// source: proto/entity/entityService.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var proto_common_amazon_pb = require('../../proto/common/amazon_pb.js');
goog.object.extend(proto, proto_common_amazon_pb);
var proto_common_campaignPlatform_pb = require('../../proto/common/campaignPlatform_pb.js');
goog.object.extend(proto, proto_common_campaignPlatform_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var proto_common_datetime_pb = require('../../proto/common/datetime_pb.js');
goog.object.extend(proto, proto_common_datetime_pb);
var proto_common_subscriptionPlan_pb = require('../../proto/common/subscriptionPlan_pb.js');
goog.object.extend(proto, proto_common_subscriptionPlan_pb);
var proto_common_utmParameters_pb = require('../../proto/common/utmParameters_pb.js');
goog.object.extend(proto, proto_common_utmParameters_pb);
var proto_entity_action_pb = require('../../proto/entity/action_pb.js');
goog.object.extend(proto, proto_entity_action_pb);
var proto_entity_anomaly_pb = require('../../proto/entity/anomaly_pb.js');
goog.object.extend(proto, proto_entity_anomaly_pb);
var proto_entity_audit_pb = require('../../proto/entity/audit_pb.js');
goog.object.extend(proto, proto_entity_audit_pb);
var proto_entity_billingAccount_pb = require('../../proto/entity/billingAccount_pb.js');
goog.object.extend(proto, proto_entity_billingAccount_pb);
var proto_entity_campaign_pb = require('../../proto/entity/campaign_pb.js');
goog.object.extend(proto, proto_entity_campaign_pb);
var proto_entity_comment_pb = require('../../proto/entity/comment_pb.js');
goog.object.extend(proto, proto_entity_comment_pb);
var proto_entity_hub_pb = require('../../proto/entity/hub_pb.js');
goog.object.extend(proto, proto_entity_hub_pb);
var proto_entity_issue_pb = require('../../proto/entity/issue_pb.js');
goog.object.extend(proto, proto_entity_issue_pb);
var proto_entity_siteManagerLink_pb = require('../../proto/entity/siteManagerLink_pb.js');
goog.object.extend(proto, proto_entity_siteManagerLink_pb);
var proto_entity_opportunity_pb = require('../../proto/entity/opportunity_pb.js');
goog.object.extend(proto, proto_entity_opportunity_pb);
var proto_entity_organization_pb = require('../../proto/entity/organization_pb.js');
goog.object.extend(proto, proto_entity_organization_pb);
var proto_entity_reporting_pb = require('../../proto/entity/reporting_pb.js');
goog.object.extend(proto, proto_entity_reporting_pb);
var proto_entity_session_pb = require('../../proto/entity/session_pb.js');
goog.object.extend(proto, proto_entity_session_pb);
var proto_entity_site_pb = require('../../proto/entity/site_pb.js');
goog.object.extend(proto, proto_entity_site_pb);
var proto_entity_siteGrouping_pb = require('../../proto/entity/siteGrouping_pb.js');
goog.object.extend(proto, proto_entity_siteGrouping_pb);
var proto_entity_user_pb = require('../../proto/entity/user_pb.js');
goog.object.extend(proto, proto_entity_user_pb);
var proto_entity_userIdentity_pb = require('../../proto/entity/userIdentity_pb.js');
goog.object.extend(proto, proto_entity_userIdentity_pb);
var proto_entity_userInvitation_pb = require('../../proto/entity/userInvitation_pb.js');
goog.object.extend(proto, proto_entity_userInvitation_pb);
goog.exportSymbol('proto.entity.ActionFilter', null, global);
goog.exportSymbol('proto.entity.ActivateShopifySubscriptionReply', null, global);
goog.exportSymbol('proto.entity.ActivateShopifySubscriptionRequest', null, global);
goog.exportSymbol('proto.entity.ApplyStripeCouponReply', null, global);
goog.exportSymbol('proto.entity.ApplyStripeCouponRequest', null, global);
goog.exportSymbol('proto.entity.CampaignFilter', null, global);
goog.exportSymbol('proto.entity.ChangeOpportunitiesStatusReply', null, global);
goog.exportSymbol('proto.entity.ChangeOpportunitiesStatusRequest', null, global);
goog.exportSymbol('proto.entity.CheckHMACReply', null, global);
goog.exportSymbol('proto.entity.CheckHMACRequest', null, global);
goog.exportSymbol('proto.entity.CheckStripeSubscriptionReply', null, global);
goog.exportSymbol('proto.entity.CheckStripeSubscriptionRequest', null, global);
goog.exportSymbol('proto.entity.CollectRelevantAmazonAccountProfileIdsReply', null, global);
goog.exportSymbol('proto.entity.CollectRelevantAmazonAccountProfileIdsRequest', null, global);
goog.exportSymbol('proto.entity.CountOpportunitiesReply', null, global);
goog.exportSymbol('proto.entity.CountOpportunitiesRequest', null, global);
goog.exportSymbol('proto.entity.CreateActionReply', null, global);
goog.exportSymbol('proto.entity.CreateActionRequest', null, global);
goog.exportSymbol('proto.entity.CreateBillingAccountReply', null, global);
goog.exportSymbol('proto.entity.CreateBillingAccountRequest', null, global);
goog.exportSymbol('proto.entity.CreateCampaignReply', null, global);
goog.exportSymbol('proto.entity.CreateCampaignRequest', null, global);
goog.exportSymbol('proto.entity.CreateInitialBillingAccountReply', null, global);
goog.exportSymbol('proto.entity.CreateInitialBillingAccountRequest', null, global);
goog.exportSymbol('proto.entity.CreateIssueReply', null, global);
goog.exportSymbol('proto.entity.CreateIssueRequest', null, global);
goog.exportSymbol('proto.entity.CreateOpportunityReply', null, global);
goog.exportSymbol('proto.entity.CreateOpportunityRequest', null, global);
goog.exportSymbol('proto.entity.CreateOpportunitySuspensionReply', null, global);
goog.exportSymbol('proto.entity.CreateOpportunitySuspensionRequest', null, global);
goog.exportSymbol('proto.entity.CreateOrganizationReply', null, global);
goog.exportSymbol('proto.entity.CreateOrganizationRequest', null, global);
goog.exportSymbol('proto.entity.CreateRobotAccountReply', null, global);
goog.exportSymbol('proto.entity.CreateRobotAccountRequest', null, global);
goog.exportSymbol('proto.entity.CreateRobotSessionReply', null, global);
goog.exportSymbol('proto.entity.CreateRobotSessionRequest', null, global);
goog.exportSymbol('proto.entity.CreateSiteGroupingReply', null, global);
goog.exportSymbol('proto.entity.CreateSiteGroupingRequest', null, global);
goog.exportSymbol('proto.entity.CreateSiteReply', null, global);
goog.exportSymbol('proto.entity.CreateSiteRequest', null, global);
goog.exportSymbol('proto.entity.CreateSiteWithUserReply', null, global);
goog.exportSymbol('proto.entity.CreateSiteWithUserRequest', null, global);
goog.exportSymbol('proto.entity.CreateStripeSubscriptionReply', null, global);
goog.exportSymbol('proto.entity.CreateStripeSubscriptionReply.RequiresAction', null, global);
goog.exportSymbol('proto.entity.CreateStripeSubscriptionRequest', null, global);
goog.exportSymbol('proto.entity.ExecuteActionReply', null, global);
goog.exportSymbol('proto.entity.ExecuteActionRequest', null, global);
goog.exportSymbol('proto.entity.ExecuteOpportunitiesReply', null, global);
goog.exportSymbol('proto.entity.ExecuteOpportunitiesRequest', null, global);
goog.exportSymbol('proto.entity.ExternalCampaign', null, global);
goog.exportSymbol('proto.entity.ExternalCampaignAccount', null, global);
goog.exportSymbol('proto.entity.FinalizeStripeInvoicingReply', null, global);
goog.exportSymbol('proto.entity.FinalizeStripeInvoicingRequest', null, global);
goog.exportSymbol('proto.entity.FindSitesByAmazonProfileIdsReply', null, global);
goog.exportSymbol('proto.entity.FindSitesByAmazonProfileIdsRequest', null, global);
goog.exportSymbol('proto.entity.FindSitesByFeatureMaskReply', null, global);
goog.exportSymbol('proto.entity.FindSitesByFeatureMaskRequest', null, global);
goog.exportSymbol('proto.entity.GetAppURLReply', null, global);
goog.exportSymbol('proto.entity.GetAppURLRequest', null, global);
goog.exportSymbol('proto.entity.GetEligibleSubscriptionPlansReply', null, global);
goog.exportSymbol('proto.entity.GetEligibleSubscriptionPlansRequest', null, global);
goog.exportSymbol('proto.entity.GetSessionInfoReply', null, global);
goog.exportSymbol('proto.entity.GetSessionInfoRequest', null, global);
goog.exportSymbol('proto.entity.HasExecutedActionsReply', null, global);
goog.exportSymbol('proto.entity.HasExecutedActionsRequest', null, global);
goog.exportSymbol('proto.entity.HasOpportunitiesReply', null, global);
goog.exportSymbol('proto.entity.HasOpportunitiesRequest', null, global);
goog.exportSymbol('proto.entity.InviteUserToSiteReply', null, global);
goog.exportSymbol('proto.entity.InviteUserToSiteRequest', null, global);
goog.exportSymbol('proto.entity.LinkClientSiteToManagerSiteReply', null, global);
goog.exportSymbol('proto.entity.LinkClientSiteToManagerSiteRequest', null, global);
goog.exportSymbol('proto.entity.ListActionsReply', null, global);
goog.exportSymbol('proto.entity.ListActionsRequest', null, global);
goog.exportSymbol('proto.entity.ListAuditEventsReply', null, global);
goog.exportSymbol('proto.entity.ListAuditEventsRequest', null, global);
goog.exportSymbol('proto.entity.ListBillingAccountsReply', null, global);
goog.exportSymbol('proto.entity.ListBillingAccountsRequest', null, global);
goog.exportSymbol('proto.entity.ListEmailRecipientsReply', null, global);
goog.exportSymbol('proto.entity.ListEmailRecipientsRequest', null, global);
goog.exportSymbol('proto.entity.ListIssueCommentsReply', null, global);
goog.exportSymbol('proto.entity.ListIssueCommentsRequest', null, global);
goog.exportSymbol('proto.entity.ListIssuesReply', null, global);
goog.exportSymbol('proto.entity.ListIssuesRequest', null, global);
goog.exportSymbol('proto.entity.ListIssuesRequest.Filters', null, global);
goog.exportSymbol('proto.entity.ListOpportunitiesReply', null, global);
goog.exportSymbol('proto.entity.ListOpportunitiesRequest', null, global);
goog.exportSymbol('proto.entity.ListOpportunitiesRequest.Filters', null, global);
goog.exportSymbol('proto.entity.ListOpportunitySuspensionsReply', null, global);
goog.exportSymbol('proto.entity.ListOpportunitySuspensionsRequest', null, global);
goog.exportSymbol('proto.entity.ListSiteGroupingsReply', null, global);
goog.exportSymbol('proto.entity.ListSiteGroupingsRequest', null, global);
goog.exportSymbol('proto.entity.ListSiteHubsReply', null, global);
goog.exportSymbol('proto.entity.ListSiteHubsRequest', null, global);
goog.exportSymbol('proto.entity.ListSiteUsersReply', null, global);
goog.exportSymbol('proto.entity.ListSiteUsersRequest', null, global);
goog.exportSymbol('proto.entity.ListSuspendedOpportunitiesReply', null, global);
goog.exportSymbol('proto.entity.ListSuspendedOpportunitiesRequest', null, global);
goog.exportSymbol('proto.entity.ListUsersReply', null, global);
goog.exportSymbol('proto.entity.ListUsersRequest', null, global);
goog.exportSymbol('proto.entity.LogInReply', null, global);
goog.exportSymbol('proto.entity.LogInRequest', null, global);
goog.exportSymbol('proto.entity.LogInRequest.Auth0', null, global);
goog.exportSymbol('proto.entity.LogInRequest.Authentication', null, global);
goog.exportSymbol('proto.entity.LogInRequest.Authentication.TypeCase', null, global);
goog.exportSymbol('proto.entity.LogInRequest.BigCommerce', null, global);
goog.exportSymbol('proto.entity.LogInRequest.BigCommerce.TypeCase', null, global);
goog.exportSymbol('proto.entity.LogInRequest.Google', null, global);
goog.exportSymbol('proto.entity.LogInRequest.Shopify', null, global);
goog.exportSymbol('proto.entity.LookupActionReply', null, global);
goog.exportSymbol('proto.entity.LookupActionRequest', null, global);
goog.exportSymbol('proto.entity.LookupBillingAccountReply', null, global);
goog.exportSymbol('proto.entity.LookupBillingAccountRequest', null, global);
goog.exportSymbol('proto.entity.LookupCampaignReply', null, global);
goog.exportSymbol('proto.entity.LookupCampaignRequest', null, global);
goog.exportSymbol('proto.entity.LookupCampaignRequest.TypeCase', null, global);
goog.exportSymbol('proto.entity.LookupIssueReply', null, global);
goog.exportSymbol('proto.entity.LookupIssueRequest', null, global);
goog.exportSymbol('proto.entity.LookupOpportunitiesReply', null, global);
goog.exportSymbol('proto.entity.LookupOpportunitiesRequest', null, global);
goog.exportSymbol('proto.entity.LookupOrganizationReply', null, global);
goog.exportSymbol('proto.entity.LookupOrganizationRequest', null, global);
goog.exportSymbol('proto.entity.LookupSessionReply', null, global);
goog.exportSymbol('proto.entity.LookupSessionRequest', null, global);
goog.exportSymbol('proto.entity.LookupSiteByBigCommerceStoreHashReply', null, global);
goog.exportSymbol('proto.entity.LookupSiteByBigCommerceStoreHashRequest', null, global);
goog.exportSymbol('proto.entity.LookupSiteByShopifyIDReply', null, global);
goog.exportSymbol('proto.entity.LookupSiteByShopifyIDRequest', null, global);
goog.exportSymbol('proto.entity.LookupSiteByShopifyShopDomainReply', null, global);
goog.exportSymbol('proto.entity.LookupSiteByShopifyShopDomainRequest', null, global);
goog.exportSymbol('proto.entity.LookupSiteGroupingReply', null, global);
goog.exportSymbol('proto.entity.LookupSiteGroupingRequest', null, global);
goog.exportSymbol('proto.entity.LookupSiteManagerLinkReply', null, global);
goog.exportSymbol('proto.entity.LookupSiteManagerLinkRequest', null, global);
goog.exportSymbol('proto.entity.LookupSiteReply', null, global);
goog.exportSymbol('proto.entity.LookupSiteRequest', null, global);
goog.exportSymbol('proto.entity.LookupSiteUserReply', null, global);
goog.exportSymbol('proto.entity.LookupSiteUserRequest', null, global);
goog.exportSymbol('proto.entity.LookupUserReply', null, global);
goog.exportSymbol('proto.entity.LookupUserRequest', null, global);
goog.exportSymbol('proto.entity.OpportunityChangeStatusSet', null, global);
goog.exportSymbol('proto.entity.OpportunityFailureSet', null, global);
goog.exportSymbol('proto.entity.OrganizationFilter', null, global);
goog.exportSymbol('proto.entity.PrepareShopifySubscriptionReply', null, global);
goog.exportSymbol('proto.entity.PrepareShopifySubscriptionRequest', null, global);
goog.exportSymbol('proto.entity.PrepareStripeInvoicingReply', null, global);
goog.exportSymbol('proto.entity.PrepareStripeInvoicingRequest', null, global);
goog.exportSymbol('proto.entity.QueryBigCommerceReply', null, global);
goog.exportSymbol('proto.entity.QueryBigCommerceRequest', null, global);
goog.exportSymbol('proto.entity.QueryCampaignsReply', null, global);
goog.exportSymbol('proto.entity.QueryCampaignsRequest', null, global);
goog.exportSymbol('proto.entity.QueryClientSitesForManagerSiteReply', null, global);
goog.exportSymbol('proto.entity.QueryClientSitesForManagerSiteRequest', null, global);
goog.exportSymbol('proto.entity.QueryManagerSitesForClientSiteReply', null, global);
goog.exportSymbol('proto.entity.QueryManagerSitesForClientSiteRequest', null, global);
goog.exportSymbol('proto.entity.QueryOrganizationsReply', null, global);
goog.exportSymbol('proto.entity.QueryOrganizationsRequest', null, global);
goog.exportSymbol('proto.entity.QueryShopifyReply', null, global);
goog.exportSymbol('proto.entity.QueryShopifyRequest', null, global);
goog.exportSymbol('proto.entity.QuerySiteManagerLinksReply', null, global);
goog.exportSymbol('proto.entity.QuerySiteManagerLinksRequest', null, global);
goog.exportSymbol('proto.entity.QuerySitesForUserReply', null, global);
goog.exportSymbol('proto.entity.QuerySitesForUserRequest', null, global);
goog.exportSymbol('proto.entity.QuerySitesReply', null, global);
goog.exportSymbol('proto.entity.QuerySitesRequest', null, global);
goog.exportSymbol('proto.entity.RefreshBillingAccountReply', null, global);
goog.exportSymbol('proto.entity.RefreshBillingAccountRequest', null, global);
goog.exportSymbol('proto.entity.SendOpportunityReportReply', null, global);
goog.exportSymbol('proto.entity.SendOpportunityReportRequest', null, global);
goog.exportSymbol('proto.entity.SessionInfo', null, global);
goog.exportSymbol('proto.entity.SessionInfo.SiteUserSite', null, global);
goog.exportSymbol('proto.entity.SignUpLinkedSiteReply', null, global);
goog.exportSymbol('proto.entity.SignUpLinkedSiteRequest', null, global);
goog.exportSymbol('proto.entity.SitesWithProfileId', null, global);
goog.exportSymbol('proto.entity.UnlinkClientSiteFromManagerSiteReply', null, global);
goog.exportSymbol('proto.entity.UnlinkClientSiteFromManagerSiteRequest', null, global);
goog.exportSymbol('proto.entity.UpdateActionReply', null, global);
goog.exportSymbol('proto.entity.UpdateActionRequest', null, global);
goog.exportSymbol('proto.entity.UpdateAnomalyReply', null, global);
goog.exportSymbol('proto.entity.UpdateAnomalyRequest', null, global);
goog.exportSymbol('proto.entity.UpdateAnomalyRequest.DetailsCase', null, global);
goog.exportSymbol('proto.entity.UpdateBillingAccountReply', null, global);
goog.exportSymbol('proto.entity.UpdateBillingAccountRequest', null, global);
goog.exportSymbol('proto.entity.UpdateCampaignReply', null, global);
goog.exportSymbol('proto.entity.UpdateCampaignRequest', null, global);
goog.exportSymbol('proto.entity.UpdateIssueReply', null, global);
goog.exportSymbol('proto.entity.UpdateIssueRequest', null, global);
goog.exportSymbol('proto.entity.UpdateOpportunitySuspensionReply', null, global);
goog.exportSymbol('proto.entity.UpdateOpportunitySuspensionRequest', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationReply', null, global);
goog.exportSymbol('proto.entity.UpdateOrganizationRequest', null, global);
goog.exportSymbol('proto.entity.UpdateSiteFeatureMaskReply', null, global);
goog.exportSymbol('proto.entity.UpdateSiteFeatureMaskRequest', null, global);
goog.exportSymbol('proto.entity.UpdateSiteGroupingReply', null, global);
goog.exportSymbol('proto.entity.UpdateSiteGroupingRequest', null, global);
goog.exportSymbol('proto.entity.UpdateSiteGroupingRequest.Action', null, global);
goog.exportSymbol('proto.entity.UpdateSiteGroupingRequest.Action.TypeCase', null, global);
goog.exportSymbol('proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition', null, global);
goog.exportSymbol('proto.entity.UpdateSiteManagerLinkReply', null, global);
goog.exportSymbol('proto.entity.UpdateSiteManagerLinkRequest', null, global);
goog.exportSymbol('proto.entity.UpdateSiteManagerLinkRequest.Action', null, global);
goog.exportSymbol('proto.entity.UpdateSiteManagerLinkRequest.Action.TypeCase', null, global);
goog.exportSymbol('proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels', null, global);
goog.exportSymbol('proto.entity.UpdateSiteReply', null, global);
goog.exportSymbol('proto.entity.UpdateSiteRequest', null, global);
goog.exportSymbol('proto.entity.UpdateSiteUserReply', null, global);
goog.exportSymbol('proto.entity.UpdateSiteUserRequest', null, global);
goog.exportSymbol('proto.entity.UpdateSiteUserRequest.Action', null, global);
goog.exportSymbol('proto.entity.UpdateSiteUserRequest.Action.TypeCase', null, global);
goog.exportSymbol('proto.entity.UpdateSiteUserRequest.ChangeSiteRole', null, global);
goog.exportSymbol('proto.entity.UpdateStripeSubscriptionReply', null, global);
goog.exportSymbol('proto.entity.UpdateStripeSubscriptionRequest', null, global);
goog.exportSymbol('proto.entity.UpdateUserReply', null, global);
goog.exportSymbol('proto.entity.UpdateUserRequest', null, global);
goog.exportSymbol('proto.entity.ValidateActionReply', null, global);
goog.exportSymbol('proto.entity.ValidateActionRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateIssueRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateIssueRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueRequest.displayName = 'proto.entity.UpdateIssueRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateIssueReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateIssueReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateIssueReply.displayName = 'proto.entity.UpdateIssueReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateIssueRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateIssueRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateIssueRequest.displayName = 'proto.entity.CreateIssueRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateIssueReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateIssueReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateIssueReply.displayName = 'proto.entity.CreateIssueReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateSiteRequest.displayName = 'proto.entity.CreateSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateSiteReply.displayName = 'proto.entity.CreateSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateSiteWithUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateSiteWithUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateSiteWithUserRequest.displayName = 'proto.entity.CreateSiteWithUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateSiteWithUserReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateSiteWithUserReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateSiteWithUserReply.displayName = 'proto.entity.CreateSiteWithUserReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SignUpLinkedSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.SignUpLinkedSiteRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.SignUpLinkedSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SignUpLinkedSiteRequest.displayName = 'proto.entity.SignUpLinkedSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SignUpLinkedSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.SignUpLinkedSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SignUpLinkedSiteReply.displayName = 'proto.entity.SignUpLinkedSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateSiteRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteRequest.displayName = 'proto.entity.UpdateSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteReply.displayName = 'proto.entity.UpdateSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QuerySitesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QuerySitesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QuerySitesRequest.displayName = 'proto.entity.QuerySitesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QuerySitesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QuerySitesReply.repeatedFields_, null);
};
goog.inherits(proto.entity.QuerySitesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QuerySitesReply.displayName = 'proto.entity.QuerySitesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QuerySitesForUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QuerySitesForUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QuerySitesForUserRequest.displayName = 'proto.entity.QuerySitesForUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QuerySitesForUserReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QuerySitesForUserReply.repeatedFields_, null);
};
goog.inherits(proto.entity.QuerySitesForUserReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QuerySitesForUserReply.displayName = 'proto.entity.QuerySitesForUserReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteRequest.displayName = 'proto.entity.LookupSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteReply.displayName = 'proto.entity.LookupSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteByShopifyIDRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteByShopifyIDRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteByShopifyIDRequest.displayName = 'proto.entity.LookupSiteByShopifyIDRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteByShopifyIDReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteByShopifyIDReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteByShopifyIDReply.displayName = 'proto.entity.LookupSiteByShopifyIDReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteByShopifyShopDomainRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteByShopifyShopDomainRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteByShopifyShopDomainRequest.displayName = 'proto.entity.LookupSiteByShopifyShopDomainRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteByShopifyShopDomainReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteByShopifyShopDomainReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteByShopifyShopDomainReply.displayName = 'proto.entity.LookupSiteByShopifyShopDomainReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteByBigCommerceStoreHashRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteByBigCommerceStoreHashRequest.displayName = 'proto.entity.LookupSiteByBigCommerceStoreHashRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteByBigCommerceStoreHashReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteByBigCommerceStoreHashReply.displayName = 'proto.entity.LookupSiteByBigCommerceStoreHashReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.FindSitesByFeatureMaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.FindSitesByFeatureMaskRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.FindSitesByFeatureMaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.FindSitesByFeatureMaskRequest.displayName = 'proto.entity.FindSitesByFeatureMaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateStripeSubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateStripeSubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateStripeSubscriptionRequest.displayName = 'proto.entity.UpdateStripeSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateStripeSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateStripeSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateStripeSubscriptionReply.displayName = 'proto.entity.UpdateStripeSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.FindSitesByFeatureMaskReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.FindSitesByFeatureMaskReply.repeatedFields_, null);
};
goog.inherits(proto.entity.FindSitesByFeatureMaskReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.FindSitesByFeatureMaskReply.displayName = 'proto.entity.FindSitesByFeatureMaskReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteFeatureMaskRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateSiteFeatureMaskRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateSiteFeatureMaskRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteFeatureMaskRequest.displayName = 'proto.entity.UpdateSiteFeatureMaskRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteFeatureMaskReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteFeatureMaskReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteFeatureMaskReply.displayName = 'proto.entity.UpdateSiteFeatureMaskReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSiteUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListSiteUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSiteUsersRequest.displayName = 'proto.entity.ListSiteUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSiteUsersReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListSiteUsersReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListSiteUsersReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSiteUsersReply.displayName = 'proto.entity.ListSiteUsersReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteUserRequest.displayName = 'proto.entity.LookupSiteUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteUserReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteUserReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteUserReply.displayName = 'proto.entity.LookupSiteUserReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteUserRequest.displayName = 'proto.entity.UpdateSiteUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteUserRequest.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.UpdateSiteUserRequest.Action.oneofGroups_);
};
goog.inherits(proto.entity.UpdateSiteUserRequest.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteUserRequest.Action.displayName = 'proto.entity.UpdateSiteUserRequest.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteUserRequest.ChangeSiteRole, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteUserRequest.ChangeSiteRole.displayName = 'proto.entity.UpdateSiteUserRequest.ChangeSiteRole';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteUserReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteUserReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteUserReply.displayName = 'proto.entity.UpdateSiteUserReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateSiteGroupingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateSiteGroupingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateSiteGroupingRequest.displayName = 'proto.entity.CreateSiteGroupingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateSiteGroupingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateSiteGroupingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateSiteGroupingReply.displayName = 'proto.entity.CreateSiteGroupingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteGroupingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteGroupingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteGroupingRequest.displayName = 'proto.entity.UpdateSiteGroupingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteGroupingRequest.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.UpdateSiteGroupingRequest.Action.oneofGroups_);
};
goog.inherits(proto.entity.UpdateSiteGroupingRequest.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteGroupingRequest.Action.displayName = 'proto.entity.UpdateSiteGroupingRequest.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.displayName = 'proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteGroupingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteGroupingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteGroupingReply.displayName = 'proto.entity.UpdateSiteGroupingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSiteGroupingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListSiteGroupingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSiteGroupingsRequest.displayName = 'proto.entity.ListSiteGroupingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSiteGroupingsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListSiteGroupingsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListSiteGroupingsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSiteGroupingsReply.displayName = 'proto.entity.ListSiteGroupingsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteGroupingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteGroupingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteGroupingRequest.displayName = 'proto.entity.LookupSiteGroupingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.RefreshBillingAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.RefreshBillingAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.RefreshBillingAccountRequest.displayName = 'proto.entity.RefreshBillingAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.RefreshBillingAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.RefreshBillingAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.RefreshBillingAccountReply.displayName = 'proto.entity.RefreshBillingAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListBillingAccountsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListBillingAccountsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListBillingAccountsRequest.displayName = 'proto.entity.ListBillingAccountsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListBillingAccountsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListBillingAccountsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListBillingAccountsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListBillingAccountsReply.displayName = 'proto.entity.ListBillingAccountsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteGroupingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteGroupingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteGroupingReply.displayName = 'proto.entity.LookupSiteGroupingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupBillingAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupBillingAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupBillingAccountRequest.displayName = 'proto.entity.LookupBillingAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupBillingAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.LookupBillingAccountReply.repeatedFields_, null);
};
goog.inherits(proto.entity.LookupBillingAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupBillingAccountReply.displayName = 'proto.entity.LookupBillingAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateBillingAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateBillingAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateBillingAccountRequest.displayName = 'proto.entity.CreateBillingAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateBillingAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateBillingAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateBillingAccountReply.displayName = 'proto.entity.CreateBillingAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateBillingAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateBillingAccountRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateBillingAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateBillingAccountRequest.displayName = 'proto.entity.UpdateBillingAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateBillingAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateBillingAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateBillingAccountReply.displayName = 'proto.entity.UpdateBillingAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateInitialBillingAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateInitialBillingAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateInitialBillingAccountRequest.displayName = 'proto.entity.CreateInitialBillingAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateInitialBillingAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateInitialBillingAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateInitialBillingAccountReply.displayName = 'proto.entity.CreateInitialBillingAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListEmailRecipientsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListEmailRecipientsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListEmailRecipientsRequest.displayName = 'proto.entity.ListEmailRecipientsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListEmailRecipientsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListEmailRecipientsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListEmailRecipientsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListEmailRecipientsReply.displayName = 'proto.entity.ListEmailRecipientsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSiteHubsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListSiteHubsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSiteHubsRequest.displayName = 'proto.entity.ListSiteHubsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSiteHubsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListSiteHubsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListSiteHubsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSiteHubsReply.displayName = 'proto.entity.ListSiteHubsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.InviteUserToSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.InviteUserToSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.InviteUserToSiteRequest.displayName = 'proto.entity.InviteUserToSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.InviteUserToSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.InviteUserToSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.InviteUserToSiteReply.displayName = 'proto.entity.InviteUserToSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListIssuesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListIssuesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListIssuesRequest.displayName = 'proto.entity.ListIssuesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListIssuesRequest.Filters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListIssuesRequest.Filters.repeatedFields_, null);
};
goog.inherits(proto.entity.ListIssuesRequest.Filters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListIssuesRequest.Filters.displayName = 'proto.entity.ListIssuesRequest.Filters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListIssuesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListIssuesReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListIssuesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListIssuesReply.displayName = 'proto.entity.ListIssuesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupIssueRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupIssueRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupIssueRequest.displayName = 'proto.entity.LookupIssueRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupIssueReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupIssueReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupIssueReply.displayName = 'proto.entity.LookupIssueReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateAnomalyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.UpdateAnomalyRequest.oneofGroups_);
};
goog.inherits(proto.entity.UpdateAnomalyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateAnomalyRequest.displayName = 'proto.entity.UpdateAnomalyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateAnomalyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateAnomalyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateAnomalyReply.displayName = 'proto.entity.UpdateAnomalyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListIssueCommentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListIssueCommentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListIssueCommentsRequest.displayName = 'proto.entity.ListIssueCommentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListIssueCommentsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListIssueCommentsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListIssueCommentsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListIssueCommentsReply.displayName = 'proto.entity.ListIssueCommentsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GetSessionInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.GetSessionInfoRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.GetSessionInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GetSessionInfoRequest.displayName = 'proto.entity.GetSessionInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GetSessionInfoReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.GetSessionInfoReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GetSessionInfoReply.displayName = 'proto.entity.GetSessionInfoReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSessionRequest.displayName = 'proto.entity.LookupSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSessionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSessionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSessionReply.displayName = 'proto.entity.LookupSessionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SessionInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.SessionInfo.repeatedFields_, null);
};
goog.inherits(proto.entity.SessionInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SessionInfo.displayName = 'proto.entity.SessionInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SessionInfo.SiteUserSite = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.SessionInfo.SiteUserSite, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SessionInfo.SiteUserSite.displayName = 'proto.entity.SessionInfo.SiteUserSite';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LogInRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LogInRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LogInRequest.displayName = 'proto.entity.LogInRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LogInRequest.Authentication = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.LogInRequest.Authentication.oneofGroups_);
};
goog.inherits(proto.entity.LogInRequest.Authentication, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LogInRequest.Authentication.displayName = 'proto.entity.LogInRequest.Authentication';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LogInRequest.Auth0 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LogInRequest.Auth0, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LogInRequest.Auth0.displayName = 'proto.entity.LogInRequest.Auth0';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LogInRequest.Shopify = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LogInRequest.Shopify, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LogInRequest.Shopify.displayName = 'proto.entity.LogInRequest.Shopify';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LogInRequest.BigCommerce = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.LogInRequest.BigCommerce.oneofGroups_);
};
goog.inherits(proto.entity.LogInRequest.BigCommerce, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LogInRequest.BigCommerce.displayName = 'proto.entity.LogInRequest.BigCommerce';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LogInRequest.Google = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LogInRequest.Google, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LogInRequest.Google.displayName = 'proto.entity.LogInRequest.Google';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LogInReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LogInReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LogInReply.displayName = 'proto.entity.LogInReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateRobotAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateRobotAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateRobotAccountRequest.displayName = 'proto.entity.CreateRobotAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateRobotAccountReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateRobotAccountReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateRobotAccountReply.displayName = 'proto.entity.CreateRobotAccountReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateRobotSessionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateRobotSessionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateRobotSessionRequest.displayName = 'proto.entity.CreateRobotSessionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateRobotSessionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateRobotSessionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateRobotSessionReply.displayName = 'proto.entity.CreateRobotSessionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GetAppURLRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.GetAppURLRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GetAppURLRequest.displayName = 'proto.entity.GetAppURLRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GetAppURLReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.GetAppURLReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GetAppURLReply.displayName = 'proto.entity.GetAppURLReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupUserRequest.displayName = 'proto.entity.LookupUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupUserReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupUserReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupUserReply.displayName = 'proto.entity.LookupUserReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListUsersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListUsersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListUsersRequest.displayName = 'proto.entity.ListUsersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListUsersReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListUsersReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListUsersReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListUsersReply.displayName = 'proto.entity.ListUsersReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateActionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateActionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateActionRequest.displayName = 'proto.entity.CreateActionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateActionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateActionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateActionReply.displayName = 'proto.entity.CreateActionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ExecuteActionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ExecuteActionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ExecuteActionRequest.displayName = 'proto.entity.ExecuteActionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ExecuteActionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ExecuteActionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ExecuteActionReply.displayName = 'proto.entity.ExecuteActionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateActionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateActionRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateActionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateActionRequest.displayName = 'proto.entity.UpdateActionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateActionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateActionReply.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateActionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateActionReply.displayName = 'proto.entity.UpdateActionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ValidateActionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ValidateActionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ValidateActionRequest.displayName = 'proto.entity.ValidateActionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ValidateActionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ValidateActionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ValidateActionReply.displayName = 'proto.entity.ValidateActionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupActionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupActionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupActionRequest.displayName = 'proto.entity.LookupActionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupActionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupActionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupActionReply.displayName = 'proto.entity.LookupActionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListActionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListActionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListActionsRequest.displayName = 'proto.entity.ListActionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListActionsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListActionsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListActionsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListActionsReply.displayName = 'proto.entity.ListActionsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ActionFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ActionFilter.repeatedFields_, null);
};
goog.inherits(proto.entity.ActionFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ActionFilter.displayName = 'proto.entity.ActionFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateOpportunityRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateOpportunityRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateOpportunityRequest.displayName = 'proto.entity.CreateOpportunityRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateOpportunityReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateOpportunityReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateOpportunityReply.displayName = 'proto.entity.CreateOpportunityReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListOpportunitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListOpportunitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.ListOpportunitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListOpportunitiesRequest.displayName = 'proto.entity.ListOpportunitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListOpportunitiesRequest.Filters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListOpportunitiesRequest.Filters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListOpportunitiesRequest.Filters.displayName = 'proto.entity.ListOpportunitiesRequest.Filters';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListOpportunitiesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListOpportunitiesReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListOpportunitiesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListOpportunitiesReply.displayName = 'proto.entity.ListOpportunitiesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HasOpportunitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.HasOpportunitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.HasOpportunitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HasOpportunitiesRequest.displayName = 'proto.entity.HasOpportunitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HasOpportunitiesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.HasOpportunitiesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HasOpportunitiesReply.displayName = 'proto.entity.HasOpportunitiesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CountOpportunitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.CountOpportunitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.CountOpportunitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CountOpportunitiesRequest.displayName = 'proto.entity.CountOpportunitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CountOpportunitiesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CountOpportunitiesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CountOpportunitiesReply.displayName = 'proto.entity.CountOpportunitiesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupOpportunitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.LookupOpportunitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.LookupOpportunitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupOpportunitiesRequest.displayName = 'proto.entity.LookupOpportunitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupOpportunitiesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.LookupOpportunitiesReply.repeatedFields_, null);
};
goog.inherits(proto.entity.LookupOpportunitiesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupOpportunitiesReply.displayName = 'proto.entity.LookupOpportunitiesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ChangeOpportunitiesStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ChangeOpportunitiesStatusRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.ChangeOpportunitiesStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ChangeOpportunitiesStatusRequest.displayName = 'proto.entity.ChangeOpportunitiesStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityChangeStatusSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityChangeStatusSet.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityChangeStatusSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityChangeStatusSet.displayName = 'proto.entity.OpportunityChangeStatusSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ChangeOpportunitiesStatusReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ChangeOpportunitiesStatusReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ChangeOpportunitiesStatusReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ChangeOpportunitiesStatusReply.displayName = 'proto.entity.ChangeOpportunitiesStatusReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OpportunityFailureSet = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OpportunityFailureSet.repeatedFields_, null);
};
goog.inherits(proto.entity.OpportunityFailureSet, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OpportunityFailureSet.displayName = 'proto.entity.OpportunityFailureSet';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ExecuteOpportunitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ExecuteOpportunitiesRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.ExecuteOpportunitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ExecuteOpportunitiesRequest.displayName = 'proto.entity.ExecuteOpportunitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ExecuteOpportunitiesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ExecuteOpportunitiesReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ExecuteOpportunitiesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ExecuteOpportunitiesReply.displayName = 'proto.entity.ExecuteOpportunitiesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateOpportunitySuspensionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateOpportunitySuspensionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateOpportunitySuspensionRequest.displayName = 'proto.entity.CreateOpportunitySuspensionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateOpportunitySuspensionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateOpportunitySuspensionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateOpportunitySuspensionReply.displayName = 'proto.entity.CreateOpportunitySuspensionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListOpportunitySuspensionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListOpportunitySuspensionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListOpportunitySuspensionsRequest.displayName = 'proto.entity.ListOpportunitySuspensionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListOpportunitySuspensionsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListOpportunitySuspensionsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListOpportunitySuspensionsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListOpportunitySuspensionsReply.displayName = 'proto.entity.ListOpportunitySuspensionsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOpportunitySuspensionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateOpportunitySuspensionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOpportunitySuspensionRequest.displayName = 'proto.entity.UpdateOpportunitySuspensionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOpportunitySuspensionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateOpportunitySuspensionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOpportunitySuspensionReply.displayName = 'proto.entity.UpdateOpportunitySuspensionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HasExecutedActionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.HasExecutedActionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HasExecutedActionsRequest.displayName = 'proto.entity.HasExecutedActionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.HasExecutedActionsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.HasExecutedActionsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.HasExecutedActionsReply.displayName = 'proto.entity.HasExecutedActionsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSuspendedOpportunitiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ListSuspendedOpportunitiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSuspendedOpportunitiesRequest.displayName = 'proto.entity.ListSuspendedOpportunitiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListSuspendedOpportunitiesReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListSuspendedOpportunitiesReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListSuspendedOpportunitiesReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListSuspendedOpportunitiesReply.displayName = 'proto.entity.ListSuspendedOpportunitiesReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateUserRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateUserRequest.displayName = 'proto.entity.UpdateUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateUserReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateUserReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateUserReply.displayName = 'proto.entity.UpdateUserReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateStripeSubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateStripeSubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateStripeSubscriptionRequest.displayName = 'proto.entity.CreateStripeSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateStripeSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateStripeSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateStripeSubscriptionReply.displayName = 'proto.entity.CreateStripeSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateStripeSubscriptionReply.RequiresAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateStripeSubscriptionReply.RequiresAction.displayName = 'proto.entity.CreateStripeSubscriptionReply.RequiresAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CheckStripeSubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CheckStripeSubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CheckStripeSubscriptionRequest.displayName = 'proto.entity.CheckStripeSubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CheckStripeSubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CheckStripeSubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CheckStripeSubscriptionReply.displayName = 'proto.entity.CheckStripeSubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.PrepareStripeInvoicingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.PrepareStripeInvoicingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.PrepareStripeInvoicingRequest.displayName = 'proto.entity.PrepareStripeInvoicingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.PrepareStripeInvoicingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.PrepareStripeInvoicingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.PrepareStripeInvoicingReply.displayName = 'proto.entity.PrepareStripeInvoicingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.FinalizeStripeInvoicingRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.FinalizeStripeInvoicingRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.FinalizeStripeInvoicingRequest.displayName = 'proto.entity.FinalizeStripeInvoicingRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.FinalizeStripeInvoicingReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.FinalizeStripeInvoicingReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.FinalizeStripeInvoicingReply.displayName = 'proto.entity.FinalizeStripeInvoicingReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ApplyStripeCouponRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ApplyStripeCouponRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ApplyStripeCouponRequest.displayName = 'proto.entity.ApplyStripeCouponRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ApplyStripeCouponReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ApplyStripeCouponReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ApplyStripeCouponReply.displayName = 'proto.entity.ApplyStripeCouponReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.PrepareShopifySubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.PrepareShopifySubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.PrepareShopifySubscriptionRequest.displayName = 'proto.entity.PrepareShopifySubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.PrepareShopifySubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.PrepareShopifySubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.PrepareShopifySubscriptionReply.displayName = 'proto.entity.PrepareShopifySubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ActivateShopifySubscriptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ActivateShopifySubscriptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ActivateShopifySubscriptionRequest.displayName = 'proto.entity.ActivateShopifySubscriptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ActivateShopifySubscriptionReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ActivateShopifySubscriptionReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ActivateShopifySubscriptionReply.displayName = 'proto.entity.ActivateShopifySubscriptionReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GetEligibleSubscriptionPlansRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.GetEligibleSubscriptionPlansRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GetEligibleSubscriptionPlansRequest.displayName = 'proto.entity.GetEligibleSubscriptionPlansRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.GetEligibleSubscriptionPlansReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.GetEligibleSubscriptionPlansReply.repeatedFields_, null);
};
goog.inherits(proto.entity.GetEligibleSubscriptionPlansReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.GetEligibleSubscriptionPlansReply.displayName = 'proto.entity.GetEligibleSubscriptionPlansReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CheckHMACRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CheckHMACRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CheckHMACRequest.displayName = 'proto.entity.CheckHMACRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CheckHMACReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CheckHMACReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CheckHMACReply.displayName = 'proto.entity.CheckHMACReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SendOpportunityReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.SendOpportunityReportRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.SendOpportunityReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SendOpportunityReportRequest.displayName = 'proto.entity.SendOpportunityReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SendOpportunityReportReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.SendOpportunityReportReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SendOpportunityReportReply.displayName = 'proto.entity.SendOpportunityReportReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryShopifyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryShopifyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryShopifyRequest.displayName = 'proto.entity.QueryShopifyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryShopifyReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryShopifyReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryShopifyReply.displayName = 'proto.entity.QueryShopifyReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryBigCommerceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryBigCommerceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryBigCommerceRequest.displayName = 'proto.entity.QueryBigCommerceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryBigCommerceReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryBigCommerceReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryBigCommerceReply.displayName = 'proto.entity.QueryBigCommerceReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateOrganizationRequest.displayName = 'proto.entity.CreateOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateOrganizationReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateOrganizationReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateOrganizationReply.displayName = 'proto.entity.CreateOrganizationReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateOrganizationRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOrganizationRequest.displayName = 'proto.entity.UpdateOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateOrganizationReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateOrganizationReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateOrganizationReply.displayName = 'proto.entity.UpdateOrganizationReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.OrganizationFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.OrganizationFilter.repeatedFields_, null);
};
goog.inherits(proto.entity.OrganizationFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.OrganizationFilter.displayName = 'proto.entity.OrganizationFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryOrganizationsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryOrganizationsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryOrganizationsRequest.displayName = 'proto.entity.QueryOrganizationsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryOrganizationsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QueryOrganizationsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.QueryOrganizationsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryOrganizationsReply.displayName = 'proto.entity.QueryOrganizationsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupOrganizationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupOrganizationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupOrganizationRequest.displayName = 'proto.entity.LookupOrganizationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupOrganizationReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupOrganizationReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupOrganizationReply.displayName = 'proto.entity.LookupOrganizationReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.CollectRelevantAmazonAccountProfileIdsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.displayName = 'proto.entity.CollectRelevantAmazonAccountProfileIdsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.CollectRelevantAmazonAccountProfileIdsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.CollectRelevantAmazonAccountProfileIdsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CollectRelevantAmazonAccountProfileIdsReply.displayName = 'proto.entity.CollectRelevantAmazonAccountProfileIdsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.FindSitesByAmazonProfileIdsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.FindSitesByAmazonProfileIdsRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.FindSitesByAmazonProfileIdsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.FindSitesByAmazonProfileIdsRequest.displayName = 'proto.entity.FindSitesByAmazonProfileIdsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.FindSitesByAmazonProfileIdsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.FindSitesByAmazonProfileIdsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.FindSitesByAmazonProfileIdsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.FindSitesByAmazonProfileIdsReply.displayName = 'proto.entity.FindSitesByAmazonProfileIdsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.SitesWithProfileId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.SitesWithProfileId.repeatedFields_, null);
};
goog.inherits(proto.entity.SitesWithProfileId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.SitesWithProfileId.displayName = 'proto.entity.SitesWithProfileId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateCampaignRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateCampaignRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateCampaignRequest.displayName = 'proto.entity.CreateCampaignRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CreateCampaignReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.CreateCampaignReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CreateCampaignReply.displayName = 'proto.entity.CreateCampaignReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateCampaignRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateCampaignRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateCampaignRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateCampaignRequest.displayName = 'proto.entity.UpdateCampaignRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateCampaignReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateCampaignReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateCampaignReply.displayName = 'proto.entity.UpdateCampaignReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ExternalCampaignAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ExternalCampaignAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ExternalCampaignAccount.displayName = 'proto.entity.ExternalCampaignAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ExternalCampaign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.ExternalCampaign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ExternalCampaign.displayName = 'proto.entity.ExternalCampaign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.CampaignFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.CampaignFilter.repeatedFields_, null);
};
goog.inherits(proto.entity.CampaignFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.CampaignFilter.displayName = 'proto.entity.CampaignFilter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryCampaignsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryCampaignsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryCampaignsRequest.displayName = 'proto.entity.QueryCampaignsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryCampaignsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QueryCampaignsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.QueryCampaignsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryCampaignsReply.displayName = 'proto.entity.QueryCampaignsReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupCampaignRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.LookupCampaignRequest.oneofGroups_);
};
goog.inherits(proto.entity.LookupCampaignRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupCampaignRequest.displayName = 'proto.entity.LookupCampaignRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupCampaignReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupCampaignReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupCampaignReply.displayName = 'proto.entity.LookupCampaignReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LinkClientSiteToManagerSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LinkClientSiteToManagerSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LinkClientSiteToManagerSiteRequest.displayName = 'proto.entity.LinkClientSiteToManagerSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LinkClientSiteToManagerSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LinkClientSiteToManagerSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LinkClientSiteToManagerSiteReply.displayName = 'proto.entity.LinkClientSiteToManagerSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UnlinkClientSiteFromManagerSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UnlinkClientSiteFromManagerSiteRequest.displayName = 'proto.entity.UnlinkClientSiteFromManagerSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UnlinkClientSiteFromManagerSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UnlinkClientSiteFromManagerSiteReply.displayName = 'proto.entity.UnlinkClientSiteFromManagerSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteManagerLinkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteManagerLinkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteManagerLinkRequest.displayName = 'proto.entity.LookupSiteManagerLinkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.LookupSiteManagerLinkReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.LookupSiteManagerLinkReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.LookupSiteManagerLinkReply.displayName = 'proto.entity.LookupSiteManagerLinkReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QuerySiteManagerLinksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QuerySiteManagerLinksRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.QuerySiteManagerLinksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QuerySiteManagerLinksRequest.displayName = 'proto.entity.QuerySiteManagerLinksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QuerySiteManagerLinksReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QuerySiteManagerLinksReply.repeatedFields_, null);
};
goog.inherits(proto.entity.QuerySiteManagerLinksReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QuerySiteManagerLinksReply.displayName = 'proto.entity.QuerySiteManagerLinksReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteManagerLinkRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteManagerLinkRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteManagerLinkRequest.displayName = 'proto.entity.UpdateSiteManagerLinkRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteManagerLinkRequest.Action = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.entity.UpdateSiteManagerLinkRequest.Action.oneofGroups_);
};
goog.inherits(proto.entity.UpdateSiteManagerLinkRequest.Action, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteManagerLinkRequest.Action.displayName = 'proto.entity.UpdateSiteManagerLinkRequest.Action';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.repeatedFields_, null);
};
goog.inherits(proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.displayName = 'proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.UpdateSiteManagerLinkReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.UpdateSiteManagerLinkReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.UpdateSiteManagerLinkReply.displayName = 'proto.entity.UpdateSiteManagerLinkReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryClientSitesForManagerSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryClientSitesForManagerSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryClientSitesForManagerSiteRequest.displayName = 'proto.entity.QueryClientSitesForManagerSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryClientSitesForManagerSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QueryClientSitesForManagerSiteReply.repeatedFields_, null);
};
goog.inherits(proto.entity.QueryClientSitesForManagerSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryClientSitesForManagerSiteReply.displayName = 'proto.entity.QueryClientSitesForManagerSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryManagerSitesForClientSiteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.QueryManagerSitesForClientSiteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryManagerSitesForClientSiteRequest.displayName = 'proto.entity.QueryManagerSitesForClientSiteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.QueryManagerSitesForClientSiteReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.QueryManagerSitesForClientSiteReply.repeatedFields_, null);
};
goog.inherits(proto.entity.QueryManagerSitesForClientSiteReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.QueryManagerSitesForClientSiteReply.displayName = 'proto.entity.QueryManagerSitesForClientSiteReply';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListAuditEventsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListAuditEventsRequest.repeatedFields_, null);
};
goog.inherits(proto.entity.ListAuditEventsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListAuditEventsRequest.displayName = 'proto.entity.ListAuditEventsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.ListAuditEventsReply = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.entity.ListAuditEventsReply.repeatedFields_, null);
};
goog.inherits(proto.entity.ListAuditEventsReply, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.ListAuditEventsReply.displayName = 'proto.entity.ListAuditEventsReply';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateIssueRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    issueId: (f = msg.getIssueId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    action: (f = msg.getAction()) && proto_entity_issue_pb.UpdateIssueAction.toObject(includeInstance, f),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_issue_pb.UpdateIssueAction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueRequest}
 */
proto.entity.UpdateIssueRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueRequest;
  return proto.entity.UpdateIssueRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueRequest}
 */
proto.entity.UpdateIssueRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setIssueId(value);
      break;
    case 3:
      var value = new proto_entity_issue_pb.UpdateIssueAction;
      reader.readMessage(value,proto_entity_issue_pb.UpdateIssueAction.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    case 4:
      var value = new proto_entity_issue_pb.UpdateIssueAction;
      reader.readMessage(value,proto_entity_issue_pb.UpdateIssueAction.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getIssueId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_entity_issue_pb.UpdateIssueAction.serializeBinaryToWriter
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto_entity_issue_pb.UpdateIssueAction.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateIssueRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateIssueRequest} returns this
*/
proto.entity.UpdateIssueRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueRequest} returns this
 */
proto.entity.UpdateIssueRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID issue_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UpdateIssueRequest.prototype.getIssueId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UpdateIssueRequest} returns this
*/
proto.entity.UpdateIssueRequest.prototype.setIssueId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueRequest} returns this
 */
proto.entity.UpdateIssueRequest.prototype.clearIssueId = function() {
  return this.setIssueId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueRequest.prototype.hasIssueId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UpdateIssueAction action = 3;
 * @return {?proto.entity.UpdateIssueAction}
 */
proto.entity.UpdateIssueRequest.prototype.getAction = function() {
  return /** @type{?proto.entity.UpdateIssueAction} */ (
    jspb.Message.getWrapperField(this, proto_entity_issue_pb.UpdateIssueAction, 3));
};


/**
 * @param {?proto.entity.UpdateIssueAction|undefined} value
 * @return {!proto.entity.UpdateIssueRequest} returns this
*/
proto.entity.UpdateIssueRequest.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueRequest} returns this
 */
proto.entity.UpdateIssueRequest.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueRequest.prototype.hasAction = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated UpdateIssueAction actions = 4;
 * @return {!Array<!proto.entity.UpdateIssueAction>}
 */
proto.entity.UpdateIssueRequest.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.UpdateIssueAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_issue_pb.UpdateIssueAction, 4));
};


/**
 * @param {!Array<!proto.entity.UpdateIssueAction>} value
 * @return {!proto.entity.UpdateIssueRequest} returns this
*/
proto.entity.UpdateIssueRequest.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.entity.UpdateIssueAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateIssueAction}
 */
proto.entity.UpdateIssueRequest.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.entity.UpdateIssueAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateIssueRequest} returns this
 */
proto.entity.UpdateIssueRequest.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateIssueReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateIssueReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateIssueReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    issue: (f = msg.getIssue()) && proto_entity_issue_pb.Issue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateIssueReply}
 */
proto.entity.UpdateIssueReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateIssueReply;
  return proto.entity.UpdateIssueReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateIssueReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateIssueReply}
 */
proto.entity.UpdateIssueReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_issue_pb.Issue;
      reader.readMessage(value,proto_entity_issue_pb.Issue.deserializeBinaryFromReader);
      msg.setIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateIssueReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateIssueReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateIssueReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateIssueReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_issue_pb.Issue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Issue issue = 1;
 * @return {?proto.entity.Issue}
 */
proto.entity.UpdateIssueReply.prototype.getIssue = function() {
  return /** @type{?proto.entity.Issue} */ (
    jspb.Message.getWrapperField(this, proto_entity_issue_pb.Issue, 1));
};


/**
 * @param {?proto.entity.Issue|undefined} value
 * @return {!proto.entity.UpdateIssueReply} returns this
*/
proto.entity.UpdateIssueReply.prototype.setIssue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateIssueReply} returns this
 */
proto.entity.UpdateIssueReply.prototype.clearIssue = function() {
  return this.setIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateIssueReply.prototype.hasIssue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateIssueRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateIssueRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateIssueRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateIssueRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newIssue: (f = msg.getNewIssue()) && proto_entity_issue_pb.NewIssue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateIssueRequest}
 */
proto.entity.CreateIssueRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateIssueRequest;
  return proto.entity.CreateIssueRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateIssueRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateIssueRequest}
 */
proto.entity.CreateIssueRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_issue_pb.NewIssue;
      reader.readMessage(value,proto_entity_issue_pb.NewIssue.deserializeBinaryFromReader);
      msg.setNewIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateIssueRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateIssueRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateIssueRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateIssueRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewIssue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_issue_pb.NewIssue.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewIssue new_issue = 1;
 * @return {?proto.entity.NewIssue}
 */
proto.entity.CreateIssueRequest.prototype.getNewIssue = function() {
  return /** @type{?proto.entity.NewIssue} */ (
    jspb.Message.getWrapperField(this, proto_entity_issue_pb.NewIssue, 1));
};


/**
 * @param {?proto.entity.NewIssue|undefined} value
 * @return {!proto.entity.CreateIssueRequest} returns this
*/
proto.entity.CreateIssueRequest.prototype.setNewIssue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateIssueRequest} returns this
 */
proto.entity.CreateIssueRequest.prototype.clearNewIssue = function() {
  return this.setNewIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateIssueRequest.prototype.hasNewIssue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateIssueReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateIssueReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateIssueReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateIssueReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    issue: (f = msg.getIssue()) && proto_entity_issue_pb.Issue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateIssueReply}
 */
proto.entity.CreateIssueReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateIssueReply;
  return proto.entity.CreateIssueReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateIssueReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateIssueReply}
 */
proto.entity.CreateIssueReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_issue_pb.Issue;
      reader.readMessage(value,proto_entity_issue_pb.Issue.deserializeBinaryFromReader);
      msg.setIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateIssueReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateIssueReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateIssueReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateIssueReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_issue_pb.Issue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Issue issue = 1;
 * @return {?proto.entity.Issue}
 */
proto.entity.CreateIssueReply.prototype.getIssue = function() {
  return /** @type{?proto.entity.Issue} */ (
    jspb.Message.getWrapperField(this, proto_entity_issue_pb.Issue, 1));
};


/**
 * @param {?proto.entity.Issue|undefined} value
 * @return {!proto.entity.CreateIssueReply} returns this
*/
proto.entity.CreateIssueReply.prototype.setIssue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateIssueReply} returns this
 */
proto.entity.CreateIssueReply.prototype.clearIssue = function() {
  return this.setIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateIssueReply.prototype.hasIssue = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newSite: (f = msg.getNewSite()) && proto_entity_site_pb.NewSite.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateSiteRequest}
 */
proto.entity.CreateSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateSiteRequest;
  return proto.entity.CreateSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateSiteRequest}
 */
proto.entity.CreateSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.NewSite;
      reader.readMessage(value,proto_entity_site_pb.NewSite.deserializeBinaryFromReader);
      msg.setNewSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.NewSite.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewSite new_site = 1;
 * @return {?proto.entity.NewSite}
 */
proto.entity.CreateSiteRequest.prototype.getNewSite = function() {
  return /** @type{?proto.entity.NewSite} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.NewSite, 1));
};


/**
 * @param {?proto.entity.NewSite|undefined} value
 * @return {!proto.entity.CreateSiteRequest} returns this
*/
proto.entity.CreateSiteRequest.prototype.setNewSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateSiteRequest} returns this
 */
proto.entity.CreateSiteRequest.prototype.clearNewSite = function() {
  return this.setNewSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateSiteRequest.prototype.hasNewSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateSiteReply}
 */
proto.entity.CreateSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateSiteReply;
  return proto.entity.CreateSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateSiteReply}
 */
proto.entity.CreateSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.CreateSiteReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.CreateSiteReply} returns this
*/
proto.entity.CreateSiteReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateSiteReply} returns this
 */
proto.entity.CreateSiteReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateSiteReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateSiteWithUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateSiteWithUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateSiteWithUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteWithUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newSite: (f = msg.getNewSite()) && proto_entity_site_pb.NewSite.toObject(includeInstance, f),
    user: (f = msg.getUser()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateSiteWithUserRequest}
 */
proto.entity.CreateSiteWithUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateSiteWithUserRequest;
  return proto.entity.CreateSiteWithUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateSiteWithUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateSiteWithUserRequest}
 */
proto.entity.CreateSiteWithUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.NewSite;
      reader.readMessage(value,proto_entity_site_pb.NewSite.deserializeBinaryFromReader);
      msg.setNewSite(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateSiteWithUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateSiteWithUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateSiteWithUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteWithUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.NewSite.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewSite new_site = 1;
 * @return {?proto.entity.NewSite}
 */
proto.entity.CreateSiteWithUserRequest.prototype.getNewSite = function() {
  return /** @type{?proto.entity.NewSite} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.NewSite, 1));
};


/**
 * @param {?proto.entity.NewSite|undefined} value
 * @return {!proto.entity.CreateSiteWithUserRequest} returns this
*/
proto.entity.CreateSiteWithUserRequest.prototype.setNewSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateSiteWithUserRequest} returns this
 */
proto.entity.CreateSiteWithUserRequest.prototype.clearNewSite = function() {
  return this.setNewSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateSiteWithUserRequest.prototype.hasNewSite = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserSelector user = 2;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.CreateSiteWithUserRequest.prototype.getUser = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 2));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.CreateSiteWithUserRequest} returns this
*/
proto.entity.CreateSiteWithUserRequest.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateSiteWithUserRequest} returns this
 */
proto.entity.CreateSiteWithUserRequest.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateSiteWithUserRequest.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateSiteWithUserReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateSiteWithUserReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateSiteWithUserReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteWithUserReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateSiteWithUserReply}
 */
proto.entity.CreateSiteWithUserReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateSiteWithUserReply;
  return proto.entity.CreateSiteWithUserReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateSiteWithUserReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateSiteWithUserReply}
 */
proto.entity.CreateSiteWithUserReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateSiteWithUserReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateSiteWithUserReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateSiteWithUserReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteWithUserReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.CreateSiteWithUserReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.CreateSiteWithUserReply} returns this
*/
proto.entity.CreateSiteWithUserReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateSiteWithUserReply} returns this
 */
proto.entity.CreateSiteWithUserReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateSiteWithUserReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.SignUpLinkedSiteRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SignUpLinkedSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SignUpLinkedSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SignUpLinkedSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    linkRequest: (f = msg.getLinkRequest()) && proto.entity.LinkClientSiteToManagerSiteRequest.toObject(includeInstance, f),
    newSite: (f = msg.getNewSite()) && proto_entity_site_pb.NewSite.toObject(includeInstance, f),
    additionalUserInvitationsList: jspb.Message.toObjectList(msg.getAdditionalUserInvitationsList(),
    proto.entity.InviteUserToSiteRequest.toObject, includeInstance),
    owningAdminEmail: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SignUpLinkedSiteRequest}
 */
proto.entity.SignUpLinkedSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SignUpLinkedSiteRequest;
  return proto.entity.SignUpLinkedSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SignUpLinkedSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SignUpLinkedSiteRequest}
 */
proto.entity.SignUpLinkedSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.LinkClientSiteToManagerSiteRequest;
      reader.readMessage(value,proto.entity.LinkClientSiteToManagerSiteRequest.deserializeBinaryFromReader);
      msg.setLinkRequest(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.NewSite;
      reader.readMessage(value,proto_entity_site_pb.NewSite.deserializeBinaryFromReader);
      msg.setNewSite(value);
      break;
    case 3:
      var value = new proto.entity.InviteUserToSiteRequest;
      reader.readMessage(value,proto.entity.InviteUserToSiteRequest.deserializeBinaryFromReader);
      msg.addAdditionalUserInvitations(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwningAdminEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SignUpLinkedSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SignUpLinkedSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SignUpLinkedSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinkRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.LinkClientSiteToManagerSiteRequest.serializeBinaryToWriter
    );
  }
  f = message.getNewSite();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_site_pb.NewSite.serializeBinaryToWriter
    );
  }
  f = message.getAdditionalUserInvitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.entity.InviteUserToSiteRequest.serializeBinaryToWriter
    );
  }
  f = message.getOwningAdminEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional LinkClientSiteToManagerSiteRequest link_request = 1;
 * @return {?proto.entity.LinkClientSiteToManagerSiteRequest}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.getLinkRequest = function() {
  return /** @type{?proto.entity.LinkClientSiteToManagerSiteRequest} */ (
    jspb.Message.getWrapperField(this, proto.entity.LinkClientSiteToManagerSiteRequest, 1));
};


/**
 * @param {?proto.entity.LinkClientSiteToManagerSiteRequest|undefined} value
 * @return {!proto.entity.SignUpLinkedSiteRequest} returns this
*/
proto.entity.SignUpLinkedSiteRequest.prototype.setLinkRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SignUpLinkedSiteRequest} returns this
 */
proto.entity.SignUpLinkedSiteRequest.prototype.clearLinkRequest = function() {
  return this.setLinkRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.hasLinkRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NewSite new_site = 2;
 * @return {?proto.entity.NewSite}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.getNewSite = function() {
  return /** @type{?proto.entity.NewSite} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.NewSite, 2));
};


/**
 * @param {?proto.entity.NewSite|undefined} value
 * @return {!proto.entity.SignUpLinkedSiteRequest} returns this
*/
proto.entity.SignUpLinkedSiteRequest.prototype.setNewSite = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SignUpLinkedSiteRequest} returns this
 */
proto.entity.SignUpLinkedSiteRequest.prototype.clearNewSite = function() {
  return this.setNewSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.hasNewSite = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated InviteUserToSiteRequest additional_user_invitations = 3;
 * @return {!Array<!proto.entity.InviteUserToSiteRequest>}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.getAdditionalUserInvitationsList = function() {
  return /** @type{!Array<!proto.entity.InviteUserToSiteRequest>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.InviteUserToSiteRequest, 3));
};


/**
 * @param {!Array<!proto.entity.InviteUserToSiteRequest>} value
 * @return {!proto.entity.SignUpLinkedSiteRequest} returns this
*/
proto.entity.SignUpLinkedSiteRequest.prototype.setAdditionalUserInvitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.InviteUserToSiteRequest=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.InviteUserToSiteRequest}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.addAdditionalUserInvitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.InviteUserToSiteRequest, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SignUpLinkedSiteRequest} returns this
 */
proto.entity.SignUpLinkedSiteRequest.prototype.clearAdditionalUserInvitationsList = function() {
  return this.setAdditionalUserInvitationsList([]);
};


/**
 * optional string owning_admin_email = 4;
 * @return {string}
 */
proto.entity.SignUpLinkedSiteRequest.prototype.getOwningAdminEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.SignUpLinkedSiteRequest} returns this
 */
proto.entity.SignUpLinkedSiteRequest.prototype.setOwningAdminEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SignUpLinkedSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SignUpLinkedSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SignUpLinkedSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SignUpLinkedSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SignUpLinkedSiteReply}
 */
proto.entity.SignUpLinkedSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SignUpLinkedSiteReply;
  return proto.entity.SignUpLinkedSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SignUpLinkedSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SignUpLinkedSiteReply}
 */
proto.entity.SignUpLinkedSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SignUpLinkedSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SignUpLinkedSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SignUpLinkedSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SignUpLinkedSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.SignUpLinkedSiteReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.SignUpLinkedSiteReply} returns this
*/
proto.entity.SignUpLinkedSiteReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SignUpLinkedSiteReply} returns this
 */
proto.entity.SignUpLinkedSiteReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SignUpLinkedSiteReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateSiteRequest.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_site_pb.UpdateSiteAction.toObject, includeInstance),
    ifVersion: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteRequest}
 */
proto.entity.UpdateSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteRequest;
  return proto.entity.UpdateSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteRequest}
 */
proto.entity.UpdateSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 4:
      var value = new proto_entity_site_pb.UpdateSiteAction;
      reader.readMessage(value,proto_entity_site_pb.UpdateSiteAction.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIfVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto_entity_site_pb.UpdateSiteAction.serializeBinaryToWriter
    );
  }
  f = message.getIfVersion();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateSiteRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateSiteRequest} returns this
*/
proto.entity.UpdateSiteRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteRequest} returns this
 */
proto.entity.UpdateSiteRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UpdateSiteAction actions = 4;
 * @return {!Array<!proto.entity.UpdateSiteAction>}
 */
proto.entity.UpdateSiteRequest.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.UpdateSiteAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_site_pb.UpdateSiteAction, 4));
};


/**
 * @param {!Array<!proto.entity.UpdateSiteAction>} value
 * @return {!proto.entity.UpdateSiteRequest} returns this
*/
proto.entity.UpdateSiteRequest.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.entity.UpdateSiteAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateSiteAction}
 */
proto.entity.UpdateSiteRequest.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.entity.UpdateSiteAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateSiteRequest} returns this
 */
proto.entity.UpdateSiteRequest.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};


/**
 * optional int64 if_version = 5;
 * @return {number}
 */
proto.entity.UpdateSiteRequest.prototype.getIfVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.UpdateSiteRequest} returns this
 */
proto.entity.UpdateSiteRequest.prototype.setIfVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteReply}
 */
proto.entity.UpdateSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteReply;
  return proto.entity.UpdateSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteReply}
 */
proto.entity.UpdateSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.UpdateSiteReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.UpdateSiteReply} returns this
*/
proto.entity.UpdateSiteReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteReply} returns this
 */
proto.entity.UpdateSiteReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QuerySitesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QuerySitesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QuerySitesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QuerySitesRequest}
 */
proto.entity.QuerySitesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QuerySitesRequest;
  return proto.entity.QuerySitesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QuerySitesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QuerySitesRequest}
 */
proto.entity.QuerySitesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QuerySitesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QuerySitesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QuerySitesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QuerySitesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QuerySitesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QuerySitesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QuerySitesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    sitesList: jspb.Message.toObjectList(msg.getSitesList(),
    proto_entity_site_pb.Site.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QuerySitesReply}
 */
proto.entity.QuerySitesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QuerySitesReply;
  return proto.entity.QuerySitesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QuerySitesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QuerySitesReply}
 */
proto.entity.QuerySitesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.addSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QuerySitesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QuerySitesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QuerySitesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Site sites = 1;
 * @return {!Array<!proto.entity.Site>}
 */
proto.entity.QuerySitesReply.prototype.getSitesList = function() {
  return /** @type{!Array<!proto.entity.Site>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {!Array<!proto.entity.Site>} value
 * @return {!proto.entity.QuerySitesReply} returns this
*/
proto.entity.QuerySitesReply.prototype.setSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Site=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Site}
 */
proto.entity.QuerySitesReply.prototype.addSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Site, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QuerySitesReply} returns this
 */
proto.entity.QuerySitesReply.prototype.clearSitesList = function() {
  return this.setSitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QuerySitesForUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QuerySitesForUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QuerySitesForUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesForUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userSelector: (f = msg.getUserSelector()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f),
    maybeAddUserSite: (f = msg.getMaybeAddUserSite()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QuerySitesForUserRequest}
 */
proto.entity.QuerySitesForUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QuerySitesForUserRequest;
  return proto.entity.QuerySitesForUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QuerySitesForUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QuerySitesForUserRequest}
 */
proto.entity.QuerySitesForUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setUserSelector(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setMaybeAddUserSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QuerySitesForUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QuerySitesForUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QuerySitesForUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesForUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
  f = message.getMaybeAddUserSite();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserSelector user_selector = 1;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.QuerySitesForUserRequest.prototype.getUserSelector = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 1));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.QuerySitesForUserRequest} returns this
*/
proto.entity.QuerySitesForUserRequest.prototype.setUserSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QuerySitesForUserRequest} returns this
 */
proto.entity.QuerySitesForUserRequest.prototype.clearUserSelector = function() {
  return this.setUserSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QuerySitesForUserRequest.prototype.hasUserSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SiteSelector maybe_add_user_site = 2;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.QuerySitesForUserRequest.prototype.getMaybeAddUserSite = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 2));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.QuerySitesForUserRequest} returns this
*/
proto.entity.QuerySitesForUserRequest.prototype.setMaybeAddUserSite = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QuerySitesForUserRequest} returns this
 */
proto.entity.QuerySitesForUserRequest.prototype.clearMaybeAddUserSite = function() {
  return this.setMaybeAddUserSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QuerySitesForUserRequest.prototype.hasMaybeAddUserSite = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QuerySitesForUserReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QuerySitesForUserReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QuerySitesForUserReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QuerySitesForUserReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesForUserReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteUserSitesList: jspb.Message.toObjectList(msg.getSiteUserSitesList(),
    proto.entity.SessionInfo.SiteUserSite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QuerySitesForUserReply}
 */
proto.entity.QuerySitesForUserReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QuerySitesForUserReply;
  return proto.entity.QuerySitesForUserReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QuerySitesForUserReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QuerySitesForUserReply}
 */
proto.entity.QuerySitesForUserReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.SessionInfo.SiteUserSite;
      reader.readMessage(value,proto.entity.SessionInfo.SiteUserSite.deserializeBinaryFromReader);
      msg.addSiteUserSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QuerySitesForUserReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QuerySitesForUserReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QuerySitesForUserReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySitesForUserReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteUserSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.entity.SessionInfo.SiteUserSite.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SessionInfo.SiteUserSite site_user_sites = 1;
 * @return {!Array<!proto.entity.SessionInfo.SiteUserSite>}
 */
proto.entity.QuerySitesForUserReply.prototype.getSiteUserSitesList = function() {
  return /** @type{!Array<!proto.entity.SessionInfo.SiteUserSite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.SessionInfo.SiteUserSite, 1));
};


/**
 * @param {!Array<!proto.entity.SessionInfo.SiteUserSite>} value
 * @return {!proto.entity.QuerySitesForUserReply} returns this
*/
proto.entity.QuerySitesForUserReply.prototype.setSiteUserSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SessionInfo.SiteUserSite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SessionInfo.SiteUserSite}
 */
proto.entity.QuerySitesForUserReply.prototype.addSiteUserSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SessionInfo.SiteUserSite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QuerySitesForUserReply} returns this
 */
proto.entity.QuerySitesForUserReply.prototype.clearSiteUserSitesList = function() {
  return this.setSiteUserSitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteRequest}
 */
proto.entity.LookupSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteRequest;
  return proto.entity.LookupSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteRequest}
 */
proto.entity.LookupSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupSiteRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupSiteRequest} returns this
*/
proto.entity.LookupSiteRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteRequest} returns this
 */
proto.entity.LookupSiteRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteReply}
 */
proto.entity.LookupSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteReply;
  return proto.entity.LookupSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteReply}
 */
proto.entity.LookupSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.LookupSiteReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.LookupSiteReply} returns this
*/
proto.entity.LookupSiteReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteReply} returns this
 */
proto.entity.LookupSiteReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteByShopifyIDRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteByShopifyIDRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteByShopifyIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyIDRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    shopId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteByShopifyIDRequest}
 */
proto.entity.LookupSiteByShopifyIDRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteByShopifyIDRequest;
  return proto.entity.LookupSiteByShopifyIDRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteByShopifyIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteByShopifyIDRequest}
 */
proto.entity.LookupSiteByShopifyIDRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setShopId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteByShopifyIDRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteByShopifyIDRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteByShopifyIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyIDRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopId();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
};


/**
 * optional uint64 shop_id = 1;
 * @return {number}
 */
proto.entity.LookupSiteByShopifyIDRequest.prototype.getShopId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.LookupSiteByShopifyIDRequest} returns this
 */
proto.entity.LookupSiteByShopifyIDRequest.prototype.setShopId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteByShopifyIDReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteByShopifyIDReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteByShopifyIDReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyIDReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteByShopifyIDReply}
 */
proto.entity.LookupSiteByShopifyIDReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteByShopifyIDReply;
  return proto.entity.LookupSiteByShopifyIDReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteByShopifyIDReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteByShopifyIDReply}
 */
proto.entity.LookupSiteByShopifyIDReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteByShopifyIDReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteByShopifyIDReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteByShopifyIDReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyIDReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.LookupSiteByShopifyIDReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.LookupSiteByShopifyIDReply} returns this
*/
proto.entity.LookupSiteByShopifyIDReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteByShopifyIDReply} returns this
 */
proto.entity.LookupSiteByShopifyIDReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteByShopifyIDReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteByShopifyShopDomainRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteByShopifyShopDomainRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    shopDomain: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteByShopifyShopDomainRequest}
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteByShopifyShopDomainRequest;
  return proto.entity.LookupSiteByShopifyShopDomainRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteByShopifyShopDomainRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteByShopifyShopDomainRequest}
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopDomain(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteByShopifyShopDomainRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteByShopifyShopDomainRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopDomain();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string shop_domain = 1;
 * @return {string}
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.prototype.getShopDomain = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LookupSiteByShopifyShopDomainRequest} returns this
 */
proto.entity.LookupSiteByShopifyShopDomainRequest.prototype.setShopDomain = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteByShopifyShopDomainReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteByShopifyShopDomainReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteByShopifyShopDomainReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyShopDomainReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteByShopifyShopDomainReply}
 */
proto.entity.LookupSiteByShopifyShopDomainReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteByShopifyShopDomainReply;
  return proto.entity.LookupSiteByShopifyShopDomainReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteByShopifyShopDomainReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteByShopifyShopDomainReply}
 */
proto.entity.LookupSiteByShopifyShopDomainReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteByShopifyShopDomainReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteByShopifyShopDomainReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteByShopifyShopDomainReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByShopifyShopDomainReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.LookupSiteByShopifyShopDomainReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.LookupSiteByShopifyShopDomainReply} returns this
*/
proto.entity.LookupSiteByShopifyShopDomainReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteByShopifyShopDomainReply} returns this
 */
proto.entity.LookupSiteByShopifyShopDomainReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteByShopifyShopDomainReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteByBigCommerceStoreHashRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteByBigCommerceStoreHashRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    storeHash: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteByBigCommerceStoreHashRequest}
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteByBigCommerceStoreHashRequest;
  return proto.entity.LookupSiteByBigCommerceStoreHashRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteByBigCommerceStoreHashRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteByBigCommerceStoreHashRequest}
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteByBigCommerceStoreHashRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteByBigCommerceStoreHashRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoreHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string store_hash = 1;
 * @return {string}
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.prototype.getStoreHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LookupSiteByBigCommerceStoreHashRequest} returns this
 */
proto.entity.LookupSiteByBigCommerceStoreHashRequest.prototype.setStoreHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteByBigCommerceStoreHashReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteByBigCommerceStoreHashReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteByBigCommerceStoreHashReply}
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteByBigCommerceStoreHashReply;
  return proto.entity.LookupSiteByBigCommerceStoreHashReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteByBigCommerceStoreHashReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteByBigCommerceStoreHashReply}
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteByBigCommerceStoreHashReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteByBigCommerceStoreHashReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.LookupSiteByBigCommerceStoreHashReply} returns this
*/
proto.entity.LookupSiteByBigCommerceStoreHashReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteByBigCommerceStoreHashReply} returns this
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteByBigCommerceStoreHashReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.FindSitesByFeatureMaskRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.FindSitesByFeatureMaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.FindSitesByFeatureMaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByFeatureMaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    withFeaturesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    withoutFeaturesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.FindSitesByFeatureMaskRequest}
 */
proto.entity.FindSitesByFeatureMaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.FindSitesByFeatureMaskRequest;
  return proto.entity.FindSitesByFeatureMaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.FindSitesByFeatureMaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.FindSitesByFeatureMaskRequest}
 */
proto.entity.FindSitesByFeatureMaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addWithFeatures(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addWithoutFeatures(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.FindSitesByFeatureMaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.FindSitesByFeatureMaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByFeatureMaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWithFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getWithoutFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string with_features = 1;
 * @return {!Array<string>}
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.getWithFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.FindSitesByFeatureMaskRequest} returns this
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.setWithFeaturesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.FindSitesByFeatureMaskRequest} returns this
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.addWithFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.FindSitesByFeatureMaskRequest} returns this
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.clearWithFeaturesList = function() {
  return this.setWithFeaturesList([]);
};


/**
 * repeated string without_features = 2;
 * @return {!Array<string>}
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.getWithoutFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.FindSitesByFeatureMaskRequest} returns this
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.setWithoutFeaturesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.FindSitesByFeatureMaskRequest} returns this
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.addWithoutFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.FindSitesByFeatureMaskRequest} returns this
 */
proto.entity.FindSitesByFeatureMaskRequest.prototype.clearWithoutFeaturesList = function() {
  return this.setWithoutFeaturesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateStripeSubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateStripeSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateStripeSubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    planId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    prorationDate: (f = msg.getProrationDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateStripeSubscriptionRequest}
 */
proto.entity.UpdateStripeSubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateStripeSubscriptionRequest;
  return proto.entity.UpdateStripeSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateStripeSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateStripeSubscriptionRequest}
 */
proto.entity.UpdateStripeSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setProrationDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateStripeSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateStripeSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateStripeSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlanId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getProrationDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateStripeSubscriptionRequest} returns this
*/
proto.entity.UpdateStripeSubscriptionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateStripeSubscriptionRequest} returns this
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateStripeSubscriptionRequest} returns this
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string plan_id = 3;
 * @return {string}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.getPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateStripeSubscriptionRequest} returns this
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.setPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp proration_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.getProrationDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.UpdateStripeSubscriptionRequest} returns this
*/
proto.entity.UpdateStripeSubscriptionRequest.prototype.setProrationDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateStripeSubscriptionRequest} returns this
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.clearProrationDate = function() {
  return this.setProrationDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateStripeSubscriptionRequest.prototype.hasProrationDate = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateStripeSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateStripeSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateStripeSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    planId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    billingMethodId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    clientSecret: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateStripeSubscriptionReply}
 */
proto.entity.UpdateStripeSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateStripeSubscriptionReply;
  return proto.entity.UpdateStripeSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateStripeSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateStripeSubscriptionReply}
 */
proto.entity.UpdateStripeSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillingMethodId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateStripeSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateStripeSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateStripeSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlanId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBillingMethodId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string subscription_id = 1;
 * @return {string}
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateStripeSubscriptionReply} returns this
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string plan_id = 2;
 * @return {string}
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.getPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateStripeSubscriptionReply} returns this
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.setPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string billing_method_id = 3;
 * @return {string}
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.getBillingMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateStripeSubscriptionReply} returns this
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.setBillingMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string client_secret = 4;
 * @return {string}
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateStripeSubscriptionReply} returns this
 */
proto.entity.UpdateStripeSubscriptionReply.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.FindSitesByFeatureMaskReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.FindSitesByFeatureMaskReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.FindSitesByFeatureMaskReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.FindSitesByFeatureMaskReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByFeatureMaskReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    sitesList: jspb.Message.toObjectList(msg.getSitesList(),
    proto_entity_site_pb.Site.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.FindSitesByFeatureMaskReply}
 */
proto.entity.FindSitesByFeatureMaskReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.FindSitesByFeatureMaskReply;
  return proto.entity.FindSitesByFeatureMaskReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.FindSitesByFeatureMaskReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.FindSitesByFeatureMaskReply}
 */
proto.entity.FindSitesByFeatureMaskReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.addSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.FindSitesByFeatureMaskReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.FindSitesByFeatureMaskReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.FindSitesByFeatureMaskReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByFeatureMaskReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Site sites = 1;
 * @return {!Array<!proto.entity.Site>}
 */
proto.entity.FindSitesByFeatureMaskReply.prototype.getSitesList = function() {
  return /** @type{!Array<!proto.entity.Site>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {!Array<!proto.entity.Site>} value
 * @return {!proto.entity.FindSitesByFeatureMaskReply} returns this
*/
proto.entity.FindSitesByFeatureMaskReply.prototype.setSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Site=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Site}
 */
proto.entity.FindSitesByFeatureMaskReply.prototype.addSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Site, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.FindSitesByFeatureMaskReply} returns this
 */
proto.entity.FindSitesByFeatureMaskReply.prototype.clearSitesList = function() {
  return this.setSitesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateSiteFeatureMaskRequest.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteFeatureMaskRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteFeatureMaskRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteFeatureMaskRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    addFeaturesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    removeFeaturesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest}
 */
proto.entity.UpdateSiteFeatureMaskRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteFeatureMaskRequest;
  return proto.entity.UpdateSiteFeatureMaskRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteFeatureMaskRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest}
 */
proto.entity.UpdateSiteFeatureMaskRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddFeatures(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addRemoveFeatures(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteFeatureMaskRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteFeatureMaskRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteFeatureMaskRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getAddFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getRemoveFeaturesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
*/
proto.entity.UpdateSiteFeatureMaskRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string add_features = 2;
 * @return {!Array<string>}
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.getAddFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.setAddFeaturesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.addAddFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.clearAddFeaturesList = function() {
  return this.setAddFeaturesList([]);
};


/**
 * repeated string remove_features = 3;
 * @return {!Array<string>}
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.getRemoveFeaturesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.setRemoveFeaturesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.addRemoveFeatures = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateSiteFeatureMaskRequest} returns this
 */
proto.entity.UpdateSiteFeatureMaskRequest.prototype.clearRemoveFeaturesList = function() {
  return this.setRemoveFeaturesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteFeatureMaskReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteFeatureMaskReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteFeatureMaskReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteFeatureMaskReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteFeatureMaskReply}
 */
proto.entity.UpdateSiteFeatureMaskReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteFeatureMaskReply;
  return proto.entity.UpdateSiteFeatureMaskReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteFeatureMaskReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteFeatureMaskReply}
 */
proto.entity.UpdateSiteFeatureMaskReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteFeatureMaskReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteFeatureMaskReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteFeatureMaskReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteFeatureMaskReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.UpdateSiteFeatureMaskReply.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.UpdateSiteFeatureMaskReply} returns this
*/
proto.entity.UpdateSiteFeatureMaskReply.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteFeatureMaskReply} returns this
 */
proto.entity.UpdateSiteFeatureMaskReply.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteFeatureMaskReply.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSiteUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSiteUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSiteUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSiteUsersRequest}
 */
proto.entity.ListSiteUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSiteUsersRequest;
  return proto.entity.ListSiteUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSiteUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSiteUsersRequest}
 */
proto.entity.ListSiteUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSiteUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSiteUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSiteUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListSiteUsersRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListSiteUsersRequest} returns this
*/
proto.entity.ListSiteUsersRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListSiteUsersRequest} returns this
 */
proto.entity.ListSiteUsersRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListSiteUsersRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListSiteUsersReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSiteUsersReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSiteUsersReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSiteUsersReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteUsersReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteUsersList: jspb.Message.toObjectList(msg.getSiteUsersList(),
    proto_entity_user_pb.SiteUser.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSiteUsersReply}
 */
proto.entity.ListSiteUsersReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSiteUsersReply;
  return proto.entity.ListSiteUsersReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSiteUsersReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSiteUsersReply}
 */
proto.entity.ListSiteUsersReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.SiteUser;
      reader.readMessage(value,proto_entity_user_pb.SiteUser.deserializeBinaryFromReader);
      msg.addSiteUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSiteUsersReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSiteUsersReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSiteUsersReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteUsersReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_user_pb.SiteUser.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SiteUser site_users = 1;
 * @return {!Array<!proto.entity.SiteUser>}
 */
proto.entity.ListSiteUsersReply.prototype.getSiteUsersList = function() {
  return /** @type{!Array<!proto.entity.SiteUser>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_user_pb.SiteUser, 1));
};


/**
 * @param {!Array<!proto.entity.SiteUser>} value
 * @return {!proto.entity.ListSiteUsersReply} returns this
*/
proto.entity.ListSiteUsersReply.prototype.setSiteUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SiteUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteUser}
 */
proto.entity.ListSiteUsersReply.prototype.addSiteUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SiteUser, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListSiteUsersReply} returns this
 */
proto.entity.ListSiteUsersReply.prototype.clearSiteUsersList = function() {
  return this.setSiteUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    userSelector: (f = msg.getUserSelector()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteUserRequest}
 */
proto.entity.LookupSiteUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteUserRequest;
  return proto.entity.LookupSiteUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteUserRequest}
 */
proto.entity.LookupSiteUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setUserSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getUserSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupSiteUserRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupSiteUserRequest} returns this
*/
proto.entity.LookupSiteUserRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteUserRequest} returns this
 */
proto.entity.LookupSiteUserRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteUserRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserSelector user_selector = 2;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.LookupSiteUserRequest.prototype.getUserSelector = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 2));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.LookupSiteUserRequest} returns this
*/
proto.entity.LookupSiteUserRequest.prototype.setUserSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteUserRequest} returns this
 */
proto.entity.LookupSiteUserRequest.prototype.clearUserSelector = function() {
  return this.setUserSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteUserRequest.prototype.hasUserSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteUserReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteUserReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteUserReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteUserReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteUser: (f = msg.getSiteUser()) && proto_entity_user_pb.SiteUser.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteUserReply}
 */
proto.entity.LookupSiteUserReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteUserReply;
  return proto.entity.LookupSiteUserReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteUserReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteUserReply}
 */
proto.entity.LookupSiteUserReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.SiteUser;
      reader.readMessage(value,proto_entity_user_pb.SiteUser.deserializeBinaryFromReader);
      msg.setSiteUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteUserReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteUserReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteUserReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteUserReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.SiteUser.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteUser site_user = 1;
 * @return {?proto.entity.SiteUser}
 */
proto.entity.LookupSiteUserReply.prototype.getSiteUser = function() {
  return /** @type{?proto.entity.SiteUser} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.SiteUser, 1));
};


/**
 * @param {?proto.entity.SiteUser|undefined} value
 * @return {!proto.entity.LookupSiteUserReply} returns this
*/
proto.entity.LookupSiteUserReply.prototype.setSiteUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteUserReply} returns this
 */
proto.entity.LookupSiteUserReply.prototype.clearSiteUser = function() {
  return this.setSiteUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteUserReply.prototype.hasSiteUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    userSelector: (f = msg.getUserSelector()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f),
    action: (f = msg.getAction()) && proto.entity.UpdateSiteUserRequest.Action.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteUserRequest}
 */
proto.entity.UpdateSiteUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteUserRequest;
  return proto.entity.UpdateSiteUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteUserRequest}
 */
proto.entity.UpdateSiteUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setUserSelector(value);
      break;
    case 3:
      var value = new proto.entity.UpdateSiteUserRequest.Action;
      reader.readMessage(value,proto.entity.UpdateSiteUserRequest.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getUserSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.UpdateSiteUserRequest.Action.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.UpdateSiteUserRequest.Action.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.entity.UpdateSiteUserRequest.Action.TypeCase = {
  TYPE_NOT_SET: 0,
  CHANGE_SITE_ROLE: 1
};

/**
 * @return {proto.entity.UpdateSiteUserRequest.Action.TypeCase}
 */
proto.entity.UpdateSiteUserRequest.Action.prototype.getTypeCase = function() {
  return /** @type {proto.entity.UpdateSiteUserRequest.Action.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.UpdateSiteUserRequest.Action.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteUserRequest.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteUserRequest.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteUserRequest.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserRequest.Action.toObject = function(includeInstance, msg) {
  var f, obj = {
    changeSiteRole: (f = msg.getChangeSiteRole()) && proto.entity.UpdateSiteUserRequest.ChangeSiteRole.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteUserRequest.Action}
 */
proto.entity.UpdateSiteUserRequest.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteUserRequest.Action;
  return proto.entity.UpdateSiteUserRequest.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteUserRequest.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteUserRequest.Action}
 */
proto.entity.UpdateSiteUserRequest.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.UpdateSiteUserRequest.ChangeSiteRole;
      reader.readMessage(value,proto.entity.UpdateSiteUserRequest.ChangeSiteRole.deserializeBinaryFromReader);
      msg.setChangeSiteRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteUserRequest.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteUserRequest.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteUserRequest.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserRequest.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChangeSiteRole();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.UpdateSiteUserRequest.ChangeSiteRole.serializeBinaryToWriter
    );
  }
};


/**
 * optional ChangeSiteRole change_site_role = 1;
 * @return {?proto.entity.UpdateSiteUserRequest.ChangeSiteRole}
 */
proto.entity.UpdateSiteUserRequest.Action.prototype.getChangeSiteRole = function() {
  return /** @type{?proto.entity.UpdateSiteUserRequest.ChangeSiteRole} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateSiteUserRequest.ChangeSiteRole, 1));
};


/**
 * @param {?proto.entity.UpdateSiteUserRequest.ChangeSiteRole|undefined} value
 * @return {!proto.entity.UpdateSiteUserRequest.Action} returns this
*/
proto.entity.UpdateSiteUserRequest.Action.prototype.setChangeSiteRole = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.UpdateSiteUserRequest.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteUserRequest.Action} returns this
 */
proto.entity.UpdateSiteUserRequest.Action.prototype.clearChangeSiteRole = function() {
  return this.setChangeSiteRole(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteUserRequest.Action.prototype.hasChangeSiteRole = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteUserRequest.ChangeSiteRole.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteUserRequest.ChangeSiteRole} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.toObject = function(includeInstance, msg) {
  var f, obj = {
    newSiteRole: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteUserRequest.ChangeSiteRole}
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteUserRequest.ChangeSiteRole;
  return proto.entity.UpdateSiteUserRequest.ChangeSiteRole.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteUserRequest.ChangeSiteRole} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteUserRequest.ChangeSiteRole}
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.entity.SiteRole.Option} */ (reader.readEnum());
      msg.setNewSiteRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteUserRequest.ChangeSiteRole.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteUserRequest.ChangeSiteRole} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewSiteRole();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional SiteRole.Option new_site_role = 1;
 * @return {!proto.entity.SiteRole.Option}
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.prototype.getNewSiteRole = function() {
  return /** @type {!proto.entity.SiteRole.Option} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.entity.SiteRole.Option} value
 * @return {!proto.entity.UpdateSiteUserRequest.ChangeSiteRole} returns this
 */
proto.entity.UpdateSiteUserRequest.ChangeSiteRole.prototype.setNewSiteRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateSiteUserRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateSiteUserRequest} returns this
*/
proto.entity.UpdateSiteUserRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteUserRequest} returns this
 */
proto.entity.UpdateSiteUserRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteUserRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserSelector user_selector = 2;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.UpdateSiteUserRequest.prototype.getUserSelector = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 2));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.UpdateSiteUserRequest} returns this
*/
proto.entity.UpdateSiteUserRequest.prototype.setUserSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteUserRequest} returns this
 */
proto.entity.UpdateSiteUserRequest.prototype.clearUserSelector = function() {
  return this.setUserSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteUserRequest.prototype.hasUserSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Action action = 3;
 * @return {?proto.entity.UpdateSiteUserRequest.Action}
 */
proto.entity.UpdateSiteUserRequest.prototype.getAction = function() {
  return /** @type{?proto.entity.UpdateSiteUserRequest.Action} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateSiteUserRequest.Action, 3));
};


/**
 * @param {?proto.entity.UpdateSiteUserRequest.Action|undefined} value
 * @return {!proto.entity.UpdateSiteUserRequest} returns this
*/
proto.entity.UpdateSiteUserRequest.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteUserRequest} returns this
 */
proto.entity.UpdateSiteUserRequest.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteUserRequest.prototype.hasAction = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteUserReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteUserReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteUserReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteUserReply}
 */
proto.entity.UpdateSiteUserReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteUserReply;
  return proto.entity.UpdateSiteUserReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteUserReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteUserReply}
 */
proto.entity.UpdateSiteUserReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteUserReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteUserReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteUserReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteUserReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateSiteGroupingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateSiteGroupingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateSiteGroupingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteGroupingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newSiteGrouping: (f = msg.getNewSiteGrouping()) && proto_entity_siteGrouping_pb.NewSiteGrouping.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateSiteGroupingRequest}
 */
proto.entity.CreateSiteGroupingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateSiteGroupingRequest;
  return proto.entity.CreateSiteGroupingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateSiteGroupingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateSiteGroupingRequest}
 */
proto.entity.CreateSiteGroupingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteGrouping_pb.NewSiteGrouping;
      reader.readMessage(value,proto_entity_siteGrouping_pb.NewSiteGrouping.deserializeBinaryFromReader);
      msg.setNewSiteGrouping(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateSiteGroupingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateSiteGroupingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateSiteGroupingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteGroupingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewSiteGrouping();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteGrouping_pb.NewSiteGrouping.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewSiteGrouping new_site_grouping = 1;
 * @return {?proto.entity.NewSiteGrouping}
 */
proto.entity.CreateSiteGroupingRequest.prototype.getNewSiteGrouping = function() {
  return /** @type{?proto.entity.NewSiteGrouping} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteGrouping_pb.NewSiteGrouping, 1));
};


/**
 * @param {?proto.entity.NewSiteGrouping|undefined} value
 * @return {!proto.entity.CreateSiteGroupingRequest} returns this
*/
proto.entity.CreateSiteGroupingRequest.prototype.setNewSiteGrouping = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateSiteGroupingRequest} returns this
 */
proto.entity.CreateSiteGroupingRequest.prototype.clearNewSiteGrouping = function() {
  return this.setNewSiteGrouping(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateSiteGroupingRequest.prototype.hasNewSiteGrouping = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateSiteGroupingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateSiteGroupingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateSiteGroupingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteGroupingReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteGrouping: (f = msg.getSiteGrouping()) && proto_entity_siteGrouping_pb.SiteGrouping.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateSiteGroupingReply}
 */
proto.entity.CreateSiteGroupingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateSiteGroupingReply;
  return proto.entity.CreateSiteGroupingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateSiteGroupingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateSiteGroupingReply}
 */
proto.entity.CreateSiteGroupingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteGrouping_pb.SiteGrouping;
      reader.readMessage(value,proto_entity_siteGrouping_pb.SiteGrouping.deserializeBinaryFromReader);
      msg.setSiteGrouping(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateSiteGroupingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateSiteGroupingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateSiteGroupingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateSiteGroupingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteGrouping();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteGrouping_pb.SiteGrouping.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteGrouping site_grouping = 1;
 * @return {?proto.entity.SiteGrouping}
 */
proto.entity.CreateSiteGroupingReply.prototype.getSiteGrouping = function() {
  return /** @type{?proto.entity.SiteGrouping} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteGrouping_pb.SiteGrouping, 1));
};


/**
 * @param {?proto.entity.SiteGrouping|undefined} value
 * @return {!proto.entity.CreateSiteGroupingReply} returns this
*/
proto.entity.CreateSiteGroupingReply.prototype.setSiteGrouping = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateSiteGroupingReply} returns this
 */
proto.entity.CreateSiteGroupingReply.prototype.clearSiteGrouping = function() {
  return this.setSiteGrouping(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateSiteGroupingReply.prototype.hasSiteGrouping = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteGroupingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteGroupingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteGroupingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    siteGroupingId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    action: (f = msg.getAction()) && proto.entity.UpdateSiteGroupingRequest.Action.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteGroupingRequest}
 */
proto.entity.UpdateSiteGroupingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteGroupingRequest;
  return proto.entity.UpdateSiteGroupingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteGroupingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteGroupingRequest}
 */
proto.entity.UpdateSiteGroupingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteGroupingId(value);
      break;
    case 3:
      var value = new proto.entity.UpdateSiteGroupingRequest.Action;
      reader.readMessage(value,proto.entity.UpdateSiteGroupingRequest.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteGroupingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteGroupingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteGroupingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getSiteGroupingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.UpdateSiteGroupingRequest.Action.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.UpdateSiteGroupingRequest.Action.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.entity.UpdateSiteGroupingRequest.Action.TypeCase = {
  TYPE_NOT_SET: 0,
  UPDATE_GROUPING_DEFINITION: 1
};

/**
 * @return {proto.entity.UpdateSiteGroupingRequest.Action.TypeCase}
 */
proto.entity.UpdateSiteGroupingRequest.Action.prototype.getTypeCase = function() {
  return /** @type {proto.entity.UpdateSiteGroupingRequest.Action.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.UpdateSiteGroupingRequest.Action.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteGroupingRequest.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteGroupingRequest.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteGroupingRequest.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingRequest.Action.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateGroupingDefinition: (f = msg.getUpdateGroupingDefinition()) && proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteGroupingRequest.Action}
 */
proto.entity.UpdateSiteGroupingRequest.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteGroupingRequest.Action;
  return proto.entity.UpdateSiteGroupingRequest.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteGroupingRequest.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteGroupingRequest.Action}
 */
proto.entity.UpdateSiteGroupingRequest.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition;
      reader.readMessage(value,proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.deserializeBinaryFromReader);
      msg.setUpdateGroupingDefinition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteGroupingRequest.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteGroupingRequest.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteGroupingRequest.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingRequest.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateGroupingDefinition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateGroupingDefinition update_grouping_definition = 1;
 * @return {?proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition}
 */
proto.entity.UpdateSiteGroupingRequest.Action.prototype.getUpdateGroupingDefinition = function() {
  return /** @type{?proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition, 1));
};


/**
 * @param {?proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition|undefined} value
 * @return {!proto.entity.UpdateSiteGroupingRequest.Action} returns this
*/
proto.entity.UpdateSiteGroupingRequest.Action.prototype.setUpdateGroupingDefinition = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.UpdateSiteGroupingRequest.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteGroupingRequest.Action} returns this
 */
proto.entity.UpdateSiteGroupingRequest.Action.prototype.clearUpdateGroupingDefinition = function() {
  return this.setUpdateGroupingDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteGroupingRequest.Action.prototype.hasUpdateGroupingDefinition = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    newGroupingDefinition: (f = msg.getNewGroupingDefinition()) && proto_entity_siteGrouping_pb.GroupingDefinition.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition}
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition;
  return proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition}
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteGrouping_pb.GroupingDefinition;
      reader.readMessage(value,proto_entity_siteGrouping_pb.GroupingDefinition.deserializeBinaryFromReader);
      msg.setNewGroupingDefinition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewGroupingDefinition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteGrouping_pb.GroupingDefinition.serializeBinaryToWriter
    );
  }
};


/**
 * optional GroupingDefinition new_grouping_definition = 1;
 * @return {?proto.entity.GroupingDefinition}
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.prototype.getNewGroupingDefinition = function() {
  return /** @type{?proto.entity.GroupingDefinition} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteGrouping_pb.GroupingDefinition, 1));
};


/**
 * @param {?proto.entity.GroupingDefinition|undefined} value
 * @return {!proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition} returns this
*/
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.prototype.setNewGroupingDefinition = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition} returns this
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.prototype.clearNewGroupingDefinition = function() {
  return this.setNewGroupingDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteGroupingRequest.UpdateGroupingDefinition.prototype.hasNewGroupingDefinition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateSiteGroupingRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateSiteGroupingRequest} returns this
*/
proto.entity.UpdateSiteGroupingRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteGroupingRequest} returns this
 */
proto.entity.UpdateSiteGroupingRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteGroupingRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string site_grouping_id = 2;
 * @return {string}
 */
proto.entity.UpdateSiteGroupingRequest.prototype.getSiteGroupingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.UpdateSiteGroupingRequest} returns this
 */
proto.entity.UpdateSiteGroupingRequest.prototype.setSiteGroupingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Action action = 3;
 * @return {?proto.entity.UpdateSiteGroupingRequest.Action}
 */
proto.entity.UpdateSiteGroupingRequest.prototype.getAction = function() {
  return /** @type{?proto.entity.UpdateSiteGroupingRequest.Action} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateSiteGroupingRequest.Action, 3));
};


/**
 * @param {?proto.entity.UpdateSiteGroupingRequest.Action|undefined} value
 * @return {!proto.entity.UpdateSiteGroupingRequest} returns this
*/
proto.entity.UpdateSiteGroupingRequest.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteGroupingRequest} returns this
 */
proto.entity.UpdateSiteGroupingRequest.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteGroupingRequest.prototype.hasAction = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteGroupingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteGroupingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteGroupingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteGrouping: (f = msg.getSiteGrouping()) && proto_entity_siteGrouping_pb.SiteGrouping.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteGroupingReply}
 */
proto.entity.UpdateSiteGroupingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteGroupingReply;
  return proto.entity.UpdateSiteGroupingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteGroupingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteGroupingReply}
 */
proto.entity.UpdateSiteGroupingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteGrouping_pb.SiteGrouping;
      reader.readMessage(value,proto_entity_siteGrouping_pb.SiteGrouping.deserializeBinaryFromReader);
      msg.setSiteGrouping(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteGroupingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteGroupingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteGroupingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteGroupingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteGrouping();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteGrouping_pb.SiteGrouping.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteGrouping site_grouping = 1;
 * @return {?proto.entity.SiteGrouping}
 */
proto.entity.UpdateSiteGroupingReply.prototype.getSiteGrouping = function() {
  return /** @type{?proto.entity.SiteGrouping} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteGrouping_pb.SiteGrouping, 1));
};


/**
 * @param {?proto.entity.SiteGrouping|undefined} value
 * @return {!proto.entity.UpdateSiteGroupingReply} returns this
*/
proto.entity.UpdateSiteGroupingReply.prototype.setSiteGrouping = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteGroupingReply} returns this
 */
proto.entity.UpdateSiteGroupingReply.prototype.clearSiteGrouping = function() {
  return this.setSiteGrouping(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteGroupingReply.prototype.hasSiteGrouping = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSiteGroupingsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSiteGroupingsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSiteGroupingsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteGroupingsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSiteGroupingsRequest}
 */
proto.entity.ListSiteGroupingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSiteGroupingsRequest;
  return proto.entity.ListSiteGroupingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSiteGroupingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSiteGroupingsRequest}
 */
proto.entity.ListSiteGroupingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSiteGroupingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSiteGroupingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSiteGroupingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteGroupingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListSiteGroupingsRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListSiteGroupingsRequest} returns this
*/
proto.entity.ListSiteGroupingsRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListSiteGroupingsRequest} returns this
 */
proto.entity.ListSiteGroupingsRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListSiteGroupingsRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListSiteGroupingsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSiteGroupingsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSiteGroupingsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSiteGroupingsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteGroupingsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteGroupingsList: jspb.Message.toObjectList(msg.getSiteGroupingsList(),
    proto_entity_siteGrouping_pb.SiteGrouping.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSiteGroupingsReply}
 */
proto.entity.ListSiteGroupingsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSiteGroupingsReply;
  return proto.entity.ListSiteGroupingsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSiteGroupingsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSiteGroupingsReply}
 */
proto.entity.ListSiteGroupingsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteGrouping_pb.SiteGrouping;
      reader.readMessage(value,proto_entity_siteGrouping_pb.SiteGrouping.deserializeBinaryFromReader);
      msg.addSiteGroupings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSiteGroupingsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSiteGroupingsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSiteGroupingsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteGroupingsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteGroupingsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_siteGrouping_pb.SiteGrouping.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SiteGrouping site_groupings = 1;
 * @return {!Array<!proto.entity.SiteGrouping>}
 */
proto.entity.ListSiteGroupingsReply.prototype.getSiteGroupingsList = function() {
  return /** @type{!Array<!proto.entity.SiteGrouping>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_siteGrouping_pb.SiteGrouping, 1));
};


/**
 * @param {!Array<!proto.entity.SiteGrouping>} value
 * @return {!proto.entity.ListSiteGroupingsReply} returns this
*/
proto.entity.ListSiteGroupingsReply.prototype.setSiteGroupingsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SiteGrouping=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteGrouping}
 */
proto.entity.ListSiteGroupingsReply.prototype.addSiteGroupings = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SiteGrouping, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListSiteGroupingsReply} returns this
 */
proto.entity.ListSiteGroupingsReply.prototype.clearSiteGroupingsList = function() {
  return this.setSiteGroupingsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteGroupingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteGroupingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteGroupingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteGroupingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    siteGroupingId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    version: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteGroupingRequest}
 */
proto.entity.LookupSiteGroupingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteGroupingRequest;
  return proto.entity.LookupSiteGroupingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteGroupingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteGroupingRequest}
 */
proto.entity.LookupSiteGroupingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteGroupingId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteGroupingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteGroupingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteGroupingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteGroupingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getSiteGroupingId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getVersion();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupSiteGroupingRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupSiteGroupingRequest} returns this
*/
proto.entity.LookupSiteGroupingRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteGroupingRequest} returns this
 */
proto.entity.LookupSiteGroupingRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteGroupingRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string site_grouping_id = 2;
 * @return {string}
 */
proto.entity.LookupSiteGroupingRequest.prototype.getSiteGroupingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LookupSiteGroupingRequest} returns this
 */
proto.entity.LookupSiteGroupingRequest.prototype.setSiteGroupingId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 version = 3;
 * @return {number}
 */
proto.entity.LookupSiteGroupingRequest.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.LookupSiteGroupingRequest} returns this
 */
proto.entity.LookupSiteGroupingRequest.prototype.setVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.RefreshBillingAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.RefreshBillingAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.RefreshBillingAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.RefreshBillingAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.RefreshBillingAccountRequest}
 */
proto.entity.RefreshBillingAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.RefreshBillingAccountRequest;
  return proto.entity.RefreshBillingAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.RefreshBillingAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.RefreshBillingAccountRequest}
 */
proto.entity.RefreshBillingAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.RefreshBillingAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.RefreshBillingAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.RefreshBillingAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.RefreshBillingAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.RefreshBillingAccountRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.RefreshBillingAccountRequest} returns this
*/
proto.entity.RefreshBillingAccountRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.RefreshBillingAccountRequest} returns this
 */
proto.entity.RefreshBillingAccountRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.RefreshBillingAccountRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.RefreshBillingAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.RefreshBillingAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.RefreshBillingAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.RefreshBillingAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    updated: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.RefreshBillingAccountReply}
 */
proto.entity.RefreshBillingAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.RefreshBillingAccountReply;
  return proto.entity.RefreshBillingAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.RefreshBillingAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.RefreshBillingAccountReply}
 */
proto.entity.RefreshBillingAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.RefreshBillingAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.RefreshBillingAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.RefreshBillingAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.RefreshBillingAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdated();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool updated = 1;
 * @return {boolean}
 */
proto.entity.RefreshBillingAccountReply.prototype.getUpdated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.RefreshBillingAccountReply} returns this
 */
proto.entity.RefreshBillingAccountReply.prototype.setUpdated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListBillingAccountsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListBillingAccountsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListBillingAccountsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListBillingAccountsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListBillingAccountsRequest}
 */
proto.entity.ListBillingAccountsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListBillingAccountsRequest;
  return proto.entity.ListBillingAccountsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListBillingAccountsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListBillingAccountsRequest}
 */
proto.entity.ListBillingAccountsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListBillingAccountsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListBillingAccountsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListBillingAccountsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListBillingAccountsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListBillingAccountsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListBillingAccountsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListBillingAccountsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListBillingAccountsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListBillingAccountsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAccountsList: jspb.Message.toObjectList(msg.getBillingAccountsList(),
    proto_entity_billingAccount_pb.BillingAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListBillingAccountsReply}
 */
proto.entity.ListBillingAccountsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListBillingAccountsReply;
  return proto.entity.ListBillingAccountsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListBillingAccountsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListBillingAccountsReply}
 */
proto.entity.ListBillingAccountsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.BillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.BillingAccount.deserializeBinaryFromReader);
      msg.addBillingAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListBillingAccountsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListBillingAccountsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListBillingAccountsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListBillingAccountsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_billingAccount_pb.BillingAccount.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BillingAccount billing_accounts = 1;
 * @return {!Array<!proto.entity.BillingAccount>}
 */
proto.entity.ListBillingAccountsReply.prototype.getBillingAccountsList = function() {
  return /** @type{!Array<!proto.entity.BillingAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_billingAccount_pb.BillingAccount, 1));
};


/**
 * @param {!Array<!proto.entity.BillingAccount>} value
 * @return {!proto.entity.ListBillingAccountsReply} returns this
*/
proto.entity.ListBillingAccountsReply.prototype.setBillingAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.BillingAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.BillingAccount}
 */
proto.entity.ListBillingAccountsReply.prototype.addBillingAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.BillingAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListBillingAccountsReply} returns this
 */
proto.entity.ListBillingAccountsReply.prototype.clearBillingAccountsList = function() {
  return this.setBillingAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteGroupingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteGroupingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteGroupingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteGroupingReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteGrouping: (f = msg.getSiteGrouping()) && proto_entity_siteGrouping_pb.SiteGrouping.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteGroupingReply}
 */
proto.entity.LookupSiteGroupingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteGroupingReply;
  return proto.entity.LookupSiteGroupingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteGroupingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteGroupingReply}
 */
proto.entity.LookupSiteGroupingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteGrouping_pb.SiteGrouping;
      reader.readMessage(value,proto_entity_siteGrouping_pb.SiteGrouping.deserializeBinaryFromReader);
      msg.setSiteGrouping(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteGroupingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteGroupingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteGroupingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteGroupingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteGrouping();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteGrouping_pb.SiteGrouping.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteGrouping site_grouping = 1;
 * @return {?proto.entity.SiteGrouping}
 */
proto.entity.LookupSiteGroupingReply.prototype.getSiteGrouping = function() {
  return /** @type{?proto.entity.SiteGrouping} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteGrouping_pb.SiteGrouping, 1));
};


/**
 * @param {?proto.entity.SiteGrouping|undefined} value
 * @return {!proto.entity.LookupSiteGroupingReply} returns this
*/
proto.entity.LookupSiteGroupingReply.prototype.setSiteGrouping = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteGroupingReply} returns this
 */
proto.entity.LookupSiteGroupingReply.prototype.clearSiteGrouping = function() {
  return this.setSiteGrouping(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteGroupingReply.prototype.hasSiteGrouping = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupBillingAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupBillingAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupBillingAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupBillingAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    billingAccountId: (f = msg.getBillingAccountId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    includeLinkedAccounts: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupBillingAccountRequest}
 */
proto.entity.LookupBillingAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupBillingAccountRequest;
  return proto.entity.LookupBillingAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupBillingAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupBillingAccountRequest}
 */
proto.entity.LookupBillingAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setBillingAccountId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeLinkedAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupBillingAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupBillingAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupBillingAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupBillingAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getBillingAccountId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getIncludeLinkedAccounts();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupBillingAccountRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupBillingAccountRequest} returns this
*/
proto.entity.LookupBillingAccountRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupBillingAccountRequest} returns this
 */
proto.entity.LookupBillingAccountRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupBillingAccountRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID billing_account_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.LookupBillingAccountRequest.prototype.getBillingAccountId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.LookupBillingAccountRequest} returns this
*/
proto.entity.LookupBillingAccountRequest.prototype.setBillingAccountId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupBillingAccountRequest} returns this
 */
proto.entity.LookupBillingAccountRequest.prototype.clearBillingAccountId = function() {
  return this.setBillingAccountId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupBillingAccountRequest.prototype.hasBillingAccountId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool include_linked_accounts = 3;
 * @return {boolean}
 */
proto.entity.LookupBillingAccountRequest.prototype.getIncludeLinkedAccounts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.LookupBillingAccountRequest} returns this
 */
proto.entity.LookupBillingAccountRequest.prototype.setIncludeLinkedAccounts = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.LookupBillingAccountReply.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupBillingAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupBillingAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupBillingAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupBillingAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAccount: (f = msg.getBillingAccount()) && proto_entity_billingAccount_pb.BillingAccount.toObject(includeInstance, f),
    linkTarget: (f = msg.getLinkTarget()) && proto_entity_billingAccount_pb.BillingAccount.toObject(includeInstance, f),
    linkedAccountsList: jspb.Message.toObjectList(msg.getLinkedAccountsList(),
    proto_entity_billingAccount_pb.BillingAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupBillingAccountReply}
 */
proto.entity.LookupBillingAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupBillingAccountReply;
  return proto.entity.LookupBillingAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupBillingAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupBillingAccountReply}
 */
proto.entity.LookupBillingAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.BillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.BillingAccount.deserializeBinaryFromReader);
      msg.setBillingAccount(value);
      break;
    case 2:
      var value = new proto_entity_billingAccount_pb.BillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.BillingAccount.deserializeBinaryFromReader);
      msg.setLinkTarget(value);
      break;
    case 3:
      var value = new proto_entity_billingAccount_pb.BillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.BillingAccount.deserializeBinaryFromReader);
      msg.addLinkedAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupBillingAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupBillingAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupBillingAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupBillingAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_billingAccount_pb.BillingAccount.serializeBinaryToWriter
    );
  }
  f = message.getLinkTarget();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_billingAccount_pb.BillingAccount.serializeBinaryToWriter
    );
  }
  f = message.getLinkedAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_entity_billingAccount_pb.BillingAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingAccount billing_account = 1;
 * @return {?proto.entity.BillingAccount}
 */
proto.entity.LookupBillingAccountReply.prototype.getBillingAccount = function() {
  return /** @type{?proto.entity.BillingAccount} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.BillingAccount, 1));
};


/**
 * @param {?proto.entity.BillingAccount|undefined} value
 * @return {!proto.entity.LookupBillingAccountReply} returns this
*/
proto.entity.LookupBillingAccountReply.prototype.setBillingAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupBillingAccountReply} returns this
 */
proto.entity.LookupBillingAccountReply.prototype.clearBillingAccount = function() {
  return this.setBillingAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupBillingAccountReply.prototype.hasBillingAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional BillingAccount link_target = 2;
 * @return {?proto.entity.BillingAccount}
 */
proto.entity.LookupBillingAccountReply.prototype.getLinkTarget = function() {
  return /** @type{?proto.entity.BillingAccount} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.BillingAccount, 2));
};


/**
 * @param {?proto.entity.BillingAccount|undefined} value
 * @return {!proto.entity.LookupBillingAccountReply} returns this
*/
proto.entity.LookupBillingAccountReply.prototype.setLinkTarget = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupBillingAccountReply} returns this
 */
proto.entity.LookupBillingAccountReply.prototype.clearLinkTarget = function() {
  return this.setLinkTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupBillingAccountReply.prototype.hasLinkTarget = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated BillingAccount linked_accounts = 3;
 * @return {!Array<!proto.entity.BillingAccount>}
 */
proto.entity.LookupBillingAccountReply.prototype.getLinkedAccountsList = function() {
  return /** @type{!Array<!proto.entity.BillingAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_billingAccount_pb.BillingAccount, 3));
};


/**
 * @param {!Array<!proto.entity.BillingAccount>} value
 * @return {!proto.entity.LookupBillingAccountReply} returns this
*/
proto.entity.LookupBillingAccountReply.prototype.setLinkedAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.BillingAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.BillingAccount}
 */
proto.entity.LookupBillingAccountReply.prototype.addLinkedAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.BillingAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.LookupBillingAccountReply} returns this
 */
proto.entity.LookupBillingAccountReply.prototype.clearLinkedAccountsList = function() {
  return this.setLinkedAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateBillingAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateBillingAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateBillingAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateBillingAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newBillingAccount: (f = msg.getNewBillingAccount()) && proto_entity_billingAccount_pb.NewBillingAccount.toObject(includeInstance, f),
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateBillingAccountRequest}
 */
proto.entity.CreateBillingAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateBillingAccountRequest;
  return proto.entity.CreateBillingAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateBillingAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateBillingAccountRequest}
 */
proto.entity.CreateBillingAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.NewBillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.NewBillingAccount.deserializeBinaryFromReader);
      msg.setNewBillingAccount(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateBillingAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateBillingAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateBillingAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateBillingAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewBillingAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_billingAccount_pb.NewBillingAccount.serializeBinaryToWriter
    );
  }
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewBillingAccount new_billing_account = 1;
 * @return {?proto.entity.NewBillingAccount}
 */
proto.entity.CreateBillingAccountRequest.prototype.getNewBillingAccount = function() {
  return /** @type{?proto.entity.NewBillingAccount} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.NewBillingAccount, 1));
};


/**
 * @param {?proto.entity.NewBillingAccount|undefined} value
 * @return {!proto.entity.CreateBillingAccountRequest} returns this
*/
proto.entity.CreateBillingAccountRequest.prototype.setNewBillingAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateBillingAccountRequest} returns this
 */
proto.entity.CreateBillingAccountRequest.prototype.clearNewBillingAccount = function() {
  return this.setNewBillingAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateBillingAccountRequest.prototype.hasNewBillingAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SiteSelector site_selector = 2;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.CreateBillingAccountRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 2));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.CreateBillingAccountRequest} returns this
*/
proto.entity.CreateBillingAccountRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateBillingAccountRequest} returns this
 */
proto.entity.CreateBillingAccountRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateBillingAccountRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateBillingAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateBillingAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateBillingAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateBillingAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAccount: (f = msg.getBillingAccount()) && proto_entity_billingAccount_pb.BillingAccount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateBillingAccountReply}
 */
proto.entity.CreateBillingAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateBillingAccountReply;
  return proto.entity.CreateBillingAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateBillingAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateBillingAccountReply}
 */
proto.entity.CreateBillingAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.BillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.BillingAccount.deserializeBinaryFromReader);
      msg.setBillingAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateBillingAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateBillingAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateBillingAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateBillingAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_billingAccount_pb.BillingAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingAccount billing_account = 1;
 * @return {?proto.entity.BillingAccount}
 */
proto.entity.CreateBillingAccountReply.prototype.getBillingAccount = function() {
  return /** @type{?proto.entity.BillingAccount} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.BillingAccount, 1));
};


/**
 * @param {?proto.entity.BillingAccount|undefined} value
 * @return {!proto.entity.CreateBillingAccountReply} returns this
*/
proto.entity.CreateBillingAccountReply.prototype.setBillingAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateBillingAccountReply} returns this
 */
proto.entity.CreateBillingAccountReply.prototype.clearBillingAccount = function() {
  return this.setBillingAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateBillingAccountReply.prototype.hasBillingAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateBillingAccountRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateBillingAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateBillingAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateBillingAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateBillingAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    billingAccountId: (f = msg.getBillingAccountId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_billingAccount_pb.UpdateBillingAccountAction.toObject, includeInstance),
    ifVersion: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateBillingAccountRequest}
 */
proto.entity.UpdateBillingAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateBillingAccountRequest;
  return proto.entity.UpdateBillingAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateBillingAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateBillingAccountRequest}
 */
proto.entity.UpdateBillingAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setBillingAccountId(value);
      break;
    case 3:
      var value = new proto_entity_billingAccount_pb.UpdateBillingAccountAction;
      reader.readMessage(value,proto_entity_billingAccount_pb.UpdateBillingAccountAction.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIfVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateBillingAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateBillingAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateBillingAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateBillingAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getBillingAccountId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_entity_billingAccount_pb.UpdateBillingAccountAction.serializeBinaryToWriter
    );
  }
  f = message.getIfVersion();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateBillingAccountRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateBillingAccountRequest} returns this
*/
proto.entity.UpdateBillingAccountRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateBillingAccountRequest} returns this
 */
proto.entity.UpdateBillingAccountRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateBillingAccountRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID billing_account_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UpdateBillingAccountRequest.prototype.getBillingAccountId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UpdateBillingAccountRequest} returns this
*/
proto.entity.UpdateBillingAccountRequest.prototype.setBillingAccountId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateBillingAccountRequest} returns this
 */
proto.entity.UpdateBillingAccountRequest.prototype.clearBillingAccountId = function() {
  return this.setBillingAccountId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateBillingAccountRequest.prototype.hasBillingAccountId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated UpdateBillingAccountAction actions = 3;
 * @return {!Array<!proto.entity.UpdateBillingAccountAction>}
 */
proto.entity.UpdateBillingAccountRequest.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.UpdateBillingAccountAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_billingAccount_pb.UpdateBillingAccountAction, 3));
};


/**
 * @param {!Array<!proto.entity.UpdateBillingAccountAction>} value
 * @return {!proto.entity.UpdateBillingAccountRequest} returns this
*/
proto.entity.UpdateBillingAccountRequest.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.UpdateBillingAccountAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateBillingAccountAction}
 */
proto.entity.UpdateBillingAccountRequest.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.UpdateBillingAccountAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateBillingAccountRequest} returns this
 */
proto.entity.UpdateBillingAccountRequest.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};


/**
 * optional int64 if_version = 4;
 * @return {number}
 */
proto.entity.UpdateBillingAccountRequest.prototype.getIfVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.UpdateBillingAccountRequest} returns this
 */
proto.entity.UpdateBillingAccountRequest.prototype.setIfVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateBillingAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateBillingAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateBillingAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateBillingAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAccount: (f = msg.getBillingAccount()) && proto_entity_billingAccount_pb.BillingAccount.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateBillingAccountReply}
 */
proto.entity.UpdateBillingAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateBillingAccountReply;
  return proto.entity.UpdateBillingAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateBillingAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateBillingAccountReply}
 */
proto.entity.UpdateBillingAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.BillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.BillingAccount.deserializeBinaryFromReader);
      msg.setBillingAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateBillingAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateBillingAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateBillingAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateBillingAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_billingAccount_pb.BillingAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingAccount billing_account = 1;
 * @return {?proto.entity.BillingAccount}
 */
proto.entity.UpdateBillingAccountReply.prototype.getBillingAccount = function() {
  return /** @type{?proto.entity.BillingAccount} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.BillingAccount, 1));
};


/**
 * @param {?proto.entity.BillingAccount|undefined} value
 * @return {!proto.entity.UpdateBillingAccountReply} returns this
*/
proto.entity.UpdateBillingAccountReply.prototype.setBillingAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateBillingAccountReply} returns this
 */
proto.entity.UpdateBillingAccountReply.prototype.clearBillingAccount = function() {
  return this.setBillingAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateBillingAccountReply.prototype.hasBillingAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateInitialBillingAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateInitialBillingAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateInitialBillingAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateInitialBillingAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateInitialBillingAccountRequest}
 */
proto.entity.CreateInitialBillingAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateInitialBillingAccountRequest;
  return proto.entity.CreateInitialBillingAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateInitialBillingAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateInitialBillingAccountRequest}
 */
proto.entity.CreateInitialBillingAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateInitialBillingAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateInitialBillingAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateInitialBillingAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateInitialBillingAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.CreateInitialBillingAccountRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.CreateInitialBillingAccountRequest} returns this
*/
proto.entity.CreateInitialBillingAccountRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateInitialBillingAccountRequest} returns this
 */
proto.entity.CreateInitialBillingAccountRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateInitialBillingAccountRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateInitialBillingAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateInitialBillingAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateInitialBillingAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateInitialBillingAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    billingAccount: (f = msg.getBillingAccount()) && proto_entity_billingAccount_pb.BillingAccount.toObject(includeInstance, f),
    createdBillingAccount: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateInitialBillingAccountReply}
 */
proto.entity.CreateInitialBillingAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateInitialBillingAccountReply;
  return proto.entity.CreateInitialBillingAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateInitialBillingAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateInitialBillingAccountReply}
 */
proto.entity.CreateInitialBillingAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.BillingAccount;
      reader.readMessage(value,proto_entity_billingAccount_pb.BillingAccount.deserializeBinaryFromReader);
      msg.setBillingAccount(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCreatedBillingAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateInitialBillingAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateInitialBillingAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateInitialBillingAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateInitialBillingAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBillingAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_billingAccount_pb.BillingAccount.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBillingAccount();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional BillingAccount billing_account = 1;
 * @return {?proto.entity.BillingAccount}
 */
proto.entity.CreateInitialBillingAccountReply.prototype.getBillingAccount = function() {
  return /** @type{?proto.entity.BillingAccount} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.BillingAccount, 1));
};


/**
 * @param {?proto.entity.BillingAccount|undefined} value
 * @return {!proto.entity.CreateInitialBillingAccountReply} returns this
*/
proto.entity.CreateInitialBillingAccountReply.prototype.setBillingAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateInitialBillingAccountReply} returns this
 */
proto.entity.CreateInitialBillingAccountReply.prototype.clearBillingAccount = function() {
  return this.setBillingAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateInitialBillingAccountReply.prototype.hasBillingAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool created_billing_account = 2;
 * @return {boolean}
 */
proto.entity.CreateInitialBillingAccountReply.prototype.getCreatedBillingAccount = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.CreateInitialBillingAccountReply} returns this
 */
proto.entity.CreateInitialBillingAccountReply.prototype.setCreatedBillingAccount = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListEmailRecipientsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListEmailRecipientsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListEmailRecipientsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListEmailRecipientsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListEmailRecipientsRequest}
 */
proto.entity.ListEmailRecipientsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListEmailRecipientsRequest;
  return proto.entity.ListEmailRecipientsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListEmailRecipientsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListEmailRecipientsRequest}
 */
proto.entity.ListEmailRecipientsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListEmailRecipientsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListEmailRecipientsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListEmailRecipientsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListEmailRecipientsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListEmailRecipientsRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListEmailRecipientsRequest} returns this
*/
proto.entity.ListEmailRecipientsRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListEmailRecipientsRequest} returns this
 */
proto.entity.ListEmailRecipientsRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListEmailRecipientsRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListEmailRecipientsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListEmailRecipientsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListEmailRecipientsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListEmailRecipientsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListEmailRecipientsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    recipientsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListEmailRecipientsReply}
 */
proto.entity.ListEmailRecipientsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListEmailRecipientsReply;
  return proto.entity.ListEmailRecipientsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListEmailRecipientsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListEmailRecipientsReply}
 */
proto.entity.ListEmailRecipientsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecipients(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListEmailRecipientsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListEmailRecipientsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListEmailRecipientsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListEmailRecipientsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string recipients = 1;
 * @return {!Array<string>}
 */
proto.entity.ListEmailRecipientsReply.prototype.getRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.ListEmailRecipientsReply} returns this
 */
proto.entity.ListEmailRecipientsReply.prototype.setRecipientsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.ListEmailRecipientsReply} returns this
 */
proto.entity.ListEmailRecipientsReply.prototype.addRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListEmailRecipientsReply} returns this
 */
proto.entity.ListEmailRecipientsReply.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSiteHubsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSiteHubsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSiteHubsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteHubsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSiteHubsRequest}
 */
proto.entity.ListSiteHubsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSiteHubsRequest;
  return proto.entity.ListSiteHubsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSiteHubsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSiteHubsRequest}
 */
proto.entity.ListSiteHubsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSiteHubsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSiteHubsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSiteHubsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteHubsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListSiteHubsRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListSiteHubsRequest} returns this
*/
proto.entity.ListSiteHubsRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListSiteHubsRequest} returns this
 */
proto.entity.ListSiteHubsRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListSiteHubsRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListSiteHubsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSiteHubsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSiteHubsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSiteHubsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteHubsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    hubsList: jspb.Message.toObjectList(msg.getHubsList(),
    proto_entity_hub_pb.Hub.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSiteHubsReply}
 */
proto.entity.ListSiteHubsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSiteHubsReply;
  return proto.entity.ListSiteHubsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSiteHubsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSiteHubsReply}
 */
proto.entity.ListSiteHubsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_hub_pb.Hub;
      reader.readMessage(value,proto_entity_hub_pb.Hub.deserializeBinaryFromReader);
      msg.addHubs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSiteHubsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSiteHubsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSiteHubsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSiteHubsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHubsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_hub_pb.Hub.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Hub hubs = 1;
 * @return {!Array<!proto.entity.Hub>}
 */
proto.entity.ListSiteHubsReply.prototype.getHubsList = function() {
  return /** @type{!Array<!proto.entity.Hub>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_hub_pb.Hub, 1));
};


/**
 * @param {!Array<!proto.entity.Hub>} value
 * @return {!proto.entity.ListSiteHubsReply} returns this
*/
proto.entity.ListSiteHubsReply.prototype.setHubsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Hub=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Hub}
 */
proto.entity.ListSiteHubsReply.prototype.addHubs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Hub, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListSiteHubsReply} returns this
 */
proto.entity.ListSiteHubsReply.prototype.clearHubsList = function() {
  return this.setHubsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.InviteUserToSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.InviteUserToSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.InviteUserToSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.InviteUserToSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    userSelector: (f = msg.getUserSelector()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f),
    siteRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    userInvitationDetails: (f = msg.getUserInvitationDetails()) && proto_entity_userInvitation_pb.UserInvitationDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.InviteUserToSiteRequest}
 */
proto.entity.InviteUserToSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.InviteUserToSiteRequest;
  return proto.entity.InviteUserToSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.InviteUserToSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.InviteUserToSiteRequest}
 */
proto.entity.InviteUserToSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setUserSelector(value);
      break;
    case 3:
      var value = /** @type {!proto.entity.SiteRole.Option} */ (reader.readEnum());
      msg.setSiteRole(value);
      break;
    case 4:
      var value = new proto_entity_userInvitation_pb.UserInvitationDetails;
      reader.readMessage(value,proto_entity_userInvitation_pb.UserInvitationDetails.deserializeBinaryFromReader);
      msg.setUserInvitationDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.InviteUserToSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.InviteUserToSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.InviteUserToSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.InviteUserToSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getUserSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
  f = message.getSiteRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUserInvitationDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_entity_userInvitation_pb.UserInvitationDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.InviteUserToSiteRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.InviteUserToSiteRequest} returns this
*/
proto.entity.InviteUserToSiteRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.InviteUserToSiteRequest} returns this
 */
proto.entity.InviteUserToSiteRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.InviteUserToSiteRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserSelector user_selector = 2;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.InviteUserToSiteRequest.prototype.getUserSelector = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 2));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.InviteUserToSiteRequest} returns this
*/
proto.entity.InviteUserToSiteRequest.prototype.setUserSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.InviteUserToSiteRequest} returns this
 */
proto.entity.InviteUserToSiteRequest.prototype.clearUserSelector = function() {
  return this.setUserSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.InviteUserToSiteRequest.prototype.hasUserSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SiteRole.Option site_role = 3;
 * @return {!proto.entity.SiteRole.Option}
 */
proto.entity.InviteUserToSiteRequest.prototype.getSiteRole = function() {
  return /** @type {!proto.entity.SiteRole.Option} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.entity.SiteRole.Option} value
 * @return {!proto.entity.InviteUserToSiteRequest} returns this
 */
proto.entity.InviteUserToSiteRequest.prototype.setSiteRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional UserInvitationDetails user_invitation_details = 4;
 * @return {?proto.entity.UserInvitationDetails}
 */
proto.entity.InviteUserToSiteRequest.prototype.getUserInvitationDetails = function() {
  return /** @type{?proto.entity.UserInvitationDetails} */ (
    jspb.Message.getWrapperField(this, proto_entity_userInvitation_pb.UserInvitationDetails, 4));
};


/**
 * @param {?proto.entity.UserInvitationDetails|undefined} value
 * @return {!proto.entity.InviteUserToSiteRequest} returns this
*/
proto.entity.InviteUserToSiteRequest.prototype.setUserInvitationDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.InviteUserToSiteRequest} returns this
 */
proto.entity.InviteUserToSiteRequest.prototype.clearUserInvitationDetails = function() {
  return this.setUserInvitationDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.InviteUserToSiteRequest.prototype.hasUserInvitationDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.InviteUserToSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.InviteUserToSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.InviteUserToSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.InviteUserToSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    userSite: (f = msg.getUserSite()) && proto_entity_user_pb.UserSiteMapping.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.InviteUserToSiteReply}
 */
proto.entity.InviteUserToSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.InviteUserToSiteReply;
  return proto.entity.InviteUserToSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.InviteUserToSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.InviteUserToSiteReply}
 */
proto.entity.InviteUserToSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.UserSiteMapping;
      reader.readMessage(value,proto_entity_user_pb.UserSiteMapping.deserializeBinaryFromReader);
      msg.setUserSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.InviteUserToSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.InviteUserToSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.InviteUserToSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.InviteUserToSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.UserSiteMapping.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserSiteMapping user_site = 1;
 * @return {?proto.entity.UserSiteMapping}
 */
proto.entity.InviteUserToSiteReply.prototype.getUserSite = function() {
  return /** @type{?proto.entity.UserSiteMapping} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSiteMapping, 1));
};


/**
 * @param {?proto.entity.UserSiteMapping|undefined} value
 * @return {!proto.entity.InviteUserToSiteReply} returns this
*/
proto.entity.InviteUserToSiteReply.prototype.setUserSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.InviteUserToSiteReply} returns this
 */
proto.entity.InviteUserToSiteReply.prototype.clearUserSite = function() {
  return this.setUserSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.InviteUserToSiteReply.prototype.hasUserSite = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListIssuesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListIssuesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListIssuesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssuesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    filters: (f = msg.getFilters()) && proto.entity.ListIssuesRequest.Filters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListIssuesRequest}
 */
proto.entity.ListIssuesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListIssuesRequest;
  return proto.entity.ListIssuesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListIssuesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListIssuesRequest}
 */
proto.entity.ListIssuesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto.entity.ListIssuesRequest.Filters;
      reader.readMessage(value,proto.entity.ListIssuesRequest.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListIssuesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListIssuesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListIssuesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssuesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.ListIssuesRequest.Filters.serializeBinaryToWriter
    );
  }
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListIssuesRequest.Filters.repeatedFields_ = [2,3,5,11,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListIssuesRequest.Filters.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListIssuesRequest.Filters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListIssuesRequest.Filters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssuesRequest.Filters.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && proto_common_datetime_pb.Date.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && proto_common_datetime_pb.Date.toObject(includeInstance, f),
    createdSince: (f = msg.getCreatedSince()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdBefore: (f = msg.getCreatedBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    includeStatesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    includeDimensionNamesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    includeDimensionsMap: (f = msg.getIncludeDimensionsMap()) ? f.toObject(includeInstance, undefined) : [],
    includeTagsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    includeAttributesMap: (f = msg.getIncludeAttributesMap()) ? f.toObject(includeInstance, undefined) : [],
    excludeAttributeNamesList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    includeAssigneeUserIdsList: jspb.Message.toObjectList(msg.getIncludeAssigneeUserIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListIssuesRequest.Filters}
 */
proto.entity.ListIssuesRequest.Filters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListIssuesRequest.Filters;
  return proto.entity.ListIssuesRequest.Filters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListIssuesRequest.Filters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListIssuesRequest.Filters}
 */
proto.entity.ListIssuesRequest.Filters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_datetime_pb.Date;
      reader.readMessage(value,proto_common_datetime_pb.Date.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 7:
      var value = new proto_common_datetime_pb.Date;
      reader.readMessage(value,proto_common_datetime_pb.Date.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedSince(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedBefore(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.entity.IssueState.Options>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addIncludeStates(values[i]);
      }
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeDimensionNames(value);
      break;
    case 4:
      var value = msg.getIncludeDimensionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeTags(value);
      break;
    case 10:
      var value = msg.getIncludeAttributesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addExcludeAttributeNames(value);
      break;
    case 6:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addIncludeAssigneeUserIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListIssuesRequest.Filters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListIssuesRequest.Filters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListIssuesRequest.Filters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssuesRequest.Filters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_datetime_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto_common_datetime_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCreatedSince();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBefore();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIncludeStatesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getIncludeDimensionNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getIncludeDimensionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getIncludeTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getIncludeAttributesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(10, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getExcludeAttributeNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getIncludeAssigneeUserIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.Date start_date = 1;
 * @return {?proto.common.Date}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getStartDate = function() {
  return /** @type{?proto.common.Date} */ (
    jspb.Message.getWrapperField(this, proto_common_datetime_pb.Date, 1));
};


/**
 * @param {?proto.common.Date|undefined} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
*/
proto.entity.ListIssuesRequest.Filters.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssuesRequest.Filters.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.Date end_date = 7;
 * @return {?proto.common.Date}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getEndDate = function() {
  return /** @type{?proto.common.Date} */ (
    jspb.Message.getWrapperField(this, proto_common_datetime_pb.Date, 7));
};


/**
 * @param {?proto.common.Date|undefined} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
*/
proto.entity.ListIssuesRequest.Filters.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssuesRequest.Filters.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp created_since = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getCreatedSince = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
*/
proto.entity.ListIssuesRequest.Filters.prototype.setCreatedSince = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearCreatedSince = function() {
  return this.setCreatedSince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssuesRequest.Filters.prototype.hasCreatedSince = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp created_before = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getCreatedBefore = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
*/
proto.entity.ListIssuesRequest.Filters.prototype.setCreatedBefore = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearCreatedBefore = function() {
  return this.setCreatedBefore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssuesRequest.Filters.prototype.hasCreatedBefore = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * repeated IssueState.Options include_states = 2;
 * @return {!Array<!proto.entity.IssueState.Options>}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getIncludeStatesList = function() {
  return /** @type {!Array<!proto.entity.IssueState.Options>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.entity.IssueState.Options>} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.setIncludeStatesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.entity.IssueState.Options} value
 * @param {number=} opt_index
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.addIncludeStates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearIncludeStatesList = function() {
  return this.setIncludeStatesList([]);
};


/**
 * repeated string include_dimension_names = 3;
 * @return {!Array<string>}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getIncludeDimensionNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.setIncludeDimensionNamesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.addIncludeDimensionNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearIncludeDimensionNamesList = function() {
  return this.setIncludeDimensionNamesList([]);
};


/**
 * map<string, string> include_dimensions = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getIncludeDimensionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearIncludeDimensionsMap = function() {
  this.getIncludeDimensionsMap().clear();
  return this;};


/**
 * repeated string include_tags = 5;
 * @return {!Array<string>}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getIncludeTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.setIncludeTagsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.addIncludeTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearIncludeTagsList = function() {
  return this.setIncludeTagsList([]);
};


/**
 * map<string, string> include_attributes = 10;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getIncludeAttributesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 10, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearIncludeAttributesMap = function() {
  this.getIncludeAttributesMap().clear();
  return this;};


/**
 * repeated string exclude_attribute_names = 11;
 * @return {!Array<string>}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getExcludeAttributeNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.setExcludeAttributeNamesList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.addExcludeAttributeNames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearExcludeAttributeNamesList = function() {
  return this.setExcludeAttributeNamesList([]);
};


/**
 * repeated common.ObjectID include_assignee_user_ids = 6;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.ListIssuesRequest.Filters.prototype.getIncludeAssigneeUserIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 6));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
*/
proto.entity.ListIssuesRequest.Filters.prototype.setIncludeAssigneeUserIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.ListIssuesRequest.Filters.prototype.addIncludeAssigneeUserIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListIssuesRequest.Filters} returns this
 */
proto.entity.ListIssuesRequest.Filters.prototype.clearIncludeAssigneeUserIdsList = function() {
  return this.setIncludeAssigneeUserIdsList([]);
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListIssuesRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListIssuesRequest} returns this
*/
proto.entity.ListIssuesRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssuesRequest} returns this
 */
proto.entity.ListIssuesRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssuesRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Filters filters = 2;
 * @return {?proto.entity.ListIssuesRequest.Filters}
 */
proto.entity.ListIssuesRequest.prototype.getFilters = function() {
  return /** @type{?proto.entity.ListIssuesRequest.Filters} */ (
    jspb.Message.getWrapperField(this, proto.entity.ListIssuesRequest.Filters, 2));
};


/**
 * @param {?proto.entity.ListIssuesRequest.Filters|undefined} value
 * @return {!proto.entity.ListIssuesRequest} returns this
*/
proto.entity.ListIssuesRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssuesRequest} returns this
 */
proto.entity.ListIssuesRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssuesRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListIssuesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListIssuesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListIssuesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListIssuesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssuesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    issuesList: jspb.Message.toObjectList(msg.getIssuesList(),
    proto_entity_issue_pb.Issue.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListIssuesReply}
 */
proto.entity.ListIssuesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListIssuesReply;
  return proto.entity.ListIssuesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListIssuesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListIssuesReply}
 */
proto.entity.ListIssuesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_issue_pb.Issue;
      reader.readMessage(value,proto_entity_issue_pb.Issue.deserializeBinaryFromReader);
      msg.addIssues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListIssuesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListIssuesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListIssuesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssuesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssuesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_issue_pb.Issue.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Issue issues = 1;
 * @return {!Array<!proto.entity.Issue>}
 */
proto.entity.ListIssuesReply.prototype.getIssuesList = function() {
  return /** @type{!Array<!proto.entity.Issue>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_issue_pb.Issue, 1));
};


/**
 * @param {!Array<!proto.entity.Issue>} value
 * @return {!proto.entity.ListIssuesReply} returns this
*/
proto.entity.ListIssuesReply.prototype.setIssuesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Issue=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Issue}
 */
proto.entity.ListIssuesReply.prototype.addIssues = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Issue, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListIssuesReply} returns this
 */
proto.entity.ListIssuesReply.prototype.clearIssuesList = function() {
  return this.setIssuesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupIssueRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupIssueRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupIssueRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupIssueRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    issueId: (f = msg.getIssueId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupIssueRequest}
 */
proto.entity.LookupIssueRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupIssueRequest;
  return proto.entity.LookupIssueRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupIssueRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupIssueRequest}
 */
proto.entity.LookupIssueRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setIssueId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupIssueRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupIssueRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupIssueRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupIssueRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getIssueId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupIssueRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupIssueRequest} returns this
*/
proto.entity.LookupIssueRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupIssueRequest} returns this
 */
proto.entity.LookupIssueRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupIssueRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID issue_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.LookupIssueRequest.prototype.getIssueId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.LookupIssueRequest} returns this
*/
proto.entity.LookupIssueRequest.prototype.setIssueId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupIssueRequest} returns this
 */
proto.entity.LookupIssueRequest.prototype.clearIssueId = function() {
  return this.setIssueId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupIssueRequest.prototype.hasIssueId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupIssueReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupIssueReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupIssueReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupIssueReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    issue: (f = msg.getIssue()) && proto_entity_issue_pb.Issue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupIssueReply}
 */
proto.entity.LookupIssueReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupIssueReply;
  return proto.entity.LookupIssueReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupIssueReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupIssueReply}
 */
proto.entity.LookupIssueReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_issue_pb.Issue;
      reader.readMessage(value,proto_entity_issue_pb.Issue.deserializeBinaryFromReader);
      msg.setIssue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupIssueReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupIssueReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupIssueReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupIssueReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIssue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_issue_pb.Issue.serializeBinaryToWriter
    );
  }
};


/**
 * optional Issue issue = 1;
 * @return {?proto.entity.Issue}
 */
proto.entity.LookupIssueReply.prototype.getIssue = function() {
  return /** @type{?proto.entity.Issue} */ (
    jspb.Message.getWrapperField(this, proto_entity_issue_pb.Issue, 1));
};


/**
 * @param {?proto.entity.Issue|undefined} value
 * @return {!proto.entity.LookupIssueReply} returns this
*/
proto.entity.LookupIssueReply.prototype.setIssue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupIssueReply} returns this
 */
proto.entity.LookupIssueReply.prototype.clearIssue = function() {
  return this.setIssue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupIssueReply.prototype.hasIssue = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.UpdateAnomalyRequest.oneofGroups_ = [[5]];

/**
 * @enum {number}
 */
proto.entity.UpdateAnomalyRequest.DetailsCase = {
  DETAILS_NOT_SET: 0,
  ANOMALY_V1: 5
};

/**
 * @return {proto.entity.UpdateAnomalyRequest.DetailsCase}
 */
proto.entity.UpdateAnomalyRequest.prototype.getDetailsCase = function() {
  return /** @type {proto.entity.UpdateAnomalyRequest.DetailsCase} */(jspb.Message.computeOneofCase(this, proto.entity.UpdateAnomalyRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateAnomalyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateAnomalyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateAnomalyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateAnomalyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    anomalyId: (f = msg.getAnomalyId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    anomalyV1: (f = msg.getAnomalyV1()) && proto_entity_anomaly_pb.AnomalyV1.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateAnomalyRequest}
 */
proto.entity.UpdateAnomalyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateAnomalyRequest;
  return proto.entity.UpdateAnomalyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateAnomalyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateAnomalyRequest}
 */
proto.entity.UpdateAnomalyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setAnomalyId(value);
      break;
    case 5:
      var value = new proto_entity_anomaly_pb.AnomalyV1;
      reader.readMessage(value,proto_entity_anomaly_pb.AnomalyV1.deserializeBinaryFromReader);
      msg.setAnomalyV1(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateAnomalyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateAnomalyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateAnomalyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateAnomalyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getAnomalyId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getAnomalyV1();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto_entity_anomaly_pb.AnomalyV1.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateAnomalyRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateAnomalyRequest} returns this
*/
proto.entity.UpdateAnomalyRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateAnomalyRequest} returns this
 */
proto.entity.UpdateAnomalyRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateAnomalyRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID anomaly_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UpdateAnomalyRequest.prototype.getAnomalyId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UpdateAnomalyRequest} returns this
*/
proto.entity.UpdateAnomalyRequest.prototype.setAnomalyId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateAnomalyRequest} returns this
 */
proto.entity.UpdateAnomalyRequest.prototype.clearAnomalyId = function() {
  return this.setAnomalyId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateAnomalyRequest.prototype.hasAnomalyId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional AnomalyV1 anomaly_v1 = 5;
 * @return {?proto.entity.AnomalyV1}
 */
proto.entity.UpdateAnomalyRequest.prototype.getAnomalyV1 = function() {
  return /** @type{?proto.entity.AnomalyV1} */ (
    jspb.Message.getWrapperField(this, proto_entity_anomaly_pb.AnomalyV1, 5));
};


/**
 * @param {?proto.entity.AnomalyV1|undefined} value
 * @return {!proto.entity.UpdateAnomalyRequest} returns this
*/
proto.entity.UpdateAnomalyRequest.prototype.setAnomalyV1 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.entity.UpdateAnomalyRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateAnomalyRequest} returns this
 */
proto.entity.UpdateAnomalyRequest.prototype.clearAnomalyV1 = function() {
  return this.setAnomalyV1(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateAnomalyRequest.prototype.hasAnomalyV1 = function() {
  return jspb.Message.getField(this, 5) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateAnomalyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateAnomalyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateAnomalyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateAnomalyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    anomaly: (f = msg.getAnomaly()) && proto_entity_anomaly_pb.Anomaly.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateAnomalyReply}
 */
proto.entity.UpdateAnomalyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateAnomalyReply;
  return proto.entity.UpdateAnomalyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateAnomalyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateAnomalyReply}
 */
proto.entity.UpdateAnomalyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_anomaly_pb.Anomaly;
      reader.readMessage(value,proto_entity_anomaly_pb.Anomaly.deserializeBinaryFromReader);
      msg.setAnomaly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateAnomalyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateAnomalyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateAnomalyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateAnomalyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAnomaly();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_anomaly_pb.Anomaly.serializeBinaryToWriter
    );
  }
};


/**
 * optional Anomaly anomaly = 1;
 * @return {?proto.entity.Anomaly}
 */
proto.entity.UpdateAnomalyReply.prototype.getAnomaly = function() {
  return /** @type{?proto.entity.Anomaly} */ (
    jspb.Message.getWrapperField(this, proto_entity_anomaly_pb.Anomaly, 1));
};


/**
 * @param {?proto.entity.Anomaly|undefined} value
 * @return {!proto.entity.UpdateAnomalyReply} returns this
*/
proto.entity.UpdateAnomalyReply.prototype.setAnomaly = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateAnomalyReply} returns this
 */
proto.entity.UpdateAnomalyReply.prototype.clearAnomaly = function() {
  return this.setAnomaly(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateAnomalyReply.prototype.hasAnomaly = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListIssueCommentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListIssueCommentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListIssueCommentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssueCommentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    issueId: (f = msg.getIssueId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListIssueCommentsRequest}
 */
proto.entity.ListIssueCommentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListIssueCommentsRequest;
  return proto.entity.ListIssueCommentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListIssueCommentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListIssueCommentsRequest}
 */
proto.entity.ListIssueCommentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setIssueId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListIssueCommentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListIssueCommentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListIssueCommentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssueCommentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getIssueId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListIssueCommentsRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListIssueCommentsRequest} returns this
*/
proto.entity.ListIssueCommentsRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssueCommentsRequest} returns this
 */
proto.entity.ListIssueCommentsRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssueCommentsRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID issue_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.ListIssueCommentsRequest.prototype.getIssueId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.ListIssueCommentsRequest} returns this
*/
proto.entity.ListIssueCommentsRequest.prototype.setIssueId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListIssueCommentsRequest} returns this
 */
proto.entity.ListIssueCommentsRequest.prototype.clearIssueId = function() {
  return this.setIssueId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListIssueCommentsRequest.prototype.hasIssueId = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListIssueCommentsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListIssueCommentsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListIssueCommentsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListIssueCommentsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssueCommentsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    commentsList: jspb.Message.toObjectList(msg.getCommentsList(),
    proto_entity_comment_pb.Comment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListIssueCommentsReply}
 */
proto.entity.ListIssueCommentsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListIssueCommentsReply;
  return proto.entity.ListIssueCommentsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListIssueCommentsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListIssueCommentsReply}
 */
proto.entity.ListIssueCommentsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_comment_pb.Comment;
      reader.readMessage(value,proto_entity_comment_pb.Comment.deserializeBinaryFromReader);
      msg.addComments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListIssueCommentsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListIssueCommentsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListIssueCommentsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListIssueCommentsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_comment_pb.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Comment comments = 1;
 * @return {!Array<!proto.entity.Comment>}
 */
proto.entity.ListIssueCommentsReply.prototype.getCommentsList = function() {
  return /** @type{!Array<!proto.entity.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_comment_pb.Comment, 1));
};


/**
 * @param {!Array<!proto.entity.Comment>} value
 * @return {!proto.entity.ListIssueCommentsReply} returns this
*/
proto.entity.ListIssueCommentsReply.prototype.setCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Comment}
 */
proto.entity.ListIssueCommentsReply.prototype.addComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListIssueCommentsReply} returns this
 */
proto.entity.ListIssueCommentsReply.prototype.clearCommentsList = function() {
  return this.setCommentsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.GetSessionInfoRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GetSessionInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GetSessionInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GetSessionInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetSessionInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    includeSitesList: jspb.Message.toObjectList(msg.getIncludeSitesList(),
    proto_entity_site_pb.SiteSelector.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GetSessionInfoRequest}
 */
proto.entity.GetSessionInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GetSessionInfoRequest;
  return proto.entity.GetSessionInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GetSessionInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GetSessionInfoRequest}
 */
proto.entity.GetSessionInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.addIncludeSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GetSessionInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GetSessionInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GetSessionInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetSessionInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludeSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SiteSelector include_sites = 1;
 * @return {!Array<!proto.entity.SiteSelector>}
 */
proto.entity.GetSessionInfoRequest.prototype.getIncludeSitesList = function() {
  return /** @type{!Array<!proto.entity.SiteSelector>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {!Array<!proto.entity.SiteSelector>} value
 * @return {!proto.entity.GetSessionInfoRequest} returns this
*/
proto.entity.GetSessionInfoRequest.prototype.setIncludeSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SiteSelector=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteSelector}
 */
proto.entity.GetSessionInfoRequest.prototype.addIncludeSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SiteSelector, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.GetSessionInfoRequest} returns this
 */
proto.entity.GetSessionInfoRequest.prototype.clearIncludeSitesList = function() {
  return this.setIncludeSitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GetSessionInfoReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GetSessionInfoReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GetSessionInfoReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetSessionInfoReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionInfo: (f = msg.getSessionInfo()) && proto.entity.SessionInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GetSessionInfoReply}
 */
proto.entity.GetSessionInfoReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GetSessionInfoReply;
  return proto.entity.GetSessionInfoReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GetSessionInfoReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GetSessionInfoReply}
 */
proto.entity.GetSessionInfoReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 7:
      var value = new proto.entity.SessionInfo;
      reader.readMessage(value,proto.entity.SessionInfo.deserializeBinaryFromReader);
      msg.setSessionInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GetSessionInfoReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GetSessionInfoReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GetSessionInfoReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetSessionInfoReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionInfo();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.entity.SessionInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional SessionInfo session_info = 7;
 * @return {?proto.entity.SessionInfo}
 */
proto.entity.GetSessionInfoReply.prototype.getSessionInfo = function() {
  return /** @type{?proto.entity.SessionInfo} */ (
    jspb.Message.getWrapperField(this, proto.entity.SessionInfo, 7));
};


/**
 * @param {?proto.entity.SessionInfo|undefined} value
 * @return {!proto.entity.GetSessionInfoReply} returns this
*/
proto.entity.GetSessionInfoReply.prototype.setSessionInfo = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.GetSessionInfoReply} returns this
 */
proto.entity.GetSessionInfoReply.prototype.clearSessionInfo = function() {
  return this.setSessionInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.GetSessionInfoReply.prototype.hasSessionInfo = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionId: (f = msg.getSessionId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSessionRequest}
 */
proto.entity.LookupSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSessionRequest;
  return proto.entity.LookupSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSessionRequest}
 */
proto.entity.LookupSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID session_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.LookupSessionRequest.prototype.getSessionId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.LookupSessionRequest} returns this
*/
proto.entity.LookupSessionRequest.prototype.setSessionId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSessionRequest} returns this
 */
proto.entity.LookupSessionRequest.prototype.clearSessionId = function() {
  return this.setSessionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSessionRequest.prototype.hasSessionId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSessionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSessionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSessionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSessionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionInfo: (f = msg.getSessionInfo()) && proto.entity.SessionInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSessionReply}
 */
proto.entity.LookupSessionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSessionReply;
  return proto.entity.LookupSessionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSessionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSessionReply}
 */
proto.entity.LookupSessionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.SessionInfo;
      reader.readMessage(value,proto.entity.SessionInfo.deserializeBinaryFromReader);
      msg.setSessionInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSessionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSessionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSessionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSessionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.SessionInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional SessionInfo session_info = 1;
 * @return {?proto.entity.SessionInfo}
 */
proto.entity.LookupSessionReply.prototype.getSessionInfo = function() {
  return /** @type{?proto.entity.SessionInfo} */ (
    jspb.Message.getWrapperField(this, proto.entity.SessionInfo, 1));
};


/**
 * @param {?proto.entity.SessionInfo|undefined} value
 * @return {!proto.entity.LookupSessionReply} returns this
*/
proto.entity.LookupSessionReply.prototype.setSessionInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSessionReply} returns this
 */
proto.entity.LookupSessionReply.prototype.clearSessionInfo = function() {
  return this.setSessionInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSessionReply.prototype.hasSessionInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.SessionInfo.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SessionInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SessionInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SessionInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SessionInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    session: (f = msg.getSession()) && proto_entity_session_pb.Session.toObject(includeInstance, f),
    user: (f = msg.getUser()) && proto_entity_user_pb.User.toObject(includeInstance, f),
    userIdentity: (f = msg.getUserIdentity()) && proto_entity_userIdentity_pb.UserIdentity.toObject(includeInstance, f),
    siteUserSitesList: jspb.Message.toObjectList(msg.getSiteUserSitesList(),
    proto.entity.SessionInfo.SiteUserSite.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SessionInfo}
 */
proto.entity.SessionInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SessionInfo;
  return proto.entity.SessionInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SessionInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SessionInfo}
 */
proto.entity.SessionInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_session_pb.Session;
      reader.readMessage(value,proto_entity_session_pb.Session.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.User;
      reader.readMessage(value,proto_entity_user_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 3:
      var value = new proto_entity_userIdentity_pb.UserIdentity;
      reader.readMessage(value,proto_entity_userIdentity_pb.UserIdentity.deserializeBinaryFromReader);
      msg.setUserIdentity(value);
      break;
    case 4:
      var value = new proto.entity.SessionInfo.SiteUserSite;
      reader.readMessage(value,proto.entity.SessionInfo.SiteUserSite.deserializeBinaryFromReader);
      msg.addSiteUserSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SessionInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SessionInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SessionInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SessionInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_session_pb.Session.serializeBinaryToWriter
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_user_pb.User.serializeBinaryToWriter
    );
  }
  f = message.getUserIdentity();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_entity_userIdentity_pb.UserIdentity.serializeBinaryToWriter
    );
  }
  f = message.getSiteUserSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.entity.SessionInfo.SiteUserSite.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SessionInfo.SiteUserSite.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SessionInfo.SiteUserSite.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SessionInfo.SiteUserSite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SessionInfo.SiteUserSite.toObject = function(includeInstance, msg) {
  var f, obj = {
    site: (f = msg.getSite()) && proto_entity_site_pb.Site.toObject(includeInstance, f),
    userSite: (f = msg.getUserSite()) && proto_entity_user_pb.UserSiteMapping.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SessionInfo.SiteUserSite}
 */
proto.entity.SessionInfo.SiteUserSite.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SessionInfo.SiteUserSite;
  return proto.entity.SessionInfo.SiteUserSite.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SessionInfo.SiteUserSite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SessionInfo.SiteUserSite}
 */
proto.entity.SessionInfo.SiteUserSite.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.setSite(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.UserSiteMapping;
      reader.readMessage(value,proto_entity_user_pb.UserSiteMapping.deserializeBinaryFromReader);
      msg.setUserSite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SessionInfo.SiteUserSite.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SessionInfo.SiteUserSite.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SessionInfo.SiteUserSite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SessionInfo.SiteUserSite.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSite();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
  f = message.getUserSite();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_user_pb.UserSiteMapping.serializeBinaryToWriter
    );
  }
};


/**
 * optional Site site = 1;
 * @return {?proto.entity.Site}
 */
proto.entity.SessionInfo.SiteUserSite.prototype.getSite = function() {
  return /** @type{?proto.entity.Site} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.Site, 1));
};


/**
 * @param {?proto.entity.Site|undefined} value
 * @return {!proto.entity.SessionInfo.SiteUserSite} returns this
*/
proto.entity.SessionInfo.SiteUserSite.prototype.setSite = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SessionInfo.SiteUserSite} returns this
 */
proto.entity.SessionInfo.SiteUserSite.prototype.clearSite = function() {
  return this.setSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SessionInfo.SiteUserSite.prototype.hasSite = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional UserSiteMapping user_site = 2;
 * @return {?proto.entity.UserSiteMapping}
 */
proto.entity.SessionInfo.SiteUserSite.prototype.getUserSite = function() {
  return /** @type{?proto.entity.UserSiteMapping} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSiteMapping, 2));
};


/**
 * @param {?proto.entity.UserSiteMapping|undefined} value
 * @return {!proto.entity.SessionInfo.SiteUserSite} returns this
*/
proto.entity.SessionInfo.SiteUserSite.prototype.setUserSite = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SessionInfo.SiteUserSite} returns this
 */
proto.entity.SessionInfo.SiteUserSite.prototype.clearUserSite = function() {
  return this.setUserSite(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SessionInfo.SiteUserSite.prototype.hasUserSite = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Session session = 1;
 * @return {?proto.entity.Session}
 */
proto.entity.SessionInfo.prototype.getSession = function() {
  return /** @type{?proto.entity.Session} */ (
    jspb.Message.getWrapperField(this, proto_entity_session_pb.Session, 1));
};


/**
 * @param {?proto.entity.Session|undefined} value
 * @return {!proto.entity.SessionInfo} returns this
*/
proto.entity.SessionInfo.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SessionInfo} returns this
 */
proto.entity.SessionInfo.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SessionInfo.prototype.hasSession = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional User user = 2;
 * @return {?proto.entity.User}
 */
proto.entity.SessionInfo.prototype.getUser = function() {
  return /** @type{?proto.entity.User} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.User, 2));
};


/**
 * @param {?proto.entity.User|undefined} value
 * @return {!proto.entity.SessionInfo} returns this
*/
proto.entity.SessionInfo.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SessionInfo} returns this
 */
proto.entity.SessionInfo.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SessionInfo.prototype.hasUser = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional UserIdentity user_identity = 3;
 * @return {?proto.entity.UserIdentity}
 */
proto.entity.SessionInfo.prototype.getUserIdentity = function() {
  return /** @type{?proto.entity.UserIdentity} */ (
    jspb.Message.getWrapperField(this, proto_entity_userIdentity_pb.UserIdentity, 3));
};


/**
 * @param {?proto.entity.UserIdentity|undefined} value
 * @return {!proto.entity.SessionInfo} returns this
*/
proto.entity.SessionInfo.prototype.setUserIdentity = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SessionInfo} returns this
 */
proto.entity.SessionInfo.prototype.clearUserIdentity = function() {
  return this.setUserIdentity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SessionInfo.prototype.hasUserIdentity = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated SiteUserSite site_user_sites = 4;
 * @return {!Array<!proto.entity.SessionInfo.SiteUserSite>}
 */
proto.entity.SessionInfo.prototype.getSiteUserSitesList = function() {
  return /** @type{!Array<!proto.entity.SessionInfo.SiteUserSite>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.SessionInfo.SiteUserSite, 4));
};


/**
 * @param {!Array<!proto.entity.SessionInfo.SiteUserSite>} value
 * @return {!proto.entity.SessionInfo} returns this
*/
proto.entity.SessionInfo.prototype.setSiteUserSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.entity.SessionInfo.SiteUserSite=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SessionInfo.SiteUserSite}
 */
proto.entity.SessionInfo.prototype.addSiteUserSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.entity.SessionInfo.SiteUserSite, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SessionInfo} returns this
 */
proto.entity.SessionInfo.prototype.clearSiteUserSitesList = function() {
  return this.setSiteUserSitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LogInRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LogInRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LogInRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    authentication: (f = msg.getAuthentication()) && proto.entity.LogInRequest.Authentication.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LogInRequest}
 */
proto.entity.LogInRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LogInRequest;
  return proto.entity.LogInRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LogInRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LogInRequest}
 */
proto.entity.LogInRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto.entity.LogInRequest.Authentication;
      reader.readMessage(value,proto.entity.LogInRequest.Authentication.deserializeBinaryFromReader);
      msg.setAuthentication(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LogInRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LogInRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LogInRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getAuthentication();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.LogInRequest.Authentication.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.LogInRequest.Authentication.oneofGroups_ = [[1,2,3,4]];

/**
 * @enum {number}
 */
proto.entity.LogInRequest.Authentication.TypeCase = {
  TYPE_NOT_SET: 0,
  AUTH0: 1,
  SHOPIFY: 2,
  BIG_COMMERCE: 3,
  GOOGLE: 4
};

/**
 * @return {proto.entity.LogInRequest.Authentication.TypeCase}
 */
proto.entity.LogInRequest.Authentication.prototype.getTypeCase = function() {
  return /** @type {proto.entity.LogInRequest.Authentication.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.LogInRequest.Authentication.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LogInRequest.Authentication.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LogInRequest.Authentication.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LogInRequest.Authentication} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Authentication.toObject = function(includeInstance, msg) {
  var f, obj = {
    auth0: (f = msg.getAuth0()) && proto.entity.LogInRequest.Auth0.toObject(includeInstance, f),
    shopify: (f = msg.getShopify()) && proto.entity.LogInRequest.Shopify.toObject(includeInstance, f),
    bigCommerce: (f = msg.getBigCommerce()) && proto.entity.LogInRequest.BigCommerce.toObject(includeInstance, f),
    google: (f = msg.getGoogle()) && proto.entity.LogInRequest.Google.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LogInRequest.Authentication}
 */
proto.entity.LogInRequest.Authentication.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LogInRequest.Authentication;
  return proto.entity.LogInRequest.Authentication.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LogInRequest.Authentication} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LogInRequest.Authentication}
 */
proto.entity.LogInRequest.Authentication.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.LogInRequest.Auth0;
      reader.readMessage(value,proto.entity.LogInRequest.Auth0.deserializeBinaryFromReader);
      msg.setAuth0(value);
      break;
    case 2:
      var value = new proto.entity.LogInRequest.Shopify;
      reader.readMessage(value,proto.entity.LogInRequest.Shopify.deserializeBinaryFromReader);
      msg.setShopify(value);
      break;
    case 3:
      var value = new proto.entity.LogInRequest.BigCommerce;
      reader.readMessage(value,proto.entity.LogInRequest.BigCommerce.deserializeBinaryFromReader);
      msg.setBigCommerce(value);
      break;
    case 4:
      var value = new proto.entity.LogInRequest.Google;
      reader.readMessage(value,proto.entity.LogInRequest.Google.deserializeBinaryFromReader);
      msg.setGoogle(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LogInRequest.Authentication.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LogInRequest.Authentication.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LogInRequest.Authentication} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Authentication.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuth0();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.LogInRequest.Auth0.serializeBinaryToWriter
    );
  }
  f = message.getShopify();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.LogInRequest.Shopify.serializeBinaryToWriter
    );
  }
  f = message.getBigCommerce();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.LogInRequest.BigCommerce.serializeBinaryToWriter
    );
  }
  f = message.getGoogle();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.LogInRequest.Google.serializeBinaryToWriter
    );
  }
};


/**
 * optional Auth0 auth0 = 1;
 * @return {?proto.entity.LogInRequest.Auth0}
 */
proto.entity.LogInRequest.Authentication.prototype.getAuth0 = function() {
  return /** @type{?proto.entity.LogInRequest.Auth0} */ (
    jspb.Message.getWrapperField(this, proto.entity.LogInRequest.Auth0, 1));
};


/**
 * @param {?proto.entity.LogInRequest.Auth0|undefined} value
 * @return {!proto.entity.LogInRequest.Authentication} returns this
*/
proto.entity.LogInRequest.Authentication.prototype.setAuth0 = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.LogInRequest.Authentication.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInRequest.Authentication} returns this
 */
proto.entity.LogInRequest.Authentication.prototype.clearAuth0 = function() {
  return this.setAuth0(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.Authentication.prototype.hasAuth0 = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Shopify shopify = 2;
 * @return {?proto.entity.LogInRequest.Shopify}
 */
proto.entity.LogInRequest.Authentication.prototype.getShopify = function() {
  return /** @type{?proto.entity.LogInRequest.Shopify} */ (
    jspb.Message.getWrapperField(this, proto.entity.LogInRequest.Shopify, 2));
};


/**
 * @param {?proto.entity.LogInRequest.Shopify|undefined} value
 * @return {!proto.entity.LogInRequest.Authentication} returns this
*/
proto.entity.LogInRequest.Authentication.prototype.setShopify = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.entity.LogInRequest.Authentication.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInRequest.Authentication} returns this
 */
proto.entity.LogInRequest.Authentication.prototype.clearShopify = function() {
  return this.setShopify(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.Authentication.prototype.hasShopify = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional BigCommerce big_commerce = 3;
 * @return {?proto.entity.LogInRequest.BigCommerce}
 */
proto.entity.LogInRequest.Authentication.prototype.getBigCommerce = function() {
  return /** @type{?proto.entity.LogInRequest.BigCommerce} */ (
    jspb.Message.getWrapperField(this, proto.entity.LogInRequest.BigCommerce, 3));
};


/**
 * @param {?proto.entity.LogInRequest.BigCommerce|undefined} value
 * @return {!proto.entity.LogInRequest.Authentication} returns this
*/
proto.entity.LogInRequest.Authentication.prototype.setBigCommerce = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.entity.LogInRequest.Authentication.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInRequest.Authentication} returns this
 */
proto.entity.LogInRequest.Authentication.prototype.clearBigCommerce = function() {
  return this.setBigCommerce(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.Authentication.prototype.hasBigCommerce = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Google google = 4;
 * @return {?proto.entity.LogInRequest.Google}
 */
proto.entity.LogInRequest.Authentication.prototype.getGoogle = function() {
  return /** @type{?proto.entity.LogInRequest.Google} */ (
    jspb.Message.getWrapperField(this, proto.entity.LogInRequest.Google, 4));
};


/**
 * @param {?proto.entity.LogInRequest.Google|undefined} value
 * @return {!proto.entity.LogInRequest.Authentication} returns this
*/
proto.entity.LogInRequest.Authentication.prototype.setGoogle = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.entity.LogInRequest.Authentication.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInRequest.Authentication} returns this
 */
proto.entity.LogInRequest.Authentication.prototype.clearGoogle = function() {
  return this.setGoogle(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.Authentication.prototype.hasGoogle = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LogInRequest.Auth0.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LogInRequest.Auth0.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LogInRequest.Auth0} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Auth0.toObject = function(includeInstance, msg) {
  var f, obj = {
    idToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LogInRequest.Auth0}
 */
proto.entity.LogInRequest.Auth0.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LogInRequest.Auth0;
  return proto.entity.LogInRequest.Auth0.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LogInRequest.Auth0} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LogInRequest.Auth0}
 */
proto.entity.LogInRequest.Auth0.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LogInRequest.Auth0.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LogInRequest.Auth0.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LogInRequest.Auth0} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Auth0.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIdToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id_token = 1;
 * @return {string}
 */
proto.entity.LogInRequest.Auth0.prototype.getIdToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LogInRequest.Auth0} returns this
 */
proto.entity.LogInRequest.Auth0.prototype.setIdToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LogInRequest.Shopify.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LogInRequest.Shopify.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LogInRequest.Shopify} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Shopify.toObject = function(includeInstance, msg) {
  var f, obj = {
    onlineQuery: jspb.Message.getFieldWithDefault(msg, 1, ""),
    offlineQuery: jspb.Message.getFieldWithDefault(msg, 2, ""),
    utmParameters: (f = msg.getUtmParameters()) && proto_common_utmParameters_pb.UTMParameters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LogInRequest.Shopify}
 */
proto.entity.LogInRequest.Shopify.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LogInRequest.Shopify;
  return proto.entity.LogInRequest.Shopify.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LogInRequest.Shopify} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LogInRequest.Shopify}
 */
proto.entity.LogInRequest.Shopify.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnlineQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOfflineQuery(value);
      break;
    case 3:
      var value = new proto_common_utmParameters_pb.UTMParameters;
      reader.readMessage(value,proto_common_utmParameters_pb.UTMParameters.deserializeBinaryFromReader);
      msg.setUtmParameters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LogInRequest.Shopify.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LogInRequest.Shopify.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LogInRequest.Shopify} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Shopify.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOnlineQuery();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOfflineQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUtmParameters();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_common_utmParameters_pb.UTMParameters.serializeBinaryToWriter
    );
  }
};


/**
 * optional string online_query = 1;
 * @return {string}
 */
proto.entity.LogInRequest.Shopify.prototype.getOnlineQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LogInRequest.Shopify} returns this
 */
proto.entity.LogInRequest.Shopify.prototype.setOnlineQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string offline_query = 2;
 * @return {string}
 */
proto.entity.LogInRequest.Shopify.prototype.getOfflineQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LogInRequest.Shopify} returns this
 */
proto.entity.LogInRequest.Shopify.prototype.setOfflineQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional common.UTMParameters utm_parameters = 3;
 * @return {?proto.common.UTMParameters}
 */
proto.entity.LogInRequest.Shopify.prototype.getUtmParameters = function() {
  return /** @type{?proto.common.UTMParameters} */ (
    jspb.Message.getWrapperField(this, proto_common_utmParameters_pb.UTMParameters, 3));
};


/**
 * @param {?proto.common.UTMParameters|undefined} value
 * @return {!proto.entity.LogInRequest.Shopify} returns this
*/
proto.entity.LogInRequest.Shopify.prototype.setUtmParameters = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInRequest.Shopify} returns this
 */
proto.entity.LogInRequest.Shopify.prototype.clearUtmParameters = function() {
  return this.setUtmParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.Shopify.prototype.hasUtmParameters = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.LogInRequest.BigCommerce.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.entity.LogInRequest.BigCommerce.TypeCase = {
  TYPE_NOT_SET: 0,
  AUTH_QUERY: 1,
  LOAD_QUERY: 2
};

/**
 * @return {proto.entity.LogInRequest.BigCommerce.TypeCase}
 */
proto.entity.LogInRequest.BigCommerce.prototype.getTypeCase = function() {
  return /** @type {proto.entity.LogInRequest.BigCommerce.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.LogInRequest.BigCommerce.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LogInRequest.BigCommerce.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LogInRequest.BigCommerce.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LogInRequest.BigCommerce} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.BigCommerce.toObject = function(includeInstance, msg) {
  var f, obj = {
    authQuery: jspb.Message.getFieldWithDefault(msg, 1, ""),
    loadQuery: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LogInRequest.BigCommerce}
 */
proto.entity.LogInRequest.BigCommerce.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LogInRequest.BigCommerce;
  return proto.entity.LogInRequest.BigCommerce.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LogInRequest.BigCommerce} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LogInRequest.BigCommerce}
 */
proto.entity.LogInRequest.BigCommerce.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthQuery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLoadQuery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LogInRequest.BigCommerce.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LogInRequest.BigCommerce.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LogInRequest.BigCommerce} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.BigCommerce.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string auth_query = 1;
 * @return {string}
 */
proto.entity.LogInRequest.BigCommerce.prototype.getAuthQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LogInRequest.BigCommerce} returns this
 */
proto.entity.LogInRequest.BigCommerce.prototype.setAuthQuery = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.entity.LogInRequest.BigCommerce.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.entity.LogInRequest.BigCommerce} returns this
 */
proto.entity.LogInRequest.BigCommerce.prototype.clearAuthQuery = function() {
  return jspb.Message.setOneofField(this, 1, proto.entity.LogInRequest.BigCommerce.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.BigCommerce.prototype.hasAuthQuery = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string load_query = 2;
 * @return {string}
 */
proto.entity.LogInRequest.BigCommerce.prototype.getLoadQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LogInRequest.BigCommerce} returns this
 */
proto.entity.LogInRequest.BigCommerce.prototype.setLoadQuery = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.entity.LogInRequest.BigCommerce.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.entity.LogInRequest.BigCommerce} returns this
 */
proto.entity.LogInRequest.BigCommerce.prototype.clearLoadQuery = function() {
  return jspb.Message.setOneofField(this, 2, proto.entity.LogInRequest.BigCommerce.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.BigCommerce.prototype.hasLoadQuery = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LogInRequest.Google.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LogInRequest.Google.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LogInRequest.Google} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Google.toObject = function(includeInstance, msg) {
  var f, obj = {
    accessToken: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LogInRequest.Google}
 */
proto.entity.LogInRequest.Google.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LogInRequest.Google;
  return proto.entity.LogInRequest.Google.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LogInRequest.Google} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LogInRequest.Google}
 */
proto.entity.LogInRequest.Google.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccessToken(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LogInRequest.Google.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LogInRequest.Google.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LogInRequest.Google} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInRequest.Google.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccessToken();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string access_token = 1;
 * @return {string}
 */
proto.entity.LogInRequest.Google.prototype.getAccessToken = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.LogInRequest.Google} returns this
 */
proto.entity.LogInRequest.Google.prototype.setAccessToken = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LogInRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LogInRequest} returns this
*/
proto.entity.LogInRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInRequest} returns this
 */
proto.entity.LogInRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Authentication authentication = 2;
 * @return {?proto.entity.LogInRequest.Authentication}
 */
proto.entity.LogInRequest.prototype.getAuthentication = function() {
  return /** @type{?proto.entity.LogInRequest.Authentication} */ (
    jspb.Message.getWrapperField(this, proto.entity.LogInRequest.Authentication, 2));
};


/**
 * @param {?proto.entity.LogInRequest.Authentication|undefined} value
 * @return {!proto.entity.LogInRequest} returns this
*/
proto.entity.LogInRequest.prototype.setAuthentication = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInRequest} returns this
 */
proto.entity.LogInRequest.prototype.clearAuthentication = function() {
  return this.setAuthentication(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInRequest.prototype.hasAuthentication = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LogInReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LogInReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LogInReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    sessionInfo: (f = msg.getSessionInfo()) && proto.entity.SessionInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LogInReply}
 */
proto.entity.LogInReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LogInReply;
  return proto.entity.LogInReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LogInReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LogInReply}
 */
proto.entity.LogInReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.SessionInfo;
      reader.readMessage(value,proto.entity.SessionInfo.deserializeBinaryFromReader);
      msg.setSessionInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LogInReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LogInReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LogInReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LogInReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSessionInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.SessionInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional SessionInfo session_info = 1;
 * @return {?proto.entity.SessionInfo}
 */
proto.entity.LogInReply.prototype.getSessionInfo = function() {
  return /** @type{?proto.entity.SessionInfo} */ (
    jspb.Message.getWrapperField(this, proto.entity.SessionInfo, 1));
};


/**
 * @param {?proto.entity.SessionInfo|undefined} value
 * @return {!proto.entity.LogInReply} returns this
*/
proto.entity.LogInReply.prototype.setSessionInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LogInReply} returns this
 */
proto.entity.LogInReply.prototype.clearSessionInfo = function() {
  return this.setSessionInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LogInReply.prototype.hasSessionInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateRobotAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateRobotAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateRobotAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateRobotAccountRequest}
 */
proto.entity.CreateRobotAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateRobotAccountRequest;
  return proto.entity.CreateRobotAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateRobotAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateRobotAccountRequest}
 */
proto.entity.CreateRobotAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateRobotAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateRobotAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateRobotAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.entity.CreateRobotAccountRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateRobotAccountRequest} returns this
 */
proto.entity.CreateRobotAccountRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateRobotAccountReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateRobotAccountReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateRobotAccountReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotAccountReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    robotAccount: (f = msg.getRobotAccount()) && proto_entity_user_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateRobotAccountReply}
 */
proto.entity.CreateRobotAccountReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateRobotAccountReply;
  return proto.entity.CreateRobotAccountReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateRobotAccountReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateRobotAccountReply}
 */
proto.entity.CreateRobotAccountReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.User;
      reader.readMessage(value,proto_entity_user_pb.User.deserializeBinaryFromReader);
      msg.setRobotAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateRobotAccountReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateRobotAccountReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateRobotAccountReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotAccountReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRobotAccount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional User robot_account = 1;
 * @return {?proto.entity.User}
 */
proto.entity.CreateRobotAccountReply.prototype.getRobotAccount = function() {
  return /** @type{?proto.entity.User} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.User, 1));
};


/**
 * @param {?proto.entity.User|undefined} value
 * @return {!proto.entity.CreateRobotAccountReply} returns this
*/
proto.entity.CreateRobotAccountReply.prototype.setRobotAccount = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateRobotAccountReply} returns this
 */
proto.entity.CreateRobotAccountReply.prototype.clearRobotAccount = function() {
  return this.setRobotAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateRobotAccountReply.prototype.hasRobotAccount = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateRobotSessionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateRobotSessionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateRobotSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotSessionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    robotUserId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateRobotSessionRequest}
 */
proto.entity.CreateRobotSessionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateRobotSessionRequest;
  return proto.entity.CreateRobotSessionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateRobotSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateRobotSessionRequest}
 */
proto.entity.CreateRobotSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRobotUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateRobotSessionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateRobotSessionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateRobotSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotSessionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRobotUserId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string robot_user_id = 1;
 * @return {string}
 */
proto.entity.CreateRobotSessionRequest.prototype.getRobotUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateRobotSessionRequest} returns this
 */
proto.entity.CreateRobotSessionRequest.prototype.setRobotUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateRobotSessionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateRobotSessionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateRobotSessionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotSessionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    session: (f = msg.getSession()) && proto_entity_session_pb.Session.toObject(includeInstance, f),
    robotAccount: (f = msg.getRobotAccount()) && proto_entity_user_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateRobotSessionReply}
 */
proto.entity.CreateRobotSessionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateRobotSessionReply;
  return proto.entity.CreateRobotSessionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateRobotSessionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateRobotSessionReply}
 */
proto.entity.CreateRobotSessionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_session_pb.Session;
      reader.readMessage(value,proto_entity_session_pb.Session.deserializeBinaryFromReader);
      msg.setSession(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.User;
      reader.readMessage(value,proto_entity_user_pb.User.deserializeBinaryFromReader);
      msg.setRobotAccount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateRobotSessionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateRobotSessionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateRobotSessionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateRobotSessionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSession();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_session_pb.Session.serializeBinaryToWriter
    );
  }
  f = message.getRobotAccount();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_user_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional Session session = 1;
 * @return {?proto.entity.Session}
 */
proto.entity.CreateRobotSessionReply.prototype.getSession = function() {
  return /** @type{?proto.entity.Session} */ (
    jspb.Message.getWrapperField(this, proto_entity_session_pb.Session, 1));
};


/**
 * @param {?proto.entity.Session|undefined} value
 * @return {!proto.entity.CreateRobotSessionReply} returns this
*/
proto.entity.CreateRobotSessionReply.prototype.setSession = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateRobotSessionReply} returns this
 */
proto.entity.CreateRobotSessionReply.prototype.clearSession = function() {
  return this.setSession(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateRobotSessionReply.prototype.hasSession = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional User robot_account = 2;
 * @return {?proto.entity.User}
 */
proto.entity.CreateRobotSessionReply.prototype.getRobotAccount = function() {
  return /** @type{?proto.entity.User} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.User, 2));
};


/**
 * @param {?proto.entity.User|undefined} value
 * @return {!proto.entity.CreateRobotSessionReply} returns this
*/
proto.entity.CreateRobotSessionReply.prototype.setRobotAccount = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateRobotSessionReply} returns this
 */
proto.entity.CreateRobotSessionReply.prototype.clearRobotAccount = function() {
  return this.setRobotAccount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateRobotSessionReply.prototype.hasRobotAccount = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GetAppURLRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GetAppURLRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GetAppURLRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetAppURLRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    path: jspb.Message.getFieldWithDefault(msg, 1, ""),
    escapedQuery: jspb.Message.getFieldWithDefault(msg, 2, ""),
    fragment: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GetAppURLRequest}
 */
proto.entity.GetAppURLRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GetAppURLRequest;
  return proto.entity.GetAppURLRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GetAppURLRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GetAppURLRequest}
 */
proto.entity.GetAppURLRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPath(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEscapedQuery(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFragment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GetAppURLRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GetAppURLRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GetAppURLRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetAppURLRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPath();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEscapedQuery();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getFragment();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string path = 1;
 * @return {string}
 */
proto.entity.GetAppURLRequest.prototype.getPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.GetAppURLRequest} returns this
 */
proto.entity.GetAppURLRequest.prototype.setPath = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string escaped_query = 2;
 * @return {string}
 */
proto.entity.GetAppURLRequest.prototype.getEscapedQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.GetAppURLRequest} returns this
 */
proto.entity.GetAppURLRequest.prototype.setEscapedQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string fragment = 3;
 * @return {string}
 */
proto.entity.GetAppURLRequest.prototype.getFragment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.GetAppURLRequest} returns this
 */
proto.entity.GetAppURLRequest.prototype.setFragment = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GetAppURLReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GetAppURLReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GetAppURLReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetAppURLReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    url: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GetAppURLReply}
 */
proto.entity.GetAppURLReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GetAppURLReply;
  return proto.entity.GetAppURLReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GetAppURLReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GetAppURLReply}
 */
proto.entity.GetAppURLReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GetAppURLReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GetAppURLReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GetAppURLReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetAppURLReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string url = 1;
 * @return {string}
 */
proto.entity.GetAppURLReply.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.GetAppURLReply} returns this
 */
proto.entity.GetAppURLReply.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userSelector: (f = msg.getUserSelector()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupUserRequest}
 */
proto.entity.LookupUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupUserRequest;
  return proto.entity.LookupUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupUserRequest}
 */
proto.entity.LookupUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setUserSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserSelector user_selector = 1;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.LookupUserRequest.prototype.getUserSelector = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 1));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.LookupUserRequest} returns this
*/
proto.entity.LookupUserRequest.prototype.setUserSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupUserRequest} returns this
 */
proto.entity.LookupUserRequest.prototype.clearUserSelector = function() {
  return this.setUserSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupUserRequest.prototype.hasUserSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupUserReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupUserReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupUserReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupUserReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && proto_entity_user_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupUserReply}
 */
proto.entity.LookupUserReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupUserReply;
  return proto.entity.LookupUserReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupUserReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupUserReply}
 */
proto.entity.LookupUserReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.User;
      reader.readMessage(value,proto_entity_user_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupUserReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupUserReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupUserReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupUserReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.entity.User}
 */
proto.entity.LookupUserReply.prototype.getUser = function() {
  return /** @type{?proto.entity.User} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.User, 1));
};


/**
 * @param {?proto.entity.User|undefined} value
 * @return {!proto.entity.LookupUserReply} returns this
*/
proto.entity.LookupUserReply.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupUserReply} returns this
 */
proto.entity.LookupUserReply.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupUserReply.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListUsersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListUsersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListUsersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListUsersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    globalRole: jspb.Message.getFieldWithDefault(msg, 1, 0),
    emailPattern: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListUsersRequest}
 */
proto.entity.ListUsersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListUsersRequest;
  return proto.entity.ListUsersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListUsersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListUsersRequest}
 */
proto.entity.ListUsersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.entity.GlobalRole.Option} */ (reader.readEnum());
      msg.setGlobalRole(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailPattern(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListUsersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListUsersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListUsersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListUsersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGlobalRole();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getEmailPattern();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional GlobalRole.Option global_role = 1;
 * @return {!proto.entity.GlobalRole.Option}
 */
proto.entity.ListUsersRequest.prototype.getGlobalRole = function() {
  return /** @type {!proto.entity.GlobalRole.Option} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.entity.GlobalRole.Option} value
 * @return {!proto.entity.ListUsersRequest} returns this
 */
proto.entity.ListUsersRequest.prototype.setGlobalRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string email_pattern = 2;
 * @return {string}
 */
proto.entity.ListUsersRequest.prototype.getEmailPattern = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ListUsersRequest} returns this
 */
proto.entity.ListUsersRequest.prototype.setEmailPattern = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListUsersReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListUsersReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListUsersReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListUsersReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListUsersReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto_entity_user_pb.User.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListUsersReply}
 */
proto.entity.ListUsersReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListUsersReply;
  return proto.entity.ListUsersReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListUsersReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListUsersReply}
 */
proto.entity.ListUsersReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.User;
      reader.readMessage(value,proto_entity_user_pb.User.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListUsersReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListUsersReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListUsersReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListUsersReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_user_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * repeated User users = 1;
 * @return {!Array<!proto.entity.User>}
 */
proto.entity.ListUsersReply.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.entity.User>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_user_pb.User, 1));
};


/**
 * @param {!Array<!proto.entity.User>} value
 * @return {!proto.entity.ListUsersReply} returns this
*/
proto.entity.ListUsersReply.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.User=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.User}
 */
proto.entity.ListUsersReply.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.User, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListUsersReply} returns this
 */
proto.entity.ListUsersReply.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateActionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateActionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateActionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateActionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newAction: (f = msg.getNewAction()) && proto_entity_action_pb.NewAction.toObject(includeInstance, f),
    markAsExecuted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    executionTime: (f = msg.getExecutionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateActionRequest}
 */
proto.entity.CreateActionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateActionRequest;
  return proto.entity.CreateActionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateActionRequest}
 */
proto.entity.CreateActionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_action_pb.NewAction;
      reader.readMessage(value,proto_entity_action_pb.NewAction.deserializeBinaryFromReader);
      msg.setNewAction(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarkAsExecuted(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExecutionTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateActionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateActionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateActionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewAction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_action_pb.NewAction.serializeBinaryToWriter
    );
  }
  f = message.getMarkAsExecuted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getExecutionTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewAction new_action = 1;
 * @return {?proto.entity.NewAction}
 */
proto.entity.CreateActionRequest.prototype.getNewAction = function() {
  return /** @type{?proto.entity.NewAction} */ (
    jspb.Message.getWrapperField(this, proto_entity_action_pb.NewAction, 1));
};


/**
 * @param {?proto.entity.NewAction|undefined} value
 * @return {!proto.entity.CreateActionRequest} returns this
*/
proto.entity.CreateActionRequest.prototype.setNewAction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateActionRequest} returns this
 */
proto.entity.CreateActionRequest.prototype.clearNewAction = function() {
  return this.setNewAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateActionRequest.prototype.hasNewAction = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool mark_as_executed = 2;
 * @return {boolean}
 */
proto.entity.CreateActionRequest.prototype.getMarkAsExecuted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.CreateActionRequest} returns this
 */
proto.entity.CreateActionRequest.prototype.setMarkAsExecuted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp execution_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.CreateActionRequest.prototype.getExecutionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.CreateActionRequest} returns this
*/
proto.entity.CreateActionRequest.prototype.setExecutionTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateActionRequest} returns this
 */
proto.entity.CreateActionRequest.prototype.clearExecutionTime = function() {
  return this.setExecutionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateActionRequest.prototype.hasExecutionTime = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateActionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateActionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateActionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateActionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: (f = msg.getAction()) && proto_entity_action_pb.Action.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateActionReply}
 */
proto.entity.CreateActionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateActionReply;
  return proto.entity.CreateActionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateActionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateActionReply}
 */
proto.entity.CreateActionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_action_pb.Action;
      reader.readMessage(value,proto_entity_action_pb.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateActionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateActionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateActionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateActionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_action_pb.Action.serializeBinaryToWriter
    );
  }
};


/**
 * optional Action action = 1;
 * @return {?proto.entity.Action}
 */
proto.entity.CreateActionReply.prototype.getAction = function() {
  return /** @type{?proto.entity.Action} */ (
    jspb.Message.getWrapperField(this, proto_entity_action_pb.Action, 1));
};


/**
 * @param {?proto.entity.Action|undefined} value
 * @return {!proto.entity.CreateActionReply} returns this
*/
proto.entity.CreateActionReply.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateActionReply} returns this
 */
proto.entity.CreateActionReply.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateActionReply.prototype.hasAction = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ExecuteActionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ExecuteActionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ExecuteActionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteActionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: (f = msg.getAction()) && proto_entity_action_pb.Action.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ExecuteActionRequest}
 */
proto.entity.ExecuteActionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ExecuteActionRequest;
  return proto.entity.ExecuteActionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ExecuteActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ExecuteActionRequest}
 */
proto.entity.ExecuteActionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_action_pb.Action;
      reader.readMessage(value,proto_entity_action_pb.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ExecuteActionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ExecuteActionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ExecuteActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteActionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_action_pb.Action.serializeBinaryToWriter
    );
  }
};


/**
 * optional Action action = 1;
 * @return {?proto.entity.Action}
 */
proto.entity.ExecuteActionRequest.prototype.getAction = function() {
  return /** @type{?proto.entity.Action} */ (
    jspb.Message.getWrapperField(this, proto_entity_action_pb.Action, 1));
};


/**
 * @param {?proto.entity.Action|undefined} value
 * @return {!proto.entity.ExecuteActionRequest} returns this
*/
proto.entity.ExecuteActionRequest.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ExecuteActionRequest} returns this
 */
proto.entity.ExecuteActionRequest.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ExecuteActionRequest.prototype.hasAction = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ExecuteActionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ExecuteActionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ExecuteActionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteActionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: (f = msg.getAction()) && proto_entity_action_pb.Action.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ExecuteActionReply}
 */
proto.entity.ExecuteActionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ExecuteActionReply;
  return proto.entity.ExecuteActionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ExecuteActionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ExecuteActionReply}
 */
proto.entity.ExecuteActionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_action_pb.Action;
      reader.readMessage(value,proto_entity_action_pb.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ExecuteActionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ExecuteActionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ExecuteActionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteActionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_action_pb.Action.serializeBinaryToWriter
    );
  }
};


/**
 * optional Action action = 1;
 * @return {?proto.entity.Action}
 */
proto.entity.ExecuteActionReply.prototype.getAction = function() {
  return /** @type{?proto.entity.Action} */ (
    jspb.Message.getWrapperField(this, proto_entity_action_pb.Action, 1));
};


/**
 * @param {?proto.entity.Action|undefined} value
 * @return {!proto.entity.ExecuteActionReply} returns this
*/
proto.entity.ExecuteActionReply.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ExecuteActionReply} returns this
 */
proto.entity.ExecuteActionReply.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ExecuteActionReply.prototype.hasAction = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateActionRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateActionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateActionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateActionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateActionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_action_pb.UpdateActionAction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateActionRequest}
 */
proto.entity.UpdateActionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateActionRequest;
  return proto.entity.UpdateActionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateActionRequest}
 */
proto.entity.UpdateActionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 3:
      var value = new proto_entity_action_pb.UpdateActionAction;
      reader.readMessage(value,proto_entity_action_pb.UpdateActionAction.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateActionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateActionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateActionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_entity_action_pb.UpdateActionAction.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateActionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateActionRequest} returns this
*/
proto.entity.UpdateActionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateActionRequest} returns this
 */
proto.entity.UpdateActionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateActionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UpdateActionAction actions = 3;
 * @return {!Array<!proto.entity.UpdateActionAction>}
 */
proto.entity.UpdateActionRequest.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.UpdateActionAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_action_pb.UpdateActionAction, 3));
};


/**
 * @param {!Array<!proto.entity.UpdateActionAction>} value
 * @return {!proto.entity.UpdateActionRequest} returns this
*/
proto.entity.UpdateActionRequest.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.UpdateActionAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateActionAction}
 */
proto.entity.UpdateActionRequest.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.UpdateActionAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateActionRequest} returns this
 */
proto.entity.UpdateActionRequest.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateActionReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateActionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateActionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateActionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateActionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    updatedActionsList: jspb.Message.toObjectList(msg.getUpdatedActionsList(),
    proto_entity_action_pb.Action.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateActionReply}
 */
proto.entity.UpdateActionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateActionReply;
  return proto.entity.UpdateActionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateActionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateActionReply}
 */
proto.entity.UpdateActionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_action_pb.Action;
      reader.readMessage(value,proto_entity_action_pb.Action.deserializeBinaryFromReader);
      msg.addUpdatedActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateActionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateActionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateActionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateActionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatedActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_action_pb.Action.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Action updated_actions = 1;
 * @return {!Array<!proto.entity.Action>}
 */
proto.entity.UpdateActionReply.prototype.getUpdatedActionsList = function() {
  return /** @type{!Array<!proto.entity.Action>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_action_pb.Action, 1));
};


/**
 * @param {!Array<!proto.entity.Action>} value
 * @return {!proto.entity.UpdateActionReply} returns this
*/
proto.entity.UpdateActionReply.prototype.setUpdatedActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Action=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Action}
 */
proto.entity.UpdateActionReply.prototype.addUpdatedActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Action, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateActionReply} returns this
 */
proto.entity.UpdateActionReply.prototype.clearUpdatedActionsList = function() {
  return this.setUpdatedActionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ValidateActionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ValidateActionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ValidateActionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ValidateActionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    actionDetails: (f = msg.getActionDetails()) && proto_entity_action_pb.ActionDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ValidateActionRequest}
 */
proto.entity.ValidateActionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ValidateActionRequest;
  return proto.entity.ValidateActionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ValidateActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ValidateActionRequest}
 */
proto.entity.ValidateActionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_action_pb.ActionDetails;
      reader.readMessage(value,proto_entity_action_pb.ActionDetails.deserializeBinaryFromReader);
      msg.setActionDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ValidateActionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ValidateActionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ValidateActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ValidateActionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getActionDetails();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_action_pb.ActionDetails.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ValidateActionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ValidateActionRequest} returns this
*/
proto.entity.ValidateActionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ValidateActionRequest} returns this
 */
proto.entity.ValidateActionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ValidateActionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ActionDetails action_details = 2;
 * @return {?proto.entity.ActionDetails}
 */
proto.entity.ValidateActionRequest.prototype.getActionDetails = function() {
  return /** @type{?proto.entity.ActionDetails} */ (
    jspb.Message.getWrapperField(this, proto_entity_action_pb.ActionDetails, 2));
};


/**
 * @param {?proto.entity.ActionDetails|undefined} value
 * @return {!proto.entity.ValidateActionRequest} returns this
*/
proto.entity.ValidateActionRequest.prototype.setActionDetails = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ValidateActionRequest} returns this
 */
proto.entity.ValidateActionRequest.prototype.clearActionDetails = function() {
  return this.setActionDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ValidateActionRequest.prototype.hasActionDetails = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ValidateActionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ValidateActionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ValidateActionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ValidateActionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ValidateActionReply}
 */
proto.entity.ValidateActionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ValidateActionReply;
  return proto.entity.ValidateActionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ValidateActionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ValidateActionReply}
 */
proto.entity.ValidateActionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ValidateActionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ValidateActionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ValidateActionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ValidateActionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupActionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupActionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupActionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupActionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    actionId: (f = msg.getActionId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupActionRequest}
 */
proto.entity.LookupActionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupActionRequest;
  return proto.entity.LookupActionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupActionRequest}
 */
proto.entity.LookupActionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setActionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupActionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupActionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupActionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getActionId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupActionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupActionRequest} returns this
*/
proto.entity.LookupActionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupActionRequest} returns this
 */
proto.entity.LookupActionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupActionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID action_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.LookupActionRequest.prototype.getActionId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.LookupActionRequest} returns this
*/
proto.entity.LookupActionRequest.prototype.setActionId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupActionRequest} returns this
 */
proto.entity.LookupActionRequest.prototype.clearActionId = function() {
  return this.setActionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupActionRequest.prototype.hasActionId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupActionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupActionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupActionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupActionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: (f = msg.getAction()) && proto_entity_action_pb.Action.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupActionReply}
 */
proto.entity.LookupActionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupActionReply;
  return proto.entity.LookupActionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupActionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupActionReply}
 */
proto.entity.LookupActionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_action_pb.Action;
      reader.readMessage(value,proto_entity_action_pb.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupActionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupActionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupActionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupActionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_action_pb.Action.serializeBinaryToWriter
    );
  }
};


/**
 * optional Action action = 1;
 * @return {?proto.entity.Action}
 */
proto.entity.LookupActionReply.prototype.getAction = function() {
  return /** @type{?proto.entity.Action} */ (
    jspb.Message.getWrapperField(this, proto_entity_action_pb.Action, 1));
};


/**
 * @param {?proto.entity.Action|undefined} value
 * @return {!proto.entity.LookupActionReply} returns this
*/
proto.entity.LookupActionReply.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupActionReply} returns this
 */
proto.entity.LookupActionReply.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupActionReply.prototype.hasAction = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListActionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListActionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListActionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListActionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    actionFilter: (f = msg.getActionFilter()) && proto.entity.ActionFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListActionsRequest}
 */
proto.entity.ListActionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListActionsRequest;
  return proto.entity.ListActionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListActionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListActionsRequest}
 */
proto.entity.ListActionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto.entity.ActionFilter;
      reader.readMessage(value,proto.entity.ActionFilter.deserializeBinaryFromReader);
      msg.setActionFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListActionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListActionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListActionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListActionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getActionFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.ActionFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListActionsRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListActionsRequest} returns this
*/
proto.entity.ListActionsRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListActionsRequest} returns this
 */
proto.entity.ListActionsRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListActionsRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ActionFilter action_filter = 2;
 * @return {?proto.entity.ActionFilter}
 */
proto.entity.ListActionsRequest.prototype.getActionFilter = function() {
  return /** @type{?proto.entity.ActionFilter} */ (
    jspb.Message.getWrapperField(this, proto.entity.ActionFilter, 2));
};


/**
 * @param {?proto.entity.ActionFilter|undefined} value
 * @return {!proto.entity.ListActionsRequest} returns this
*/
proto.entity.ListActionsRequest.prototype.setActionFilter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListActionsRequest} returns this
 */
proto.entity.ListActionsRequest.prototype.clearActionFilter = function() {
  return this.setActionFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListActionsRequest.prototype.hasActionFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListActionsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListActionsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListActionsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListActionsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListActionsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_action_pb.Action.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListActionsReply}
 */
proto.entity.ListActionsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListActionsReply;
  return proto.entity.ListActionsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListActionsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListActionsReply}
 */
proto.entity.ListActionsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_action_pb.Action;
      reader.readMessage(value,proto_entity_action_pb.Action.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListActionsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListActionsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListActionsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListActionsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_action_pb.Action.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Action actions = 1;
 * @return {!Array<!proto.entity.Action>}
 */
proto.entity.ListActionsReply.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.Action>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_action_pb.Action, 1));
};


/**
 * @param {!Array<!proto.entity.Action>} value
 * @return {!proto.entity.ListActionsReply} returns this
*/
proto.entity.ListActionsReply.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Action=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Action}
 */
proto.entity.ListActionsReply.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Action, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListActionsReply} returns this
 */
proto.entity.ListActionsReply.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ActionFilter.repeatedFields_ = [1,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ActionFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ActionFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ActionFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ActionFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    includeSitesList: jspb.Message.toObjectList(msg.getIncludeSitesList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    includeUnexecuted: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    googleAdsActionTypesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ActionFilter}
 */
proto.entity.ActionFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ActionFilter;
  return proto.entity.ActionFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ActionFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ActionFilter}
 */
proto.entity.ActionFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addIncludeSites(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeUnexecuted(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addGoogleAdsActionTypes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ActionFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ActionFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ActionFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ActionFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludeSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getIncludeUnexecuted();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getGoogleAdsActionTypesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated common.ObjectID include_sites = 1;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.ActionFilter.prototype.getIncludeSitesList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.ActionFilter} returns this
*/
proto.entity.ActionFilter.prototype.setIncludeSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.ActionFilter.prototype.addIncludeSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ActionFilter} returns this
 */
proto.entity.ActionFilter.prototype.clearIncludeSitesList = function() {
  return this.setIncludeSitesList([]);
};


/**
 * optional bool include_unexecuted = 2;
 * @return {boolean}
 */
proto.entity.ActionFilter.prototype.getIncludeUnexecuted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.ActionFilter} returns this
 */
proto.entity.ActionFilter.prototype.setIncludeUnexecuted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated string google_ads_action_types = 3;
 * @return {!Array<string>}
 */
proto.entity.ActionFilter.prototype.getGoogleAdsActionTypesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.ActionFilter} returns this
 */
proto.entity.ActionFilter.prototype.setGoogleAdsActionTypesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.ActionFilter} returns this
 */
proto.entity.ActionFilter.prototype.addGoogleAdsActionTypes = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ActionFilter} returns this
 */
proto.entity.ActionFilter.prototype.clearGoogleAdsActionTypesList = function() {
  return this.setGoogleAdsActionTypesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateOpportunityRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateOpportunityRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateOpportunityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunityRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newOpportunity: (f = msg.getNewOpportunity()) && proto_entity_opportunity_pb.NewOpportunity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateOpportunityRequest}
 */
proto.entity.CreateOpportunityRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateOpportunityRequest;
  return proto.entity.CreateOpportunityRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateOpportunityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateOpportunityRequest}
 */
proto.entity.CreateOpportunityRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.NewOpportunity;
      reader.readMessage(value,proto_entity_opportunity_pb.NewOpportunity.deserializeBinaryFromReader);
      msg.setNewOpportunity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateOpportunityRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateOpportunityRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateOpportunityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunityRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewOpportunity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_opportunity_pb.NewOpportunity.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewOpportunity new_opportunity = 1;
 * @return {?proto.entity.NewOpportunity}
 */
proto.entity.CreateOpportunityRequest.prototype.getNewOpportunity = function() {
  return /** @type{?proto.entity.NewOpportunity} */ (
    jspb.Message.getWrapperField(this, proto_entity_opportunity_pb.NewOpportunity, 1));
};


/**
 * @param {?proto.entity.NewOpportunity|undefined} value
 * @return {!proto.entity.CreateOpportunityRequest} returns this
*/
proto.entity.CreateOpportunityRequest.prototype.setNewOpportunity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateOpportunityRequest} returns this
 */
proto.entity.CreateOpportunityRequest.prototype.clearNewOpportunity = function() {
  return this.setNewOpportunity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateOpportunityRequest.prototype.hasNewOpportunity = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateOpportunityReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateOpportunityReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateOpportunityReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunityReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunity: (f = msg.getOpportunity()) && proto_entity_opportunity_pb.Opportunity.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateOpportunityReply}
 */
proto.entity.CreateOpportunityReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateOpportunityReply;
  return proto.entity.CreateOpportunityReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateOpportunityReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateOpportunityReply}
 */
proto.entity.CreateOpportunityReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.Opportunity;
      reader.readMessage(value,proto_entity_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.setOpportunity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateOpportunityReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateOpportunityReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateOpportunityReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunityReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunity();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
};


/**
 * optional Opportunity opportunity = 1;
 * @return {?proto.entity.Opportunity}
 */
proto.entity.CreateOpportunityReply.prototype.getOpportunity = function() {
  return /** @type{?proto.entity.Opportunity} */ (
    jspb.Message.getWrapperField(this, proto_entity_opportunity_pb.Opportunity, 1));
};


/**
 * @param {?proto.entity.Opportunity|undefined} value
 * @return {!proto.entity.CreateOpportunityReply} returns this
*/
proto.entity.CreateOpportunityReply.prototype.setOpportunity = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateOpportunityReply} returns this
 */
proto.entity.CreateOpportunityReply.prototype.clearOpportunity = function() {
  return this.setOpportunity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateOpportunityReply.prototype.hasOpportunity = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListOpportunitiesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListOpportunitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListOpportunitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListOpportunitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    statusesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    enforceSuspensions: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    limit: jspb.Message.getFieldWithDefault(msg, 4, 0),
    opportunityType: jspb.Message.getFieldWithDefault(msg, 5, ""),
    filters: (f = msg.getFilters()) && proto.entity.ListOpportunitiesRequest.Filters.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListOpportunitiesRequest}
 */
proto.entity.ListOpportunitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListOpportunitiesRequest;
  return proto.entity.ListOpportunitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListOpportunitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListOpportunitiesRequest}
 */
proto.entity.ListOpportunitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.entity.OpportunityStatus.Option>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatuses(values[i]);
      }
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnforceSuspensions(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpportunityType(value);
      break;
    case 6:
      var value = new proto.entity.ListOpportunitiesRequest.Filters;
      reader.readMessage(value,proto.entity.ListOpportunitiesRequest.Filters.deserializeBinaryFromReader);
      msg.setFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListOpportunitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListOpportunitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListOpportunitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getEnforceSuspensions();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getOpportunityType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFilters();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.entity.ListOpportunitiesRequest.Filters.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListOpportunitiesRequest.Filters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListOpportunitiesRequest.Filters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitiesRequest.Filters.toObject = function(includeInstance, msg) {
  var f, obj = {
    enforceSuspensions: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    createdBefore: (f = msg.getCreatedBefore()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdSince: (f = msg.getCreatedSince()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListOpportunitiesRequest.Filters}
 */
proto.entity.ListOpportunitiesRequest.Filters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListOpportunitiesRequest.Filters;
  return proto.entity.ListOpportunitiesRequest.Filters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListOpportunitiesRequest.Filters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListOpportunitiesRequest.Filters}
 */
proto.entity.ListOpportunitiesRequest.Filters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnforceSuspensions(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedBefore(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedSince(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListOpportunitiesRequest.Filters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListOpportunitiesRequest.Filters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitiesRequest.Filters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEnforceSuspensions();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getCreatedBefore();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedSince();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional bool enforce_suspensions = 1;
 * @return {boolean}
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.getEnforceSuspensions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.ListOpportunitiesRequest.Filters} returns this
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.setEnforceSuspensions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_before = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.getCreatedBefore = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.ListOpportunitiesRequest.Filters} returns this
*/
proto.entity.ListOpportunitiesRequest.Filters.prototype.setCreatedBefore = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListOpportunitiesRequest.Filters} returns this
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.clearCreatedBefore = function() {
  return this.setCreatedBefore(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.hasCreatedBefore = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp created_since = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.getCreatedSince = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.ListOpportunitiesRequest.Filters} returns this
*/
proto.entity.ListOpportunitiesRequest.Filters.prototype.setCreatedSince = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListOpportunitiesRequest.Filters} returns this
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.clearCreatedSince = function() {
  return this.setCreatedSince(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListOpportunitiesRequest.Filters.prototype.hasCreatedSince = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListOpportunitiesRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
*/
proto.entity.ListOpportunitiesRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListOpportunitiesRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OpportunityStatus.Option statuses = 2;
 * @return {!Array<!proto.entity.OpportunityStatus.Option>}
 */
proto.entity.ListOpportunitiesRequest.prototype.getStatusesList = function() {
  return /** @type {!Array<!proto.entity.OpportunityStatus.Option>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.entity.OpportunityStatus.Option>} value
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.setStatusesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.entity.OpportunityStatus.Option} value
 * @param {number=} opt_index
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.addStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.clearStatusesList = function() {
  return this.setStatusesList([]);
};


/**
 * optional bool enforce_suspensions = 3;
 * @return {boolean}
 */
proto.entity.ListOpportunitiesRequest.prototype.getEnforceSuspensions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.setEnforceSuspensions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional uint32 limit = 4;
 * @return {number}
 */
proto.entity.ListOpportunitiesRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string opportunity_type = 5;
 * @return {string}
 */
proto.entity.ListOpportunitiesRequest.prototype.getOpportunityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.setOpportunityType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional Filters filters = 6;
 * @return {?proto.entity.ListOpportunitiesRequest.Filters}
 */
proto.entity.ListOpportunitiesRequest.prototype.getFilters = function() {
  return /** @type{?proto.entity.ListOpportunitiesRequest.Filters} */ (
    jspb.Message.getWrapperField(this, proto.entity.ListOpportunitiesRequest.Filters, 6));
};


/**
 * @param {?proto.entity.ListOpportunitiesRequest.Filters|undefined} value
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
*/
proto.entity.ListOpportunitiesRequest.prototype.setFilters = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListOpportunitiesRequest} returns this
 */
proto.entity.ListOpportunitiesRequest.prototype.clearFilters = function() {
  return this.setFilters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListOpportunitiesRequest.prototype.hasFilters = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListOpportunitiesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListOpportunitiesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListOpportunitiesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListOpportunitiesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitiesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunitiesList: jspb.Message.toObjectList(msg.getOpportunitiesList(),
    proto_entity_opportunity_pb.Opportunity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListOpportunitiesReply}
 */
proto.entity.ListOpportunitiesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListOpportunitiesReply;
  return proto.entity.ListOpportunitiesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListOpportunitiesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListOpportunitiesReply}
 */
proto.entity.ListOpportunitiesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.Opportunity;
      reader.readMessage(value,proto_entity_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.addOpportunities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListOpportunitiesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListOpportunitiesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListOpportunitiesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitiesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Opportunity opportunities = 1;
 * @return {!Array<!proto.entity.Opportunity>}
 */
proto.entity.ListOpportunitiesReply.prototype.getOpportunitiesList = function() {
  return /** @type{!Array<!proto.entity.Opportunity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_opportunity_pb.Opportunity, 1));
};


/**
 * @param {!Array<!proto.entity.Opportunity>} value
 * @return {!proto.entity.ListOpportunitiesReply} returns this
*/
proto.entity.ListOpportunitiesReply.prototype.setOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Opportunity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Opportunity}
 */
proto.entity.ListOpportunitiesReply.prototype.addOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Opportunity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListOpportunitiesReply} returns this
 */
proto.entity.ListOpportunitiesReply.prototype.clearOpportunitiesList = function() {
  return this.setOpportunitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.HasOpportunitiesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HasOpportunitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HasOpportunitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HasOpportunitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasOpportunitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    statusesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    opportunityType: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HasOpportunitiesRequest}
 */
proto.entity.HasOpportunitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HasOpportunitiesRequest;
  return proto.entity.HasOpportunitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HasOpportunitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HasOpportunitiesRequest}
 */
proto.entity.HasOpportunitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.entity.OpportunityStatus.Option>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatuses(values[i]);
      }
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpportunityType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HasOpportunitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HasOpportunitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HasOpportunitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasOpportunitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getOpportunityType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.HasOpportunitiesRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.HasOpportunitiesRequest} returns this
*/
proto.entity.HasOpportunitiesRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.HasOpportunitiesRequest} returns this
 */
proto.entity.HasOpportunitiesRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HasOpportunitiesRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OpportunityStatus.Option statuses = 2;
 * @return {!Array<!proto.entity.OpportunityStatus.Option>}
 */
proto.entity.HasOpportunitiesRequest.prototype.getStatusesList = function() {
  return /** @type {!Array<!proto.entity.OpportunityStatus.Option>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.entity.OpportunityStatus.Option>} value
 * @return {!proto.entity.HasOpportunitiesRequest} returns this
 */
proto.entity.HasOpportunitiesRequest.prototype.setStatusesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.entity.OpportunityStatus.Option} value
 * @param {number=} opt_index
 * @return {!proto.entity.HasOpportunitiesRequest} returns this
 */
proto.entity.HasOpportunitiesRequest.prototype.addStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.HasOpportunitiesRequest} returns this
 */
proto.entity.HasOpportunitiesRequest.prototype.clearStatusesList = function() {
  return this.setStatusesList([]);
};


/**
 * optional string opportunity_type = 5;
 * @return {string}
 */
proto.entity.HasOpportunitiesRequest.prototype.getOpportunityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.HasOpportunitiesRequest} returns this
 */
proto.entity.HasOpportunitiesRequest.prototype.setOpportunityType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HasOpportunitiesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HasOpportunitiesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HasOpportunitiesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasOpportunitiesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HasOpportunitiesReply}
 */
proto.entity.HasOpportunitiesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HasOpportunitiesReply;
  return proto.entity.HasOpportunitiesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HasOpportunitiesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HasOpportunitiesReply}
 */
proto.entity.HasOpportunitiesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HasOpportunitiesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HasOpportunitiesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HasOpportunitiesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasOpportunitiesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.entity.HasOpportunitiesReply.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.HasOpportunitiesReply} returns this
 */
proto.entity.HasOpportunitiesReply.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.CountOpportunitiesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CountOpportunitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CountOpportunitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CountOpportunitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CountOpportunitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    statusesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    opportunityType: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CountOpportunitiesRequest}
 */
proto.entity.CountOpportunitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CountOpportunitiesRequest;
  return proto.entity.CountOpportunitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CountOpportunitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CountOpportunitiesRequest}
 */
proto.entity.CountOpportunitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var values = /** @type {!Array<!proto.entity.OpportunityStatus.Option>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStatuses(values[i]);
      }
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOpportunityType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CountOpportunitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CountOpportunitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CountOpportunitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CountOpportunitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getStatusesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      2,
      f
    );
  }
  f = message.getOpportunityType();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.CountOpportunitiesRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.CountOpportunitiesRequest} returns this
*/
proto.entity.CountOpportunitiesRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CountOpportunitiesRequest} returns this
 */
proto.entity.CountOpportunitiesRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CountOpportunitiesRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OpportunityStatus.Option statuses = 2;
 * @return {!Array<!proto.entity.OpportunityStatus.Option>}
 */
proto.entity.CountOpportunitiesRequest.prototype.getStatusesList = function() {
  return /** @type {!Array<!proto.entity.OpportunityStatus.Option>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<!proto.entity.OpportunityStatus.Option>} value
 * @return {!proto.entity.CountOpportunitiesRequest} returns this
 */
proto.entity.CountOpportunitiesRequest.prototype.setStatusesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {!proto.entity.OpportunityStatus.Option} value
 * @param {number=} opt_index
 * @return {!proto.entity.CountOpportunitiesRequest} returns this
 */
proto.entity.CountOpportunitiesRequest.prototype.addStatuses = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CountOpportunitiesRequest} returns this
 */
proto.entity.CountOpportunitiesRequest.prototype.clearStatusesList = function() {
  return this.setStatusesList([]);
};


/**
 * optional string opportunity_type = 5;
 * @return {string}
 */
proto.entity.CountOpportunitiesRequest.prototype.getOpportunityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CountOpportunitiesRequest} returns this
 */
proto.entity.CountOpportunitiesRequest.prototype.setOpportunityType = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CountOpportunitiesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CountOpportunitiesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CountOpportunitiesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CountOpportunitiesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    count: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CountOpportunitiesReply}
 */
proto.entity.CountOpportunitiesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CountOpportunitiesReply;
  return proto.entity.CountOpportunitiesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CountOpportunitiesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CountOpportunitiesReply}
 */
proto.entity.CountOpportunitiesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CountOpportunitiesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CountOpportunitiesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CountOpportunitiesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CountOpportunitiesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 count = 1;
 * @return {number}
 */
proto.entity.CountOpportunitiesReply.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.CountOpportunitiesReply} returns this
 */
proto.entity.CountOpportunitiesReply.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.LookupOpportunitiesRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupOpportunitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupOpportunitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupOpportunitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOpportunitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    opportunityIdsList: jspb.Message.toObjectList(msg.getOpportunityIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupOpportunitiesRequest}
 */
proto.entity.LookupOpportunitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupOpportunitiesRequest;
  return proto.entity.LookupOpportunitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupOpportunitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupOpportunitiesRequest}
 */
proto.entity.LookupOpportunitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addOpportunityIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupOpportunitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupOpportunitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupOpportunitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOpportunitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getOpportunityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupOpportunitiesRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupOpportunitiesRequest} returns this
*/
proto.entity.LookupOpportunitiesRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupOpportunitiesRequest} returns this
 */
proto.entity.LookupOpportunitiesRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupOpportunitiesRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated common.ObjectID opportunity_ids = 2;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.LookupOpportunitiesRequest.prototype.getOpportunityIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.LookupOpportunitiesRequest} returns this
*/
proto.entity.LookupOpportunitiesRequest.prototype.setOpportunityIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.LookupOpportunitiesRequest.prototype.addOpportunityIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.LookupOpportunitiesRequest} returns this
 */
proto.entity.LookupOpportunitiesRequest.prototype.clearOpportunityIdsList = function() {
  return this.setOpportunityIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.LookupOpportunitiesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupOpportunitiesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupOpportunitiesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupOpportunitiesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOpportunitiesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunitiesList: jspb.Message.toObjectList(msg.getOpportunitiesList(),
    proto_entity_opportunity_pb.Opportunity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupOpportunitiesReply}
 */
proto.entity.LookupOpportunitiesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupOpportunitiesReply;
  return proto.entity.LookupOpportunitiesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupOpportunitiesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupOpportunitiesReply}
 */
proto.entity.LookupOpportunitiesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.Opportunity;
      reader.readMessage(value,proto_entity_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.addOpportunities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupOpportunitiesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupOpportunitiesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupOpportunitiesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOpportunitiesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Opportunity opportunities = 1;
 * @return {!Array<!proto.entity.Opportunity>}
 */
proto.entity.LookupOpportunitiesReply.prototype.getOpportunitiesList = function() {
  return /** @type{!Array<!proto.entity.Opportunity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_opportunity_pb.Opportunity, 1));
};


/**
 * @param {!Array<!proto.entity.Opportunity>} value
 * @return {!proto.entity.LookupOpportunitiesReply} returns this
*/
proto.entity.LookupOpportunitiesReply.prototype.setOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Opportunity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Opportunity}
 */
proto.entity.LookupOpportunitiesReply.prototype.addOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Opportunity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.LookupOpportunitiesReply} returns this
 */
proto.entity.LookupOpportunitiesReply.prototype.clearOpportunitiesList = function() {
  return this.setOpportunitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ChangeOpportunitiesStatusRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ChangeOpportunitiesStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ChangeOpportunitiesStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ChangeOpportunitiesStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    changeSetsList: jspb.Message.toObjectList(msg.getChangeSetsList(),
    proto.entity.OpportunityChangeStatusSet.toObject, includeInstance),
    errorForSingleFailure: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ChangeOpportunitiesStatusRequest}
 */
proto.entity.ChangeOpportunitiesStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ChangeOpportunitiesStatusRequest;
  return proto.entity.ChangeOpportunitiesStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ChangeOpportunitiesStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ChangeOpportunitiesStatusRequest}
 */
proto.entity.ChangeOpportunitiesStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto.entity.OpportunityChangeStatusSet;
      reader.readMessage(value,proto.entity.OpportunityChangeStatusSet.deserializeBinaryFromReader);
      msg.addChangeSets(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setErrorForSingleFailure(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ChangeOpportunitiesStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ChangeOpportunitiesStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ChangeOpportunitiesStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getChangeSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.entity.OpportunityChangeStatusSet.serializeBinaryToWriter
    );
  }
  f = message.getErrorForSingleFailure();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ChangeOpportunitiesStatusRequest} returns this
*/
proto.entity.ChangeOpportunitiesStatusRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ChangeOpportunitiesStatusRequest} returns this
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated OpportunityChangeStatusSet change_sets = 2;
 * @return {!Array<!proto.entity.OpportunityChangeStatusSet>}
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.getChangeSetsList = function() {
  return /** @type{!Array<!proto.entity.OpportunityChangeStatusSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunityChangeStatusSet, 2));
};


/**
 * @param {!Array<!proto.entity.OpportunityChangeStatusSet>} value
 * @return {!proto.entity.ChangeOpportunitiesStatusRequest} returns this
*/
proto.entity.ChangeOpportunitiesStatusRequest.prototype.setChangeSetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.OpportunityChangeStatusSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityChangeStatusSet}
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.addChangeSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.OpportunityChangeStatusSet, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ChangeOpportunitiesStatusRequest} returns this
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.clearChangeSetsList = function() {
  return this.setChangeSetsList([]);
};


/**
 * optional bool error_for_single_failure = 3;
 * @return {boolean}
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.getErrorForSingleFailure = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.ChangeOpportunitiesStatusRequest} returns this
 */
proto.entity.ChangeOpportunitiesStatusRequest.prototype.setErrorForSingleFailure = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityChangeStatusSet.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityChangeStatusSet.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityChangeStatusSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityChangeStatusSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityChangeStatusSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    newStatus: jspb.Message.getFieldWithDefault(msg, 1, 0),
    opportunityIdsList: jspb.Message.toObjectList(msg.getOpportunityIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    executionTime: (f = msg.getExecutionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    executionUserId: (f = msg.getExecutionUserId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityChangeStatusSet}
 */
proto.entity.OpportunityChangeStatusSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityChangeStatusSet;
  return proto.entity.OpportunityChangeStatusSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityChangeStatusSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityChangeStatusSet}
 */
proto.entity.OpportunityChangeStatusSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.entity.OpportunityStatus.Option} */ (reader.readEnum());
      msg.setNewStatus(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addOpportunityIds(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExecutionTime(value);
      break;
    case 4:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setExecutionUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityChangeStatusSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityChangeStatusSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityChangeStatusSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityChangeStatusSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOpportunityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getExecutionTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExecutionUserId();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
};


/**
 * optional OpportunityStatus.Option new_status = 1;
 * @return {!proto.entity.OpportunityStatus.Option}
 */
proto.entity.OpportunityChangeStatusSet.prototype.getNewStatus = function() {
  return /** @type {!proto.entity.OpportunityStatus.Option} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.entity.OpportunityStatus.Option} value
 * @return {!proto.entity.OpportunityChangeStatusSet} returns this
 */
proto.entity.OpportunityChangeStatusSet.prototype.setNewStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated common.ObjectID opportunity_ids = 2;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.OpportunityChangeStatusSet.prototype.getOpportunityIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.OpportunityChangeStatusSet} returns this
*/
proto.entity.OpportunityChangeStatusSet.prototype.setOpportunityIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.OpportunityChangeStatusSet.prototype.addOpportunityIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityChangeStatusSet} returns this
 */
proto.entity.OpportunityChangeStatusSet.prototype.clearOpportunityIdsList = function() {
  return this.setOpportunityIdsList([]);
};


/**
 * optional google.protobuf.Timestamp execution_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.OpportunityChangeStatusSet.prototype.getExecutionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.OpportunityChangeStatusSet} returns this
*/
proto.entity.OpportunityChangeStatusSet.prototype.setExecutionTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityChangeStatusSet} returns this
 */
proto.entity.OpportunityChangeStatusSet.prototype.clearExecutionTime = function() {
  return this.setExecutionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityChangeStatusSet.prototype.hasExecutionTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional common.ObjectID execution_user_id = 4;
 * @return {?proto.common.ObjectID}
 */
proto.entity.OpportunityChangeStatusSet.prototype.getExecutionUserId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 4));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.OpportunityChangeStatusSet} returns this
*/
proto.entity.OpportunityChangeStatusSet.prototype.setExecutionUserId = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.OpportunityChangeStatusSet} returns this
 */
proto.entity.OpportunityChangeStatusSet.prototype.clearExecutionUserId = function() {
  return this.setExecutionUserId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.OpportunityChangeStatusSet.prototype.hasExecutionUserId = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ChangeOpportunitiesStatusReply.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ChangeOpportunitiesStatusReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ChangeOpportunitiesStatusReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ChangeOpportunitiesStatusReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    updatedOpportunityIdsList: jspb.Message.toObjectList(msg.getUpdatedOpportunityIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    unchangedOpportunityIdsList: jspb.Message.toObjectList(msg.getUnchangedOpportunityIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    failureSetsList: jspb.Message.toObjectList(msg.getFailureSetsList(),
    proto.entity.OpportunityFailureSet.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ChangeOpportunitiesStatusReply}
 */
proto.entity.ChangeOpportunitiesStatusReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ChangeOpportunitiesStatusReply;
  return proto.entity.ChangeOpportunitiesStatusReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ChangeOpportunitiesStatusReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ChangeOpportunitiesStatusReply}
 */
proto.entity.ChangeOpportunitiesStatusReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addUpdatedOpportunityIds(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addUnchangedOpportunityIds(value);
      break;
    case 3:
      var value = new proto.entity.OpportunityFailureSet;
      reader.readMessage(value,proto.entity.OpportunityFailureSet.deserializeBinaryFromReader);
      msg.addFailureSets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ChangeOpportunitiesStatusReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ChangeOpportunitiesStatusReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ChangeOpportunitiesStatusReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdatedOpportunityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getUnchangedOpportunityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getFailureSetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.entity.OpportunityFailureSet.serializeBinaryToWriter
    );
  }
};


/**
 * repeated common.ObjectID updated_opportunity_ids = 1;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.getUpdatedOpportunityIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.ChangeOpportunitiesStatusReply} returns this
*/
proto.entity.ChangeOpportunitiesStatusReply.prototype.setUpdatedOpportunityIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.addUpdatedOpportunityIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ChangeOpportunitiesStatusReply} returns this
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.clearUpdatedOpportunityIdsList = function() {
  return this.setUpdatedOpportunityIdsList([]);
};


/**
 * repeated common.ObjectID unchanged_opportunity_ids = 2;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.getUnchangedOpportunityIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.ChangeOpportunitiesStatusReply} returns this
*/
proto.entity.ChangeOpportunitiesStatusReply.prototype.setUnchangedOpportunityIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.addUnchangedOpportunityIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ChangeOpportunitiesStatusReply} returns this
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.clearUnchangedOpportunityIdsList = function() {
  return this.setUnchangedOpportunityIdsList([]);
};


/**
 * repeated OpportunityFailureSet failure_sets = 3;
 * @return {!Array<!proto.entity.OpportunityFailureSet>}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.getFailureSetsList = function() {
  return /** @type{!Array<!proto.entity.OpportunityFailureSet>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.OpportunityFailureSet, 3));
};


/**
 * @param {!Array<!proto.entity.OpportunityFailureSet>} value
 * @return {!proto.entity.ChangeOpportunitiesStatusReply} returns this
*/
proto.entity.ChangeOpportunitiesStatusReply.prototype.setFailureSetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.OpportunityFailureSet=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityFailureSet}
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.addFailureSets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.OpportunityFailureSet, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ChangeOpportunitiesStatusReply} returns this
 */
proto.entity.ChangeOpportunitiesStatusReply.prototype.clearFailureSetsList = function() {
  return this.setFailureSetsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OpportunityFailureSet.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OpportunityFailureSet.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OpportunityFailureSet.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OpportunityFailureSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityFailureSet.toObject = function(includeInstance, msg) {
  var f, obj = {
    failureMessage: jspb.Message.getFieldWithDefault(msg, 1, ""),
    opportunityIdsList: jspb.Message.toObjectList(msg.getOpportunityIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    fromStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    toStatus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OpportunityFailureSet}
 */
proto.entity.OpportunityFailureSet.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OpportunityFailureSet;
  return proto.entity.OpportunityFailureSet.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OpportunityFailureSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OpportunityFailureSet}
 */
proto.entity.OpportunityFailureSet.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFailureMessage(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addOpportunityIds(value);
      break;
    case 3:
      var value = /** @type {!proto.entity.OpportunityStatus.Option} */ (reader.readEnum());
      msg.setFromStatus(value);
      break;
    case 4:
      var value = /** @type {!proto.entity.OpportunityStatus.Option} */ (reader.readEnum());
      msg.setToStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OpportunityFailureSet.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OpportunityFailureSet.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OpportunityFailureSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OpportunityFailureSet.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFailureMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getOpportunityIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getFromStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getToStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string failure_message = 1;
 * @return {string}
 */
proto.entity.OpportunityFailureSet.prototype.getFailureMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.OpportunityFailureSet} returns this
 */
proto.entity.OpportunityFailureSet.prototype.setFailureMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated common.ObjectID opportunity_ids = 2;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.OpportunityFailureSet.prototype.getOpportunityIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.OpportunityFailureSet} returns this
*/
proto.entity.OpportunityFailureSet.prototype.setOpportunityIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.OpportunityFailureSet.prototype.addOpportunityIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OpportunityFailureSet} returns this
 */
proto.entity.OpportunityFailureSet.prototype.clearOpportunityIdsList = function() {
  return this.setOpportunityIdsList([]);
};


/**
 * optional OpportunityStatus.Option from_status = 3;
 * @return {!proto.entity.OpportunityStatus.Option}
 */
proto.entity.OpportunityFailureSet.prototype.getFromStatus = function() {
  return /** @type {!proto.entity.OpportunityStatus.Option} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.entity.OpportunityStatus.Option} value
 * @return {!proto.entity.OpportunityFailureSet} returns this
 */
proto.entity.OpportunityFailureSet.prototype.setFromStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional OpportunityStatus.Option to_status = 4;
 * @return {!proto.entity.OpportunityStatus.Option}
 */
proto.entity.OpportunityFailureSet.prototype.getToStatus = function() {
  return /** @type {!proto.entity.OpportunityStatus.Option} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.entity.OpportunityStatus.Option} value
 * @return {!proto.entity.OpportunityFailureSet} returns this
 */
proto.entity.OpportunityFailureSet.prototype.setToStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ExecuteOpportunitiesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ExecuteOpportunitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ExecuteOpportunitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ExecuteOpportunitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteOpportunitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    opportunitiesList: jspb.Message.toObjectList(msg.getOpportunitiesList(),
    proto_entity_opportunity_pb.Opportunity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ExecuteOpportunitiesRequest}
 */
proto.entity.ExecuteOpportunitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ExecuteOpportunitiesRequest;
  return proto.entity.ExecuteOpportunitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ExecuteOpportunitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ExecuteOpportunitiesRequest}
 */
proto.entity.ExecuteOpportunitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.Opportunity;
      reader.readMessage(value,proto_entity_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.addOpportunities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ExecuteOpportunitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ExecuteOpportunitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ExecuteOpportunitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteOpportunitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Opportunity opportunities = 1;
 * @return {!Array<!proto.entity.Opportunity>}
 */
proto.entity.ExecuteOpportunitiesRequest.prototype.getOpportunitiesList = function() {
  return /** @type{!Array<!proto.entity.Opportunity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_opportunity_pb.Opportunity, 1));
};


/**
 * @param {!Array<!proto.entity.Opportunity>} value
 * @return {!proto.entity.ExecuteOpportunitiesRequest} returns this
*/
proto.entity.ExecuteOpportunitiesRequest.prototype.setOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Opportunity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Opportunity}
 */
proto.entity.ExecuteOpportunitiesRequest.prototype.addOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Opportunity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ExecuteOpportunitiesRequest} returns this
 */
proto.entity.ExecuteOpportunitiesRequest.prototype.clearOpportunitiesList = function() {
  return this.setOpportunitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ExecuteOpportunitiesReply.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ExecuteOpportunitiesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ExecuteOpportunitiesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ExecuteOpportunitiesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteOpportunitiesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    executedOpportunitiesList: jspb.Message.toObjectList(msg.getExecutedOpportunitiesList(),
    proto_entity_opportunity_pb.Opportunity.toObject, includeInstance),
    failedOpportunitiesList: jspb.Message.toObjectList(msg.getFailedOpportunitiesList(),
    proto_entity_opportunity_pb.OpportunityExecutionFailure.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ExecuteOpportunitiesReply}
 */
proto.entity.ExecuteOpportunitiesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ExecuteOpportunitiesReply;
  return proto.entity.ExecuteOpportunitiesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ExecuteOpportunitiesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ExecuteOpportunitiesReply}
 */
proto.entity.ExecuteOpportunitiesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.Opportunity;
      reader.readMessage(value,proto_entity_opportunity_pb.Opportunity.deserializeBinaryFromReader);
      msg.addExecutedOpportunities(value);
      break;
    case 2:
      var value = new proto_entity_opportunity_pb.OpportunityExecutionFailure;
      reader.readMessage(value,proto_entity_opportunity_pb.OpportunityExecutionFailure.deserializeBinaryFromReader);
      msg.addFailedOpportunities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ExecuteOpportunitiesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ExecuteOpportunitiesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ExecuteOpportunitiesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExecuteOpportunitiesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExecutedOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_opportunity_pb.Opportunity.serializeBinaryToWriter
    );
  }
  f = message.getFailedOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_opportunity_pb.OpportunityExecutionFailure.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Opportunity executed_opportunities = 1;
 * @return {!Array<!proto.entity.Opportunity>}
 */
proto.entity.ExecuteOpportunitiesReply.prototype.getExecutedOpportunitiesList = function() {
  return /** @type{!Array<!proto.entity.Opportunity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_opportunity_pb.Opportunity, 1));
};


/**
 * @param {!Array<!proto.entity.Opportunity>} value
 * @return {!proto.entity.ExecuteOpportunitiesReply} returns this
*/
proto.entity.ExecuteOpportunitiesReply.prototype.setExecutedOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Opportunity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Opportunity}
 */
proto.entity.ExecuteOpportunitiesReply.prototype.addExecutedOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Opportunity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ExecuteOpportunitiesReply} returns this
 */
proto.entity.ExecuteOpportunitiesReply.prototype.clearExecutedOpportunitiesList = function() {
  return this.setExecutedOpportunitiesList([]);
};


/**
 * repeated OpportunityExecutionFailure failed_opportunities = 2;
 * @return {!Array<!proto.entity.OpportunityExecutionFailure>}
 */
proto.entity.ExecuteOpportunitiesReply.prototype.getFailedOpportunitiesList = function() {
  return /** @type{!Array<!proto.entity.OpportunityExecutionFailure>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_opportunity_pb.OpportunityExecutionFailure, 2));
};


/**
 * @param {!Array<!proto.entity.OpportunityExecutionFailure>} value
 * @return {!proto.entity.ExecuteOpportunitiesReply} returns this
*/
proto.entity.ExecuteOpportunitiesReply.prototype.setFailedOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.OpportunityExecutionFailure=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunityExecutionFailure}
 */
proto.entity.ExecuteOpportunitiesReply.prototype.addFailedOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.OpportunityExecutionFailure, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ExecuteOpportunitiesReply} returns this
 */
proto.entity.ExecuteOpportunitiesReply.prototype.clearFailedOpportunitiesList = function() {
  return this.setFailedOpportunitiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateOpportunitySuspensionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateOpportunitySuspensionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateOpportunitySuspensionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunitySuspensionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newSuspension: (f = msg.getNewSuspension()) && proto_entity_opportunity_pb.NewOpportunitySuspension.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateOpportunitySuspensionRequest}
 */
proto.entity.CreateOpportunitySuspensionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateOpportunitySuspensionRequest;
  return proto.entity.CreateOpportunitySuspensionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateOpportunitySuspensionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateOpportunitySuspensionRequest}
 */
proto.entity.CreateOpportunitySuspensionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.NewOpportunitySuspension;
      reader.readMessage(value,proto_entity_opportunity_pb.NewOpportunitySuspension.deserializeBinaryFromReader);
      msg.setNewSuspension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateOpportunitySuspensionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateOpportunitySuspensionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateOpportunitySuspensionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunitySuspensionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewSuspension();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_opportunity_pb.NewOpportunitySuspension.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewOpportunitySuspension new_suspension = 1;
 * @return {?proto.entity.NewOpportunitySuspension}
 */
proto.entity.CreateOpportunitySuspensionRequest.prototype.getNewSuspension = function() {
  return /** @type{?proto.entity.NewOpportunitySuspension} */ (
    jspb.Message.getWrapperField(this, proto_entity_opportunity_pb.NewOpportunitySuspension, 1));
};


/**
 * @param {?proto.entity.NewOpportunitySuspension|undefined} value
 * @return {!proto.entity.CreateOpportunitySuspensionRequest} returns this
*/
proto.entity.CreateOpportunitySuspensionRequest.prototype.setNewSuspension = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateOpportunitySuspensionRequest} returns this
 */
proto.entity.CreateOpportunitySuspensionRequest.prototype.clearNewSuspension = function() {
  return this.setNewSuspension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateOpportunitySuspensionRequest.prototype.hasNewSuspension = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateOpportunitySuspensionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateOpportunitySuspensionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateOpportunitySuspensionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunitySuspensionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    suspension: (f = msg.getSuspension()) && proto_entity_opportunity_pb.OpportunitySuspension.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateOpportunitySuspensionReply}
 */
proto.entity.CreateOpportunitySuspensionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateOpportunitySuspensionReply;
  return proto.entity.CreateOpportunitySuspensionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateOpportunitySuspensionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateOpportunitySuspensionReply}
 */
proto.entity.CreateOpportunitySuspensionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.OpportunitySuspension;
      reader.readMessage(value,proto_entity_opportunity_pb.OpportunitySuspension.deserializeBinaryFromReader);
      msg.setSuspension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateOpportunitySuspensionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateOpportunitySuspensionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateOpportunitySuspensionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOpportunitySuspensionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuspension();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_opportunity_pb.OpportunitySuspension.serializeBinaryToWriter
    );
  }
};


/**
 * optional OpportunitySuspension suspension = 1;
 * @return {?proto.entity.OpportunitySuspension}
 */
proto.entity.CreateOpportunitySuspensionReply.prototype.getSuspension = function() {
  return /** @type{?proto.entity.OpportunitySuspension} */ (
    jspb.Message.getWrapperField(this, proto_entity_opportunity_pb.OpportunitySuspension, 1));
};


/**
 * @param {?proto.entity.OpportunitySuspension|undefined} value
 * @return {!proto.entity.CreateOpportunitySuspensionReply} returns this
*/
proto.entity.CreateOpportunitySuspensionReply.prototype.setSuspension = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateOpportunitySuspensionReply} returns this
 */
proto.entity.CreateOpportunitySuspensionReply.prototype.clearSuspension = function() {
  return this.setSuspension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateOpportunitySuspensionReply.prototype.hasSuspension = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListOpportunitySuspensionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListOpportunitySuspensionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListOpportunitySuspensionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitySuspensionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    includeExpired: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListOpportunitySuspensionsRequest}
 */
proto.entity.ListOpportunitySuspensionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListOpportunitySuspensionsRequest;
  return proto.entity.ListOpportunitySuspensionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListOpportunitySuspensionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListOpportunitySuspensionsRequest}
 */
proto.entity.ListOpportunitySuspensionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeExpired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListOpportunitySuspensionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListOpportunitySuspensionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListOpportunitySuspensionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitySuspensionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getIncludeExpired();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListOpportunitySuspensionsRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListOpportunitySuspensionsRequest} returns this
*/
proto.entity.ListOpportunitySuspensionsRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListOpportunitySuspensionsRequest} returns this
 */
proto.entity.ListOpportunitySuspensionsRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListOpportunitySuspensionsRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool include_expired = 2;
 * @return {boolean}
 */
proto.entity.ListOpportunitySuspensionsRequest.prototype.getIncludeExpired = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.ListOpportunitySuspensionsRequest} returns this
 */
proto.entity.ListOpportunitySuspensionsRequest.prototype.setIncludeExpired = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListOpportunitySuspensionsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListOpportunitySuspensionsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListOpportunitySuspensionsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListOpportunitySuspensionsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitySuspensionsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    suspensionsList: jspb.Message.toObjectList(msg.getSuspensionsList(),
    proto_entity_opportunity_pb.OpportunitySuspension.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListOpportunitySuspensionsReply}
 */
proto.entity.ListOpportunitySuspensionsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListOpportunitySuspensionsReply;
  return proto.entity.ListOpportunitySuspensionsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListOpportunitySuspensionsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListOpportunitySuspensionsReply}
 */
proto.entity.ListOpportunitySuspensionsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.OpportunitySuspension;
      reader.readMessage(value,proto_entity_opportunity_pb.OpportunitySuspension.deserializeBinaryFromReader);
      msg.addSuspensions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListOpportunitySuspensionsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListOpportunitySuspensionsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListOpportunitySuspensionsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListOpportunitySuspensionsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuspensionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_opportunity_pb.OpportunitySuspension.serializeBinaryToWriter
    );
  }
};


/**
 * repeated OpportunitySuspension suspensions = 1;
 * @return {!Array<!proto.entity.OpportunitySuspension>}
 */
proto.entity.ListOpportunitySuspensionsReply.prototype.getSuspensionsList = function() {
  return /** @type{!Array<!proto.entity.OpportunitySuspension>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_opportunity_pb.OpportunitySuspension, 1));
};


/**
 * @param {!Array<!proto.entity.OpportunitySuspension>} value
 * @return {!proto.entity.ListOpportunitySuspensionsReply} returns this
*/
proto.entity.ListOpportunitySuspensionsReply.prototype.setSuspensionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.OpportunitySuspension=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.OpportunitySuspension}
 */
proto.entity.ListOpportunitySuspensionsReply.prototype.addSuspensions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.OpportunitySuspension, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListOpportunitySuspensionsReply} returns this
 */
proto.entity.ListOpportunitySuspensionsReply.prototype.clearSuspensionsList = function() {
  return this.setSuspensionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOpportunitySuspensionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOpportunitySuspensionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOpportunitySuspensionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    suspensionId: (f = msg.getSuspensionId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    expirationTime: (f = msg.getExpirationTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    pb_delete: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest}
 */
proto.entity.UpdateOpportunitySuspensionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOpportunitySuspensionRequest;
  return proto.entity.UpdateOpportunitySuspensionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOpportunitySuspensionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest}
 */
proto.entity.UpdateOpportunitySuspensionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setSuspensionId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpirationTime(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDelete(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOpportunitySuspensionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOpportunitySuspensionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOpportunitySuspensionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getSuspensionId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getExpirationTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDelete();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest} returns this
*/
proto.entity.UpdateOpportunitySuspensionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest} returns this
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional common.ObjectID suspension_id = 2;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.getSuspensionId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest} returns this
*/
proto.entity.UpdateOpportunitySuspensionRequest.prototype.setSuspensionId = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest} returns this
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.clearSuspensionId = function() {
  return this.setSuspensionId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.hasSuspensionId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp expiration_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.getExpirationTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest} returns this
*/
proto.entity.UpdateOpportunitySuspensionRequest.prototype.setExpirationTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest} returns this
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.clearExpirationTime = function() {
  return this.setExpirationTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.hasExpirationTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool delete = 4;
 * @return {boolean}
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.getDelete = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.UpdateOpportunitySuspensionRequest} returns this
 */
proto.entity.UpdateOpportunitySuspensionRequest.prototype.setDelete = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOpportunitySuspensionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOpportunitySuspensionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOpportunitySuspensionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOpportunitySuspensionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    suspension: (f = msg.getSuspension()) && proto_entity_opportunity_pb.OpportunitySuspension.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOpportunitySuspensionReply}
 */
proto.entity.UpdateOpportunitySuspensionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOpportunitySuspensionReply;
  return proto.entity.UpdateOpportunitySuspensionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOpportunitySuspensionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOpportunitySuspensionReply}
 */
proto.entity.UpdateOpportunitySuspensionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.OpportunitySuspension;
      reader.readMessage(value,proto_entity_opportunity_pb.OpportunitySuspension.deserializeBinaryFromReader);
      msg.setSuspension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOpportunitySuspensionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOpportunitySuspensionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOpportunitySuspensionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOpportunitySuspensionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuspension();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_opportunity_pb.OpportunitySuspension.serializeBinaryToWriter
    );
  }
};


/**
 * optional OpportunitySuspension suspension = 1;
 * @return {?proto.entity.OpportunitySuspension}
 */
proto.entity.UpdateOpportunitySuspensionReply.prototype.getSuspension = function() {
  return /** @type{?proto.entity.OpportunitySuspension} */ (
    jspb.Message.getWrapperField(this, proto_entity_opportunity_pb.OpportunitySuspension, 1));
};


/**
 * @param {?proto.entity.OpportunitySuspension|undefined} value
 * @return {!proto.entity.UpdateOpportunitySuspensionReply} returns this
*/
proto.entity.UpdateOpportunitySuspensionReply.prototype.setSuspension = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOpportunitySuspensionReply} returns this
 */
proto.entity.UpdateOpportunitySuspensionReply.prototype.clearSuspension = function() {
  return this.setSuspension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOpportunitySuspensionReply.prototype.hasSuspension = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HasExecutedActionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HasExecutedActionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HasExecutedActionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasExecutedActionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HasExecutedActionsRequest}
 */
proto.entity.HasExecutedActionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HasExecutedActionsRequest;
  return proto.entity.HasExecutedActionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HasExecutedActionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HasExecutedActionsRequest}
 */
proto.entity.HasExecutedActionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HasExecutedActionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HasExecutedActionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HasExecutedActionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasExecutedActionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.HasExecutedActionsRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.HasExecutedActionsRequest} returns this
*/
proto.entity.HasExecutedActionsRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.HasExecutedActionsRequest} returns this
 */
proto.entity.HasExecutedActionsRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.HasExecutedActionsRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.HasExecutedActionsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.HasExecutedActionsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.HasExecutedActionsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasExecutedActionsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    hasExecutedActions: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.HasExecutedActionsReply}
 */
proto.entity.HasExecutedActionsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.HasExecutedActionsReply;
  return proto.entity.HasExecutedActionsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.HasExecutedActionsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.HasExecutedActionsReply}
 */
proto.entity.HasExecutedActionsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasExecutedActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.HasExecutedActionsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.HasExecutedActionsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.HasExecutedActionsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.HasExecutedActionsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHasExecutedActions();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool has_executed_actions = 1;
 * @return {boolean}
 */
proto.entity.HasExecutedActionsReply.prototype.getHasExecutedActions = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.HasExecutedActionsReply} returns this
 */
proto.entity.HasExecutedActionsReply.prototype.setHasExecutedActions = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSuspendedOpportunitiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSuspendedOpportunitiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSuspendedOpportunitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSuspendedOpportunitiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSuspendedOpportunitiesRequest}
 */
proto.entity.ListSuspendedOpportunitiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSuspendedOpportunitiesRequest;
  return proto.entity.ListSuspendedOpportunitiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSuspendedOpportunitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSuspendedOpportunitiesRequest}
 */
proto.entity.ListSuspendedOpportunitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSuspendedOpportunitiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSuspendedOpportunitiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSuspendedOpportunitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSuspendedOpportunitiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ListSuspendedOpportunitiesRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ListSuspendedOpportunitiesRequest} returns this
*/
proto.entity.ListSuspendedOpportunitiesRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListSuspendedOpportunitiesRequest} returns this
 */
proto.entity.ListSuspendedOpportunitiesRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListSuspendedOpportunitiesRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListSuspendedOpportunitiesReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListSuspendedOpportunitiesReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListSuspendedOpportunitiesReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListSuspendedOpportunitiesReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSuspendedOpportunitiesReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    suspendedOpportunitiesList: jspb.Message.toObjectList(msg.getSuspendedOpportunitiesList(),
    proto_entity_opportunity_pb.SuspendedOpportunity.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListSuspendedOpportunitiesReply}
 */
proto.entity.ListSuspendedOpportunitiesReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListSuspendedOpportunitiesReply;
  return proto.entity.ListSuspendedOpportunitiesReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListSuspendedOpportunitiesReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListSuspendedOpportunitiesReply}
 */
proto.entity.ListSuspendedOpportunitiesReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_opportunity_pb.SuspendedOpportunity;
      reader.readMessage(value,proto_entity_opportunity_pb.SuspendedOpportunity.deserializeBinaryFromReader);
      msg.addSuspendedOpportunities(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListSuspendedOpportunitiesReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListSuspendedOpportunitiesReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListSuspendedOpportunitiesReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListSuspendedOpportunitiesReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuspendedOpportunitiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_opportunity_pb.SuspendedOpportunity.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SuspendedOpportunity suspended_opportunities = 1;
 * @return {!Array<!proto.entity.SuspendedOpportunity>}
 */
proto.entity.ListSuspendedOpportunitiesReply.prototype.getSuspendedOpportunitiesList = function() {
  return /** @type{!Array<!proto.entity.SuspendedOpportunity>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_opportunity_pb.SuspendedOpportunity, 1));
};


/**
 * @param {!Array<!proto.entity.SuspendedOpportunity>} value
 * @return {!proto.entity.ListSuspendedOpportunitiesReply} returns this
*/
proto.entity.ListSuspendedOpportunitiesReply.prototype.setSuspendedOpportunitiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SuspendedOpportunity=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SuspendedOpportunity}
 */
proto.entity.ListSuspendedOpportunitiesReply.prototype.addSuspendedOpportunities = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SuspendedOpportunity, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListSuspendedOpportunitiesReply} returns this
 */
proto.entity.ListSuspendedOpportunitiesReply.prototype.clearSuspendedOpportunitiesList = function() {
  return this.setSuspendedOpportunitiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateUserRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userSelector: (f = msg.getUserSelector()) && proto_entity_user_pb.UserSelector.toObject(includeInstance, f),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_user_pb.UpdateUserAction.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateUserRequest}
 */
proto.entity.UpdateUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateUserRequest;
  return proto.entity.UpdateUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateUserRequest}
 */
proto.entity.UpdateUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.UserSelector;
      reader.readMessage(value,proto_entity_user_pb.UserSelector.deserializeBinaryFromReader);
      msg.setUserSelector(value);
      break;
    case 2:
      var value = new proto_entity_user_pb.UpdateUserAction;
      reader.readMessage(value,proto_entity_user_pb.UpdateUserAction.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.UserSelector.serializeBinaryToWriter
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_user_pb.UpdateUserAction.serializeBinaryToWriter
    );
  }
};


/**
 * optional UserSelector user_selector = 1;
 * @return {?proto.entity.UserSelector}
 */
proto.entity.UpdateUserRequest.prototype.getUserSelector = function() {
  return /** @type{?proto.entity.UserSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.UserSelector, 1));
};


/**
 * @param {?proto.entity.UserSelector|undefined} value
 * @return {!proto.entity.UpdateUserRequest} returns this
*/
proto.entity.UpdateUserRequest.prototype.setUserSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateUserRequest} returns this
 */
proto.entity.UpdateUserRequest.prototype.clearUserSelector = function() {
  return this.setUserSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateUserRequest.prototype.hasUserSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UpdateUserAction actions = 2;
 * @return {!Array<!proto.entity.UpdateUserAction>}
 */
proto.entity.UpdateUserRequest.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.UpdateUserAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_user_pb.UpdateUserAction, 2));
};


/**
 * @param {!Array<!proto.entity.UpdateUserAction>} value
 * @return {!proto.entity.UpdateUserRequest} returns this
*/
proto.entity.UpdateUserRequest.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.UpdateUserAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateUserAction}
 */
proto.entity.UpdateUserRequest.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.UpdateUserAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateUserRequest} returns this
 */
proto.entity.UpdateUserRequest.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateUserReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateUserReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateUserReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateUserReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    user: (f = msg.getUser()) && proto_entity_user_pb.User.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateUserReply}
 */
proto.entity.UpdateUserReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateUserReply;
  return proto.entity.UpdateUserReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateUserReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateUserReply}
 */
proto.entity.UpdateUserReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_user_pb.User;
      reader.readMessage(value,proto_entity_user_pb.User.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateUserReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateUserReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateUserReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateUserReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_user_pb.User.serializeBinaryToWriter
    );
  }
};


/**
 * optional User user = 1;
 * @return {?proto.entity.User}
 */
proto.entity.UpdateUserReply.prototype.getUser = function() {
  return /** @type{?proto.entity.User} */ (
    jspb.Message.getWrapperField(this, proto_entity_user_pb.User, 1));
};


/**
 * @param {?proto.entity.User|undefined} value
 * @return {!proto.entity.UpdateUserReply} returns this
*/
proto.entity.UpdateUserReply.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateUserReply} returns this
 */
proto.entity.UpdateUserReply.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateUserReply.prototype.hasUser = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateStripeSubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateStripeSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateStripeSubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    paymentMethodId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    plan: jspb.Message.getFieldWithDefault(msg, 3, ""),
    trialLengthInDays: jspb.Message.getFieldWithDefault(msg, 4, 0),
    couponId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    setupFeeId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateStripeSubscriptionRequest}
 */
proto.entity.CreateStripeSubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateStripeSubscriptionRequest;
  return proto.entity.CreateStripeSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateStripeSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateStripeSubscriptionRequest}
 */
proto.entity.CreateStripeSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPaymentMethodId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlan(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialLengthInDays(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCouponId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSetupFeeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateStripeSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateStripeSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateStripeSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getPaymentMethodId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlan();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTrialLengthInDays();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCouponId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSetupFeeId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.CreateStripeSubscriptionRequest} returns this
*/
proto.entity.CreateStripeSubscriptionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateStripeSubscriptionRequest} returns this
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string payment_method_id = 2;
 * @return {string}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.getPaymentMethodId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateStripeSubscriptionRequest} returns this
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.setPaymentMethodId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string plan = 3;
 * @return {string}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.getPlan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateStripeSubscriptionRequest} returns this
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.setPlan = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 trial_length_in_days = 4;
 * @return {number}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.getTrialLengthInDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.CreateStripeSubscriptionRequest} returns this
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.setTrialLengthInDays = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string coupon_id = 5;
 * @return {string}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.getCouponId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateStripeSubscriptionRequest} returns this
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.setCouponId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string setup_fee_id = 6;
 * @return {string}
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.getSetupFeeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateStripeSubscriptionRequest} returns this
 */
proto.entity.CreateStripeSubscriptionRequest.prototype.setSetupFeeId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateStripeSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateStripeSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateStripeSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    requiresAction: (f = msg.getRequiresAction()) && proto.entity.CreateStripeSubscriptionReply.RequiresAction.toObject(includeInstance, f),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    clientSecret: jspb.Message.getFieldWithDefault(msg, 3, ""),
    amountDue: jspb.Message.getFieldWithDefault(msg, 4, 0),
    appliedCoupon: (f = msg.getAppliedCoupon()) && proto_entity_billingAccount_pb.Stripe.Coupon.toObject(includeInstance, f),
    subtotal: jspb.Message.getFieldWithDefault(msg, 6, 0),
    planId: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateStripeSubscriptionReply}
 */
proto.entity.CreateStripeSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateStripeSubscriptionReply;
  return proto.entity.CreateStripeSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateStripeSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateStripeSubscriptionReply}
 */
proto.entity.CreateStripeSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.CreateStripeSubscriptionReply.RequiresAction;
      reader.readMessage(value,proto.entity.CreateStripeSubscriptionReply.RequiresAction.deserializeBinaryFromReader);
      msg.setRequiresAction(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountDue(value);
      break;
    case 5:
      var value = new proto_entity_billingAccount_pb.Stripe.Coupon;
      reader.readMessage(value,proto_entity_billingAccount_pb.Stripe.Coupon.deserializeBinaryFromReader);
      msg.setAppliedCoupon(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubtotal(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateStripeSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateStripeSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateStripeSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequiresAction();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.CreateStripeSubscriptionReply.RequiresAction.serializeBinaryToWriter
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmountDue();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getAppliedCoupon();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto_entity_billingAccount_pb.Stripe.Coupon.serializeBinaryToWriter
    );
  }
  f = message.getSubtotal();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getPlanId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateStripeSubscriptionReply.RequiresAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateStripeSubscriptionReply.RequiresAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.toObject = function(includeInstance, msg) {
  var f, obj = {
    paymentIntent: (f = msg.getPaymentIntent()) && proto_entity_billingAccount_pb.StripeAccount.PaymentIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateStripeSubscriptionReply.RequiresAction}
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateStripeSubscriptionReply.RequiresAction;
  return proto.entity.CreateStripeSubscriptionReply.RequiresAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateStripeSubscriptionReply.RequiresAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateStripeSubscriptionReply.RequiresAction}
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.StripeAccount.PaymentIntent;
      reader.readMessage(value,proto_entity_billingAccount_pb.StripeAccount.PaymentIntent.deserializeBinaryFromReader);
      msg.setPaymentIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateStripeSubscriptionReply.RequiresAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateStripeSubscriptionReply.RequiresAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_billingAccount_pb.StripeAccount.PaymentIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional StripeAccount.PaymentIntent payment_intent = 1;
 * @return {?proto.entity.StripeAccount.PaymentIntent}
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.prototype.getPaymentIntent = function() {
  return /** @type{?proto.entity.StripeAccount.PaymentIntent} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.StripeAccount.PaymentIntent, 1));
};


/**
 * @param {?proto.entity.StripeAccount.PaymentIntent|undefined} value
 * @return {!proto.entity.CreateStripeSubscriptionReply.RequiresAction} returns this
*/
proto.entity.CreateStripeSubscriptionReply.RequiresAction.prototype.setPaymentIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateStripeSubscriptionReply.RequiresAction} returns this
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.prototype.clearPaymentIntent = function() {
  return this.setPaymentIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateStripeSubscriptionReply.RequiresAction.prototype.hasPaymentIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RequiresAction requires_action = 1;
 * @return {?proto.entity.CreateStripeSubscriptionReply.RequiresAction}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.getRequiresAction = function() {
  return /** @type{?proto.entity.CreateStripeSubscriptionReply.RequiresAction} */ (
    jspb.Message.getWrapperField(this, proto.entity.CreateStripeSubscriptionReply.RequiresAction, 1));
};


/**
 * @param {?proto.entity.CreateStripeSubscriptionReply.RequiresAction|undefined} value
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
*/
proto.entity.CreateStripeSubscriptionReply.prototype.setRequiresAction = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
 */
proto.entity.CreateStripeSubscriptionReply.prototype.clearRequiresAction = function() {
  return this.setRequiresAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.hasRequiresAction = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string subscription_id = 2;
 * @return {string}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
 */
proto.entity.CreateStripeSubscriptionReply.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string client_secret = 3;
 * @return {string}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
 */
proto.entity.CreateStripeSubscriptionReply.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 amount_due = 4;
 * @return {number}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.getAmountDue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
 */
proto.entity.CreateStripeSubscriptionReply.prototype.setAmountDue = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional Stripe.Coupon applied_coupon = 5;
 * @return {?proto.entity.Stripe.Coupon}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.getAppliedCoupon = function() {
  return /** @type{?proto.entity.Stripe.Coupon} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.Stripe.Coupon, 5));
};


/**
 * @param {?proto.entity.Stripe.Coupon|undefined} value
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
*/
proto.entity.CreateStripeSubscriptionReply.prototype.setAppliedCoupon = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
 */
proto.entity.CreateStripeSubscriptionReply.prototype.clearAppliedCoupon = function() {
  return this.setAppliedCoupon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.hasAppliedCoupon = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int64 subtotal = 6;
 * @return {number}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.getSubtotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
 */
proto.entity.CreateStripeSubscriptionReply.prototype.setSubtotal = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional string plan_id = 7;
 * @return {string}
 */
proto.entity.CreateStripeSubscriptionReply.prototype.getPlanId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CreateStripeSubscriptionReply} returns this
 */
proto.entity.CreateStripeSubscriptionReply.prototype.setPlanId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CheckStripeSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CheckStripeSubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CheckStripeSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckStripeSubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CheckStripeSubscriptionRequest}
 */
proto.entity.CheckStripeSubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CheckStripeSubscriptionRequest;
  return proto.entity.CheckStripeSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CheckStripeSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CheckStripeSubscriptionRequest}
 */
proto.entity.CheckStripeSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CheckStripeSubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CheckStripeSubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CheckStripeSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckStripeSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.CheckStripeSubscriptionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.CheckStripeSubscriptionRequest} returns this
*/
proto.entity.CheckStripeSubscriptionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CheckStripeSubscriptionRequest} returns this
 */
proto.entity.CheckStripeSubscriptionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CheckStripeSubscriptionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CheckStripeSubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CheckStripeSubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CheckStripeSubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckStripeSubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CheckStripeSubscriptionReply}
 */
proto.entity.CheckStripeSubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CheckStripeSubscriptionReply;
  return proto.entity.CheckStripeSubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CheckStripeSubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CheckStripeSubscriptionReply}
 */
proto.entity.CheckStripeSubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CheckStripeSubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CheckStripeSubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CheckStripeSubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckStripeSubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.PrepareStripeInvoicingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.PrepareStripeInvoicingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.PrepareStripeInvoicingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareStripeInvoicingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.PrepareStripeInvoicingRequest}
 */
proto.entity.PrepareStripeInvoicingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.PrepareStripeInvoicingRequest;
  return proto.entity.PrepareStripeInvoicingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.PrepareStripeInvoicingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.PrepareStripeInvoicingRequest}
 */
proto.entity.PrepareStripeInvoicingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.PrepareStripeInvoicingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.PrepareStripeInvoicingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.PrepareStripeInvoicingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareStripeInvoicingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.PrepareStripeInvoicingRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.PrepareStripeInvoicingRequest} returns this
*/
proto.entity.PrepareStripeInvoicingRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.PrepareStripeInvoicingRequest} returns this
 */
proto.entity.PrepareStripeInvoicingRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.PrepareStripeInvoicingRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.PrepareStripeInvoicingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.PrepareStripeInvoicingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.PrepareStripeInvoicingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareStripeInvoicingReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    setupIntent: (f = msg.getSetupIntent()) && proto_entity_billingAccount_pb.Stripe.SetupIntent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.PrepareStripeInvoicingReply}
 */
proto.entity.PrepareStripeInvoicingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.PrepareStripeInvoicingReply;
  return proto.entity.PrepareStripeInvoicingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.PrepareStripeInvoicingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.PrepareStripeInvoicingReply}
 */
proto.entity.PrepareStripeInvoicingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_billingAccount_pb.Stripe.SetupIntent;
      reader.readMessage(value,proto_entity_billingAccount_pb.Stripe.SetupIntent.deserializeBinaryFromReader);
      msg.setSetupIntent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.PrepareStripeInvoicingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.PrepareStripeInvoicingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.PrepareStripeInvoicingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareStripeInvoicingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSetupIntent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_billingAccount_pb.Stripe.SetupIntent.serializeBinaryToWriter
    );
  }
};


/**
 * optional Stripe.SetupIntent setup_intent = 1;
 * @return {?proto.entity.Stripe.SetupIntent}
 */
proto.entity.PrepareStripeInvoicingReply.prototype.getSetupIntent = function() {
  return /** @type{?proto.entity.Stripe.SetupIntent} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.Stripe.SetupIntent, 1));
};


/**
 * @param {?proto.entity.Stripe.SetupIntent|undefined} value
 * @return {!proto.entity.PrepareStripeInvoicingReply} returns this
*/
proto.entity.PrepareStripeInvoicingReply.prototype.setSetupIntent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.PrepareStripeInvoicingReply} returns this
 */
proto.entity.PrepareStripeInvoicingReply.prototype.clearSetupIntent = function() {
  return this.setSetupIntent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.PrepareStripeInvoicingReply.prototype.hasSetupIntent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.FinalizeStripeInvoicingRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.FinalizeStripeInvoicingRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.FinalizeStripeInvoicingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FinalizeStripeInvoicingRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    setupIntentId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.FinalizeStripeInvoicingRequest}
 */
proto.entity.FinalizeStripeInvoicingRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.FinalizeStripeInvoicingRequest;
  return proto.entity.FinalizeStripeInvoicingRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.FinalizeStripeInvoicingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.FinalizeStripeInvoicingRequest}
 */
proto.entity.FinalizeStripeInvoicingRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSetupIntentId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.FinalizeStripeInvoicingRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.FinalizeStripeInvoicingRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.FinalizeStripeInvoicingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FinalizeStripeInvoicingRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getSetupIntentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.FinalizeStripeInvoicingRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.FinalizeStripeInvoicingRequest} returns this
*/
proto.entity.FinalizeStripeInvoicingRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.FinalizeStripeInvoicingRequest} returns this
 */
proto.entity.FinalizeStripeInvoicingRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.FinalizeStripeInvoicingRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string setup_intent_id = 2;
 * @return {string}
 */
proto.entity.FinalizeStripeInvoicingRequest.prototype.getSetupIntentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.FinalizeStripeInvoicingRequest} returns this
 */
proto.entity.FinalizeStripeInvoicingRequest.prototype.setSetupIntentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.FinalizeStripeInvoicingReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.FinalizeStripeInvoicingReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.FinalizeStripeInvoicingReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FinalizeStripeInvoicingReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.FinalizeStripeInvoicingReply}
 */
proto.entity.FinalizeStripeInvoicingReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.FinalizeStripeInvoicingReply;
  return proto.entity.FinalizeStripeInvoicingReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.FinalizeStripeInvoicingReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.FinalizeStripeInvoicingReply}
 */
proto.entity.FinalizeStripeInvoicingReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.FinalizeStripeInvoicingReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.FinalizeStripeInvoicingReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.FinalizeStripeInvoicingReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FinalizeStripeInvoicingReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ApplyStripeCouponRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ApplyStripeCouponRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ApplyStripeCouponRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ApplyStripeCouponRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    couponId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ApplyStripeCouponRequest}
 */
proto.entity.ApplyStripeCouponRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ApplyStripeCouponRequest;
  return proto.entity.ApplyStripeCouponRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ApplyStripeCouponRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ApplyStripeCouponRequest}
 */
proto.entity.ApplyStripeCouponRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCouponId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ApplyStripeCouponRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ApplyStripeCouponRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ApplyStripeCouponRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ApplyStripeCouponRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCouponId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string subscription_id = 1;
 * @return {string}
 */
proto.entity.ApplyStripeCouponRequest.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ApplyStripeCouponRequest} returns this
 */
proto.entity.ApplyStripeCouponRequest.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string coupon_id = 2;
 * @return {string}
 */
proto.entity.ApplyStripeCouponRequest.prototype.getCouponId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ApplyStripeCouponRequest} returns this
 */
proto.entity.ApplyStripeCouponRequest.prototype.setCouponId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ApplyStripeCouponReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ApplyStripeCouponReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ApplyStripeCouponReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ApplyStripeCouponReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    success: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    clientSecret: jspb.Message.getFieldWithDefault(msg, 8, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    amountDue: jspb.Message.getFieldWithDefault(msg, 10, 0),
    appliedCoupon: (f = msg.getAppliedCoupon()) && proto_entity_billingAccount_pb.Stripe.Coupon.toObject(includeInstance, f),
    subtotal: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ApplyStripeCouponReply}
 */
proto.entity.ApplyStripeCouponReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ApplyStripeCouponReply;
  return proto.entity.ApplyStripeCouponReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ApplyStripeCouponReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ApplyStripeCouponReply}
 */
proto.entity.ApplyStripeCouponReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setClientSecret(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountDue(value);
      break;
    case 11:
      var value = new proto_entity_billingAccount_pb.Stripe.Coupon;
      reader.readMessage(value,proto_entity_billingAccount_pb.Stripe.Coupon.deserializeBinaryFromReader);
      msg.setAppliedCoupon(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSubtotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ApplyStripeCouponReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ApplyStripeCouponReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ApplyStripeCouponReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ApplyStripeCouponReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getClientSecret();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getAmountDue();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getAppliedCoupon();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto_entity_billingAccount_pb.Stripe.Coupon.serializeBinaryToWriter
    );
  }
  f = message.getSubtotal();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
};


/**
 * optional bool success = 1;
 * @return {boolean}
 */
proto.entity.ApplyStripeCouponReply.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.ApplyStripeCouponReply} returns this
 */
proto.entity.ApplyStripeCouponReply.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional string client_secret = 8;
 * @return {string}
 */
proto.entity.ApplyStripeCouponReply.prototype.getClientSecret = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ApplyStripeCouponReply} returns this
 */
proto.entity.ApplyStripeCouponReply.prototype.setClientSecret = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string subscription_id = 9;
 * @return {string}
 */
proto.entity.ApplyStripeCouponReply.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ApplyStripeCouponReply} returns this
 */
proto.entity.ApplyStripeCouponReply.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int64 amount_due = 10;
 * @return {number}
 */
proto.entity.ApplyStripeCouponReply.prototype.getAmountDue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.ApplyStripeCouponReply} returns this
 */
proto.entity.ApplyStripeCouponReply.prototype.setAmountDue = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional Stripe.Coupon applied_coupon = 11;
 * @return {?proto.entity.Stripe.Coupon}
 */
proto.entity.ApplyStripeCouponReply.prototype.getAppliedCoupon = function() {
  return /** @type{?proto.entity.Stripe.Coupon} */ (
    jspb.Message.getWrapperField(this, proto_entity_billingAccount_pb.Stripe.Coupon, 11));
};


/**
 * @param {?proto.entity.Stripe.Coupon|undefined} value
 * @return {!proto.entity.ApplyStripeCouponReply} returns this
*/
proto.entity.ApplyStripeCouponReply.prototype.setAppliedCoupon = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ApplyStripeCouponReply} returns this
 */
proto.entity.ApplyStripeCouponReply.prototype.clearAppliedCoupon = function() {
  return this.setAppliedCoupon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ApplyStripeCouponReply.prototype.hasAppliedCoupon = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int64 subtotal = 12;
 * @return {number}
 */
proto.entity.ApplyStripeCouponReply.prototype.getSubtotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.ApplyStripeCouponReply} returns this
 */
proto.entity.ApplyStripeCouponReply.prototype.setSubtotal = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.PrepareShopifySubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.PrepareShopifySubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareShopifySubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    returnUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    plan: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.PrepareShopifySubscriptionRequest}
 */
proto.entity.PrepareShopifySubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.PrepareShopifySubscriptionRequest;
  return proto.entity.PrepareShopifySubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.PrepareShopifySubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.PrepareShopifySubscriptionRequest}
 */
proto.entity.PrepareShopifySubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReturnUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.PrepareShopifySubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.PrepareShopifySubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareShopifySubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getReturnUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlan();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.PrepareShopifySubscriptionRequest} returns this
*/
proto.entity.PrepareShopifySubscriptionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.PrepareShopifySubscriptionRequest} returns this
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string return_url = 2;
 * @return {string}
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.getReturnUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.PrepareShopifySubscriptionRequest} returns this
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.setReturnUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string plan = 3;
 * @return {string}
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.getPlan = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.PrepareShopifySubscriptionRequest} returns this
 */
proto.entity.PrepareShopifySubscriptionRequest.prototype.setPlan = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.PrepareShopifySubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.PrepareShopifySubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.PrepareShopifySubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareShopifySubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    confirmationUrl: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.PrepareShopifySubscriptionReply}
 */
proto.entity.PrepareShopifySubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.PrepareShopifySubscriptionReply;
  return proto.entity.PrepareShopifySubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.PrepareShopifySubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.PrepareShopifySubscriptionReply}
 */
proto.entity.PrepareShopifySubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfirmationUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.PrepareShopifySubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.PrepareShopifySubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.PrepareShopifySubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.PrepareShopifySubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfirmationUrl();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string confirmation_url = 1;
 * @return {string}
 */
proto.entity.PrepareShopifySubscriptionReply.prototype.getConfirmationUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.PrepareShopifySubscriptionReply} returns this
 */
proto.entity.PrepareShopifySubscriptionReply.prototype.setConfirmationUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ActivateShopifySubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ActivateShopifySubscriptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ActivateShopifySubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ActivateShopifySubscriptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    recurringChargeId: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ActivateShopifySubscriptionRequest}
 */
proto.entity.ActivateShopifySubscriptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ActivateShopifySubscriptionRequest;
  return proto.entity.ActivateShopifySubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ActivateShopifySubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ActivateShopifySubscriptionRequest}
 */
proto.entity.ActivateShopifySubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRecurringChargeId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ActivateShopifySubscriptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ActivateShopifySubscriptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ActivateShopifySubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ActivateShopifySubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getRecurringChargeId();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.ActivateShopifySubscriptionRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.ActivateShopifySubscriptionRequest} returns this
*/
proto.entity.ActivateShopifySubscriptionRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ActivateShopifySubscriptionRequest} returns this
 */
proto.entity.ActivateShopifySubscriptionRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ActivateShopifySubscriptionRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 recurring_charge_id = 2;
 * @return {number}
 */
proto.entity.ActivateShopifySubscriptionRequest.prototype.getRecurringChargeId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.ActivateShopifySubscriptionRequest} returns this
 */
proto.entity.ActivateShopifySubscriptionRequest.prototype.setRecurringChargeId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ActivateShopifySubscriptionReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ActivateShopifySubscriptionReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ActivateShopifySubscriptionReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ActivateShopifySubscriptionReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ActivateShopifySubscriptionReply}
 */
proto.entity.ActivateShopifySubscriptionReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ActivateShopifySubscriptionReply;
  return proto.entity.ActivateShopifySubscriptionReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ActivateShopifySubscriptionReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ActivateShopifySubscriptionReply}
 */
proto.entity.ActivateShopifySubscriptionReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ActivateShopifySubscriptionReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ActivateShopifySubscriptionReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ActivateShopifySubscriptionReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ActivateShopifySubscriptionReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GetEligibleSubscriptionPlansRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GetEligibleSubscriptionPlansRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GetEligibleSubscriptionPlansRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetEligibleSubscriptionPlansRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GetEligibleSubscriptionPlansRequest}
 */
proto.entity.GetEligibleSubscriptionPlansRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GetEligibleSubscriptionPlansRequest;
  return proto.entity.GetEligibleSubscriptionPlansRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GetEligibleSubscriptionPlansRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GetEligibleSubscriptionPlansRequest}
 */
proto.entity.GetEligibleSubscriptionPlansRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GetEligibleSubscriptionPlansRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GetEligibleSubscriptionPlansRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GetEligibleSubscriptionPlansRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetEligibleSubscriptionPlansRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.GetEligibleSubscriptionPlansRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.GetEligibleSubscriptionPlansRequest} returns this
*/
proto.entity.GetEligibleSubscriptionPlansRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.GetEligibleSubscriptionPlansRequest} returns this
 */
proto.entity.GetEligibleSubscriptionPlansRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.GetEligibleSubscriptionPlansRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.GetEligibleSubscriptionPlansReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.GetEligibleSubscriptionPlansReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.GetEligibleSubscriptionPlansReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.GetEligibleSubscriptionPlansReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetEligibleSubscriptionPlansReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscriptionPlansList: jspb.Message.toObjectList(msg.getSubscriptionPlansList(),
    proto_common_subscriptionPlan_pb.SubscriptionPlan.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.GetEligibleSubscriptionPlansReply}
 */
proto.entity.GetEligibleSubscriptionPlansReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.GetEligibleSubscriptionPlansReply;
  return proto.entity.GetEligibleSubscriptionPlansReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.GetEligibleSubscriptionPlansReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.GetEligibleSubscriptionPlansReply}
 */
proto.entity.GetEligibleSubscriptionPlansReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_subscriptionPlan_pb.SubscriptionPlan;
      reader.readMessage(value,proto_common_subscriptionPlan_pb.SubscriptionPlan.deserializeBinaryFromReader);
      msg.addSubscriptionPlans(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.GetEligibleSubscriptionPlansReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.GetEligibleSubscriptionPlansReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.GetEligibleSubscriptionPlansReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.GetEligibleSubscriptionPlansReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscriptionPlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_common_subscriptionPlan_pb.SubscriptionPlan.serializeBinaryToWriter
    );
  }
};


/**
 * repeated common.SubscriptionPlan subscription_plans = 1;
 * @return {!Array<!proto.common.SubscriptionPlan>}
 */
proto.entity.GetEligibleSubscriptionPlansReply.prototype.getSubscriptionPlansList = function() {
  return /** @type{!Array<!proto.common.SubscriptionPlan>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_subscriptionPlan_pb.SubscriptionPlan, 1));
};


/**
 * @param {!Array<!proto.common.SubscriptionPlan>} value
 * @return {!proto.entity.GetEligibleSubscriptionPlansReply} returns this
*/
proto.entity.GetEligibleSubscriptionPlansReply.prototype.setSubscriptionPlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.SubscriptionPlan=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.SubscriptionPlan}
 */
proto.entity.GetEligibleSubscriptionPlansReply.prototype.addSubscriptionPlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.SubscriptionPlan, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.GetEligibleSubscriptionPlansReply} returns this
 */
proto.entity.GetEligibleSubscriptionPlansReply.prototype.clearSubscriptionPlansList = function() {
  return this.setSubscriptionPlansList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CheckHMACRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CheckHMACRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CheckHMACRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckHMACRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    data: jspb.Message.getFieldWithDefault(msg, 2, ""),
    hmac: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CheckHMACRequest}
 */
proto.entity.CheckHMACRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CheckHMACRequest;
  return proto.entity.CheckHMACRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CheckHMACRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CheckHMACRequest}
 */
proto.entity.CheckHMACRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setHmac(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CheckHMACRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CheckHMACRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CheckHMACRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckHMACRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getHmac();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string key_name = 1;
 * @return {string}
 */
proto.entity.CheckHMACRequest.prototype.getKeyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CheckHMACRequest} returns this
 */
proto.entity.CheckHMACRequest.prototype.setKeyName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string data = 2;
 * @return {string}
 */
proto.entity.CheckHMACRequest.prototype.getData = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CheckHMACRequest} returns this
 */
proto.entity.CheckHMACRequest.prototype.setData = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string hmac = 3;
 * @return {string}
 */
proto.entity.CheckHMACRequest.prototype.getHmac = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.CheckHMACRequest} returns this
 */
proto.entity.CheckHMACRequest.prototype.setHmac = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CheckHMACReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CheckHMACReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CheckHMACReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckHMACReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CheckHMACReply}
 */
proto.entity.CheckHMACReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CheckHMACReply;
  return proto.entity.CheckHMACReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CheckHMACReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CheckHMACReply}
 */
proto.entity.CheckHMACReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CheckHMACReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CheckHMACReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CheckHMACReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CheckHMACReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.SendOpportunityReportRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SendOpportunityReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SendOpportunityReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SendOpportunityReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SendOpportunityReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    reportData: (f = msg.getReportData()) && proto_entity_reporting_pb.OpportunityReportData.toObject(includeInstance, f),
    recipientEmailsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    stageDataOnly: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SendOpportunityReportRequest}
 */
proto.entity.SendOpportunityReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SendOpportunityReportRequest;
  return proto.entity.SendOpportunityReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SendOpportunityReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SendOpportunityReportRequest}
 */
proto.entity.SendOpportunityReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_reporting_pb.OpportunityReportData;
      reader.readMessage(value,proto_entity_reporting_pb.OpportunityReportData.deserializeBinaryFromReader);
      msg.setReportData(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addRecipientEmails(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStageDataOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SendOpportunityReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SendOpportunityReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SendOpportunityReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SendOpportunityReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getReportData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_reporting_pb.OpportunityReportData.serializeBinaryToWriter
    );
  }
  f = message.getRecipientEmailsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getStageDataOnly();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.SendOpportunityReportRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
*/
proto.entity.SendOpportunityReportRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
 */
proto.entity.SendOpportunityReportRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SendOpportunityReportRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OpportunityReportData report_data = 2;
 * @return {?proto.entity.OpportunityReportData}
 */
proto.entity.SendOpportunityReportRequest.prototype.getReportData = function() {
  return /** @type{?proto.entity.OpportunityReportData} */ (
    jspb.Message.getWrapperField(this, proto_entity_reporting_pb.OpportunityReportData, 2));
};


/**
 * @param {?proto.entity.OpportunityReportData|undefined} value
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
*/
proto.entity.SendOpportunityReportRequest.prototype.setReportData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
 */
proto.entity.SendOpportunityReportRequest.prototype.clearReportData = function() {
  return this.setReportData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.SendOpportunityReportRequest.prototype.hasReportData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string recipient_emails = 3;
 * @return {!Array<string>}
 */
proto.entity.SendOpportunityReportRequest.prototype.getRecipientEmailsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
 */
proto.entity.SendOpportunityReportRequest.prototype.setRecipientEmailsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
 */
proto.entity.SendOpportunityReportRequest.prototype.addRecipientEmails = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
 */
proto.entity.SendOpportunityReportRequest.prototype.clearRecipientEmailsList = function() {
  return this.setRecipientEmailsList([]);
};


/**
 * optional bool stage_data_only = 4;
 * @return {boolean}
 */
proto.entity.SendOpportunityReportRequest.prototype.getStageDataOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.SendOpportunityReportRequest} returns this
 */
proto.entity.SendOpportunityReportRequest.prototype.setStageDataOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SendOpportunityReportReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SendOpportunityReportReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SendOpportunityReportReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SendOpportunityReportReply.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SendOpportunityReportReply}
 */
proto.entity.SendOpportunityReportReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SendOpportunityReportReply;
  return proto.entity.SendOpportunityReportReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SendOpportunityReportReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SendOpportunityReportReply}
 */
proto.entity.SendOpportunityReportReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SendOpportunityReportReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SendOpportunityReportReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SendOpportunityReportReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SendOpportunityReportReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryShopifyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryShopifyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryShopifyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryShopifyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    shop: jspb.Message.getFieldWithDefault(msg, 4, ""),
    shopifyApiVersion: jspb.Message.getFieldWithDefault(msg, 2, ""),
    queryPath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    queryParamsMap: (f = msg.getQueryParamsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryShopifyRequest}
 */
proto.entity.QueryShopifyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryShopifyRequest;
  return proto.entity.QueryShopifyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryShopifyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryShopifyRequest}
 */
proto.entity.QueryShopifyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setShop(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopifyApiVersion(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setQueryPath(value);
      break;
    case 5:
      var value = msg.getQueryParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryShopifyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryShopifyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryShopifyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryShopifyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getShop();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShopifyApiVersion();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getQueryPath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQueryParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.QueryShopifyRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.QueryShopifyRequest} returns this
*/
proto.entity.QueryShopifyRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QueryShopifyRequest} returns this
 */
proto.entity.QueryShopifyRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QueryShopifyRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string shop = 4;
 * @return {string}
 */
proto.entity.QueryShopifyRequest.prototype.getShop = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyRequest} returns this
 */
proto.entity.QueryShopifyRequest.prototype.setShop = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string shopify_api_version = 2;
 * @return {string}
 */
proto.entity.QueryShopifyRequest.prototype.getShopifyApiVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyRequest} returns this
 */
proto.entity.QueryShopifyRequest.prototype.setShopifyApiVersion = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string query_path = 3;
 * @return {string}
 */
proto.entity.QueryShopifyRequest.prototype.getQueryPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyRequest} returns this
 */
proto.entity.QueryShopifyRequest.prototype.setQueryPath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> query_params = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.QueryShopifyRequest.prototype.getQueryParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.QueryShopifyRequest} returns this
 */
proto.entity.QueryShopifyRequest.prototype.clearQueryParamsMap = function() {
  this.getQueryParamsMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryShopifyReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryShopifyReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryShopifyReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryShopifyReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    jsonReply: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nextUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    previousUrl: jspb.Message.getFieldWithDefault(msg, 3, ""),
    nextQueryPath: jspb.Message.getFieldWithDefault(msg, 4, ""),
    previousQueryPath: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryShopifyReply}
 */
proto.entity.QueryShopifyReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryShopifyReply;
  return proto.entity.QueryShopifyReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryShopifyReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryShopifyReply}
 */
proto.entity.QueryShopifyReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonReply(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousUrl(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextQueryPath(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPreviousQueryPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryShopifyReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryShopifyReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryShopifyReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryShopifyReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJsonReply();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNextUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPreviousUrl();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getNextQueryPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPreviousQueryPath();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string json_reply = 1;
 * @return {string}
 */
proto.entity.QueryShopifyReply.prototype.getJsonReply = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyReply} returns this
 */
proto.entity.QueryShopifyReply.prototype.setJsonReply = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string next_url = 2;
 * @return {string}
 */
proto.entity.QueryShopifyReply.prototype.getNextUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyReply} returns this
 */
proto.entity.QueryShopifyReply.prototype.setNextUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string previous_url = 3;
 * @return {string}
 */
proto.entity.QueryShopifyReply.prototype.getPreviousUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyReply} returns this
 */
proto.entity.QueryShopifyReply.prototype.setPreviousUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string next_query_path = 4;
 * @return {string}
 */
proto.entity.QueryShopifyReply.prototype.getNextQueryPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyReply} returns this
 */
proto.entity.QueryShopifyReply.prototype.setNextQueryPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string previous_query_path = 5;
 * @return {string}
 */
proto.entity.QueryShopifyReply.prototype.getPreviousQueryPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryShopifyReply} returns this
 */
proto.entity.QueryShopifyReply.prototype.setPreviousQueryPath = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryBigCommerceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryBigCommerceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryBigCommerceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryBigCommerceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteSelector: (f = msg.getSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    storeHash: jspb.Message.getFieldWithDefault(msg, 2, ""),
    resourcePath: jspb.Message.getFieldWithDefault(msg, 3, ""),
    queryParamsMap: (f = msg.getQueryParamsMap()) ? f.toObject(includeInstance, undefined) : [],
    page: jspb.Message.getFieldWithDefault(msg, 5, 0),
    limit: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryBigCommerceRequest}
 */
proto.entity.QueryBigCommerceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryBigCommerceRequest;
  return proto.entity.QueryBigCommerceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryBigCommerceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryBigCommerceRequest}
 */
proto.entity.QueryBigCommerceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setSiteSelector(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreHash(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setResourcePath(value);
      break;
    case 4:
      var value = msg.getQueryParamsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLimit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryBigCommerceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryBigCommerceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryBigCommerceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryBigCommerceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getStoreHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResourcePath();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getQueryParamsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional SiteSelector site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.QueryBigCommerceRequest.prototype.getSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.QueryBigCommerceRequest} returns this
*/
proto.entity.QueryBigCommerceRequest.prototype.setSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QueryBigCommerceRequest} returns this
 */
proto.entity.QueryBigCommerceRequest.prototype.clearSiteSelector = function() {
  return this.setSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QueryBigCommerceRequest.prototype.hasSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string store_hash = 2;
 * @return {string}
 */
proto.entity.QueryBigCommerceRequest.prototype.getStoreHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryBigCommerceRequest} returns this
 */
proto.entity.QueryBigCommerceRequest.prototype.setStoreHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string resource_path = 3;
 * @return {string}
 */
proto.entity.QueryBigCommerceRequest.prototype.getResourcePath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryBigCommerceRequest} returns this
 */
proto.entity.QueryBigCommerceRequest.prototype.setResourcePath = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * map<string, string> query_params = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.entity.QueryBigCommerceRequest.prototype.getQueryParamsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.QueryBigCommerceRequest} returns this
 */
proto.entity.QueryBigCommerceRequest.prototype.clearQueryParamsMap = function() {
  this.getQueryParamsMap().clear();
  return this;};


/**
 * optional int32 page = 5;
 * @return {number}
 */
proto.entity.QueryBigCommerceRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.QueryBigCommerceRequest} returns this
 */
proto.entity.QueryBigCommerceRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 limit = 6;
 * @return {number}
 */
proto.entity.QueryBigCommerceRequest.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.QueryBigCommerceRequest} returns this
 */
proto.entity.QueryBigCommerceRequest.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryBigCommerceReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryBigCommerceReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryBigCommerceReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryBigCommerceReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    jsonReply: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryBigCommerceReply}
 */
proto.entity.QueryBigCommerceReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryBigCommerceReply;
  return proto.entity.QueryBigCommerceReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryBigCommerceReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryBigCommerceReply}
 */
proto.entity.QueryBigCommerceReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setJsonReply(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryBigCommerceReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryBigCommerceReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryBigCommerceReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryBigCommerceReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getJsonReply();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string json_reply = 1;
 * @return {string}
 */
proto.entity.QueryBigCommerceReply.prototype.getJsonReply = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.QueryBigCommerceReply} returns this
 */
proto.entity.QueryBigCommerceReply.prototype.setJsonReply = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newOrganization: (f = msg.getNewOrganization()) && proto_entity_organization_pb.NewOrganization.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateOrganizationRequest}
 */
proto.entity.CreateOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateOrganizationRequest;
  return proto.entity.CreateOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateOrganizationRequest}
 */
proto.entity.CreateOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_organization_pb.NewOrganization;
      reader.readMessage(value,proto_entity_organization_pb.NewOrganization.deserializeBinaryFromReader);
      msg.setNewOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_organization_pb.NewOrganization.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewOrganization new_organization = 1;
 * @return {?proto.entity.NewOrganization}
 */
proto.entity.CreateOrganizationRequest.prototype.getNewOrganization = function() {
  return /** @type{?proto.entity.NewOrganization} */ (
    jspb.Message.getWrapperField(this, proto_entity_organization_pb.NewOrganization, 1));
};


/**
 * @param {?proto.entity.NewOrganization|undefined} value
 * @return {!proto.entity.CreateOrganizationRequest} returns this
*/
proto.entity.CreateOrganizationRequest.prototype.setNewOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateOrganizationRequest} returns this
 */
proto.entity.CreateOrganizationRequest.prototype.clearNewOrganization = function() {
  return this.setNewOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateOrganizationRequest.prototype.hasNewOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateOrganizationReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateOrganizationReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateOrganizationReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOrganizationReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    organization: (f = msg.getOrganization()) && proto_entity_organization_pb.Organization.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateOrganizationReply}
 */
proto.entity.CreateOrganizationReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateOrganizationReply;
  return proto.entity.CreateOrganizationReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateOrganizationReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateOrganizationReply}
 */
proto.entity.CreateOrganizationReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_organization_pb.Organization;
      reader.readMessage(value,proto_entity_organization_pb.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateOrganizationReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateOrganizationReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateOrganizationReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateOrganizationReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_organization_pb.Organization.serializeBinaryToWriter
    );
  }
};


/**
 * optional Organization organization = 1;
 * @return {?proto.entity.Organization}
 */
proto.entity.CreateOrganizationReply.prototype.getOrganization = function() {
  return /** @type{?proto.entity.Organization} */ (
    jspb.Message.getWrapperField(this, proto_entity_organization_pb.Organization, 1));
};


/**
 * @param {?proto.entity.Organization|undefined} value
 * @return {!proto.entity.CreateOrganizationReply} returns this
*/
proto.entity.CreateOrganizationReply.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateOrganizationReply} returns this
 */
proto.entity.CreateOrganizationReply.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateOrganizationReply.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateOrganizationRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationSelector: (f = msg.getOrganizationSelector()) && proto_entity_organization_pb.OrganizationSelector.toObject(includeInstance, f),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_organization_pb.UpdateOrganizationAction.toObject, includeInstance),
    ifVersion: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOrganizationRequest}
 */
proto.entity.UpdateOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOrganizationRequest;
  return proto.entity.UpdateOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOrganizationRequest}
 */
proto.entity.UpdateOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_organization_pb.OrganizationSelector;
      reader.readMessage(value,proto_entity_organization_pb.OrganizationSelector.deserializeBinaryFromReader);
      msg.setOrganizationSelector(value);
      break;
    case 2:
      var value = new proto_entity_organization_pb.UpdateOrganizationAction;
      reader.readMessage(value,proto_entity_organization_pb.UpdateOrganizationAction.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIfVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_organization_pb.OrganizationSelector.serializeBinaryToWriter
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_organization_pb.UpdateOrganizationAction.serializeBinaryToWriter
    );
  }
  f = message.getIfVersion();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional OrganizationSelector organization_selector = 1;
 * @return {?proto.entity.OrganizationSelector}
 */
proto.entity.UpdateOrganizationRequest.prototype.getOrganizationSelector = function() {
  return /** @type{?proto.entity.OrganizationSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_organization_pb.OrganizationSelector, 1));
};


/**
 * @param {?proto.entity.OrganizationSelector|undefined} value
 * @return {!proto.entity.UpdateOrganizationRequest} returns this
*/
proto.entity.UpdateOrganizationRequest.prototype.setOrganizationSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationRequest} returns this
 */
proto.entity.UpdateOrganizationRequest.prototype.clearOrganizationSelector = function() {
  return this.setOrganizationSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationRequest.prototype.hasOrganizationSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UpdateOrganizationAction actions = 2;
 * @return {!Array<!proto.entity.UpdateOrganizationAction>}
 */
proto.entity.UpdateOrganizationRequest.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.UpdateOrganizationAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_organization_pb.UpdateOrganizationAction, 2));
};


/**
 * @param {!Array<!proto.entity.UpdateOrganizationAction>} value
 * @return {!proto.entity.UpdateOrganizationRequest} returns this
*/
proto.entity.UpdateOrganizationRequest.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.UpdateOrganizationAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateOrganizationAction}
 */
proto.entity.UpdateOrganizationRequest.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.UpdateOrganizationAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateOrganizationRequest} returns this
 */
proto.entity.UpdateOrganizationRequest.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};


/**
 * optional int64 if_version = 5;
 * @return {number}
 */
proto.entity.UpdateOrganizationRequest.prototype.getIfVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.UpdateOrganizationRequest} returns this
 */
proto.entity.UpdateOrganizationRequest.prototype.setIfVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateOrganizationReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateOrganizationReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateOrganizationReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    organization: (f = msg.getOrganization()) && proto_entity_organization_pb.Organization.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateOrganizationReply}
 */
proto.entity.UpdateOrganizationReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateOrganizationReply;
  return proto.entity.UpdateOrganizationReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateOrganizationReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateOrganizationReply}
 */
proto.entity.UpdateOrganizationReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_organization_pb.Organization;
      reader.readMessage(value,proto_entity_organization_pb.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateOrganizationReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateOrganizationReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateOrganizationReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateOrganizationReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_organization_pb.Organization.serializeBinaryToWriter
    );
  }
};


/**
 * optional Organization organization = 1;
 * @return {?proto.entity.Organization}
 */
proto.entity.UpdateOrganizationReply.prototype.getOrganization = function() {
  return /** @type{?proto.entity.Organization} */ (
    jspb.Message.getWrapperField(this, proto_entity_organization_pb.Organization, 1));
};


/**
 * @param {?proto.entity.Organization|undefined} value
 * @return {!proto.entity.UpdateOrganizationReply} returns this
*/
proto.entity.UpdateOrganizationReply.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateOrganizationReply} returns this
 */
proto.entity.UpdateOrganizationReply.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateOrganizationReply.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.OrganizationFilter.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.OrganizationFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.OrganizationFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.OrganizationFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OrganizationFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    includeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    includeOrganizationIdsList: jspb.Message.toObjectList(msg.getIncludeOrganizationIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    includeAliasesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.OrganizationFilter}
 */
proto.entity.OrganizationFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.OrganizationFilter;
  return proto.entity.OrganizationFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.OrganizationFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.OrganizationFilter}
 */
proto.entity.OrganizationFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDeleted(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addIncludeOrganizationIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addIncludeAliases(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.OrganizationFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.OrganizationFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.OrganizationFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.OrganizationFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludeDeleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getIncludeOrganizationIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getIncludeAliasesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional bool include_deleted = 1;
 * @return {boolean}
 */
proto.entity.OrganizationFilter.prototype.getIncludeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.OrganizationFilter} returns this
 */
proto.entity.OrganizationFilter.prototype.setIncludeDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated common.ObjectID include_organization_ids = 2;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.OrganizationFilter.prototype.getIncludeOrganizationIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.OrganizationFilter} returns this
*/
proto.entity.OrganizationFilter.prototype.setIncludeOrganizationIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.OrganizationFilter.prototype.addIncludeOrganizationIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OrganizationFilter} returns this
 */
proto.entity.OrganizationFilter.prototype.clearIncludeOrganizationIdsList = function() {
  return this.setIncludeOrganizationIdsList([]);
};


/**
 * repeated string include_aliases = 3;
 * @return {!Array<string>}
 */
proto.entity.OrganizationFilter.prototype.getIncludeAliasesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.OrganizationFilter} returns this
 */
proto.entity.OrganizationFilter.prototype.setIncludeAliasesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.OrganizationFilter} returns this
 */
proto.entity.OrganizationFilter.prototype.addIncludeAliases = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.OrganizationFilter} returns this
 */
proto.entity.OrganizationFilter.prototype.clearIncludeAliasesList = function() {
  return this.setIncludeAliasesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryOrganizationsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryOrganizationsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryOrganizationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryOrganizationsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && proto.entity.OrganizationFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryOrganizationsRequest}
 */
proto.entity.QueryOrganizationsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryOrganizationsRequest;
  return proto.entity.QueryOrganizationsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryOrganizationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryOrganizationsRequest}
 */
proto.entity.QueryOrganizationsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.OrganizationFilter;
      reader.readMessage(value,proto.entity.OrganizationFilter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryOrganizationsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryOrganizationsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryOrganizationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryOrganizationsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.OrganizationFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrganizationFilter filter = 1;
 * @return {?proto.entity.OrganizationFilter}
 */
proto.entity.QueryOrganizationsRequest.prototype.getFilter = function() {
  return /** @type{?proto.entity.OrganizationFilter} */ (
    jspb.Message.getWrapperField(this, proto.entity.OrganizationFilter, 1));
};


/**
 * @param {?proto.entity.OrganizationFilter|undefined} value
 * @return {!proto.entity.QueryOrganizationsRequest} returns this
*/
proto.entity.QueryOrganizationsRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QueryOrganizationsRequest} returns this
 */
proto.entity.QueryOrganizationsRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QueryOrganizationsRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QueryOrganizationsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryOrganizationsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryOrganizationsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryOrganizationsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryOrganizationsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationsList: jspb.Message.toObjectList(msg.getOrganizationsList(),
    proto_entity_organization_pb.Organization.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryOrganizationsReply}
 */
proto.entity.QueryOrganizationsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryOrganizationsReply;
  return proto.entity.QueryOrganizationsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryOrganizationsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryOrganizationsReply}
 */
proto.entity.QueryOrganizationsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_organization_pb.Organization;
      reader.readMessage(value,proto_entity_organization_pb.Organization.deserializeBinaryFromReader);
      msg.addOrganizations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryOrganizationsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryOrganizationsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryOrganizationsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryOrganizationsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_organization_pb.Organization.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Organization organizations = 1;
 * @return {!Array<!proto.entity.Organization>}
 */
proto.entity.QueryOrganizationsReply.prototype.getOrganizationsList = function() {
  return /** @type{!Array<!proto.entity.Organization>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_organization_pb.Organization, 1));
};


/**
 * @param {!Array<!proto.entity.Organization>} value
 * @return {!proto.entity.QueryOrganizationsReply} returns this
*/
proto.entity.QueryOrganizationsReply.prototype.setOrganizationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Organization=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Organization}
 */
proto.entity.QueryOrganizationsReply.prototype.addOrganizations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Organization, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QueryOrganizationsReply} returns this
 */
proto.entity.QueryOrganizationsReply.prototype.clearOrganizationsList = function() {
  return this.setOrganizationsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupOrganizationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupOrganizationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupOrganizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOrganizationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    organizationSelector: (f = msg.getOrganizationSelector()) && proto_entity_organization_pb.OrganizationSelector.toObject(includeInstance, f),
    filter: (f = msg.getFilter()) && proto.entity.OrganizationFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupOrganizationRequest}
 */
proto.entity.LookupOrganizationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupOrganizationRequest;
  return proto.entity.LookupOrganizationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupOrganizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupOrganizationRequest}
 */
proto.entity.LookupOrganizationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_organization_pb.OrganizationSelector;
      reader.readMessage(value,proto_entity_organization_pb.OrganizationSelector.deserializeBinaryFromReader);
      msg.setOrganizationSelector(value);
      break;
    case 2:
      var value = new proto.entity.OrganizationFilter;
      reader.readMessage(value,proto.entity.OrganizationFilter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupOrganizationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupOrganizationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupOrganizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOrganizationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganizationSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_organization_pb.OrganizationSelector.serializeBinaryToWriter
    );
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.OrganizationFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional OrganizationSelector organization_selector = 1;
 * @return {?proto.entity.OrganizationSelector}
 */
proto.entity.LookupOrganizationRequest.prototype.getOrganizationSelector = function() {
  return /** @type{?proto.entity.OrganizationSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_organization_pb.OrganizationSelector, 1));
};


/**
 * @param {?proto.entity.OrganizationSelector|undefined} value
 * @return {!proto.entity.LookupOrganizationRequest} returns this
*/
proto.entity.LookupOrganizationRequest.prototype.setOrganizationSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupOrganizationRequest} returns this
 */
proto.entity.LookupOrganizationRequest.prototype.clearOrganizationSelector = function() {
  return this.setOrganizationSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupOrganizationRequest.prototype.hasOrganizationSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional OrganizationFilter filter = 2;
 * @return {?proto.entity.OrganizationFilter}
 */
proto.entity.LookupOrganizationRequest.prototype.getFilter = function() {
  return /** @type{?proto.entity.OrganizationFilter} */ (
    jspb.Message.getWrapperField(this, proto.entity.OrganizationFilter, 2));
};


/**
 * @param {?proto.entity.OrganizationFilter|undefined} value
 * @return {!proto.entity.LookupOrganizationRequest} returns this
*/
proto.entity.LookupOrganizationRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupOrganizationRequest} returns this
 */
proto.entity.LookupOrganizationRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupOrganizationRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupOrganizationReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupOrganizationReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupOrganizationReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOrganizationReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    organization: (f = msg.getOrganization()) && proto_entity_organization_pb.Organization.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupOrganizationReply}
 */
proto.entity.LookupOrganizationReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupOrganizationReply;
  return proto.entity.LookupOrganizationReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupOrganizationReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupOrganizationReply}
 */
proto.entity.LookupOrganizationReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_organization_pb.Organization;
      reader.readMessage(value,proto_entity_organization_pb.Organization.deserializeBinaryFromReader);
      msg.setOrganization(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupOrganizationReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupOrganizationReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupOrganizationReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupOrganizationReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrganization();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_organization_pb.Organization.serializeBinaryToWriter
    );
  }
};


/**
 * optional Organization organization = 1;
 * @return {?proto.entity.Organization}
 */
proto.entity.LookupOrganizationReply.prototype.getOrganization = function() {
  return /** @type{?proto.entity.Organization} */ (
    jspb.Message.getWrapperField(this, proto_entity_organization_pb.Organization, 1));
};


/**
 * @param {?proto.entity.Organization|undefined} value
 * @return {!proto.entity.LookupOrganizationReply} returns this
*/
proto.entity.LookupOrganizationReply.prototype.setOrganization = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupOrganizationReply} returns this
 */
proto.entity.LookupOrganizationReply.prototype.clearOrganization = function() {
  return this.setOrganization(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupOrganizationReply.prototype.hasOrganization = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountTypeFilterList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    knownProfileIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    collectAllSellerAccountProfileIds: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CollectRelevantAmazonAccountProfileIdsRequest;
  return proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.common.Amazon.AdvertisingProfile.AccountType.Option>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAccountTypeFilter(values[i]);
      }
      break;
    case 2:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addKnownProfileIds(values[i]);
      }
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCollectAllSellerAccountProfileIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountTypeFilterList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getKnownProfileIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      2,
      f
    );
  }
  f = message.getCollectAllSellerAccountProfileIds();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * repeated common.Amazon.AdvertisingProfile.AccountType.Option account_type_filter = 1;
 * @return {!Array<!proto.common.Amazon.AdvertisingProfile.AccountType.Option>}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.getAccountTypeFilterList = function() {
  return /** @type {!Array<!proto.common.Amazon.AdvertisingProfile.AccountType.Option>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.common.Amazon.AdvertisingProfile.AccountType.Option>} value
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.setAccountTypeFilterList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.common.Amazon.AdvertisingProfile.AccountType.Option} value
 * @param {number=} opt_index
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.addAccountTypeFilter = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.clearAccountTypeFilterList = function() {
  return this.setAccountTypeFilterList([]);
};


/**
 * repeated int64 known_profile_ids = 2;
 * @return {!Array<number>}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.getKnownProfileIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.setKnownProfileIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.addKnownProfileIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.clearKnownProfileIdsList = function() {
  return this.setKnownProfileIdsList([]);
};


/**
 * optional bool collect_all_seller_account_profile_ids = 3;
 * @return {boolean}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.getCollectAllSellerAccountProfileIds = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsRequest} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsRequest.prototype.setCollectAllSellerAccountProfileIds = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CollectRelevantAmazonAccountProfileIdsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CollectRelevantAmazonAccountProfileIdsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountProfileIdsList: jspb.Message.toObjectList(msg.getAccountProfileIdsList(),
    proto_common_amazon_pb.Amazon.AccountProfileId.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsReply}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CollectRelevantAmazonAccountProfileIdsReply;
  return proto.entity.CollectRelevantAmazonAccountProfileIdsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CollectRelevantAmazonAccountProfileIdsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsReply}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_amazon_pb.Amazon.AccountProfileId;
      reader.readMessage(value,proto_common_amazon_pb.Amazon.AccountProfileId.deserializeBinaryFromReader);
      msg.addAccountProfileIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CollectRelevantAmazonAccountProfileIdsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CollectRelevantAmazonAccountProfileIdsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountProfileIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_common_amazon_pb.Amazon.AccountProfileId.serializeBinaryToWriter
    );
  }
};


/**
 * repeated common.Amazon.AccountProfileId account_profile_ids = 1;
 * @return {!Array<!proto.common.Amazon.AccountProfileId>}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.prototype.getAccountProfileIdsList = function() {
  return /** @type{!Array<!proto.common.Amazon.AccountProfileId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_amazon_pb.Amazon.AccountProfileId, 1));
};


/**
 * @param {!Array<!proto.common.Amazon.AccountProfileId>} value
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsReply} returns this
*/
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.prototype.setAccountProfileIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.Amazon.AccountProfileId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.Amazon.AccountProfileId}
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.prototype.addAccountProfileIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.Amazon.AccountProfileId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CollectRelevantAmazonAccountProfileIdsReply} returns this
 */
proto.entity.CollectRelevantAmazonAccountProfileIdsReply.prototype.clearAccountProfileIdsList = function() {
  return this.setAccountProfileIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.FindSitesByAmazonProfileIdsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.FindSitesByAmazonProfileIdsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    profileIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.FindSitesByAmazonProfileIdsRequest}
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.FindSitesByAmazonProfileIdsRequest;
  return proto.entity.FindSitesByAmazonProfileIdsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.FindSitesByAmazonProfileIdsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.FindSitesByAmazonProfileIdsRequest}
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addProfileIds(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.FindSitesByAmazonProfileIdsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.FindSitesByAmazonProfileIdsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileIdsList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 profile_ids = 1;
 * @return {!Array<number>}
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.prototype.getProfileIdsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.entity.FindSitesByAmazonProfileIdsRequest} returns this
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.prototype.setProfileIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.entity.FindSitesByAmazonProfileIdsRequest} returns this
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.prototype.addProfileIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.FindSitesByAmazonProfileIdsRequest} returns this
 */
proto.entity.FindSitesByAmazonProfileIdsRequest.prototype.clearProfileIdsList = function() {
  return this.setProfileIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.FindSitesByAmazonProfileIdsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.FindSitesByAmazonProfileIdsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.FindSitesByAmazonProfileIdsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.FindSitesByAmazonProfileIdsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByAmazonProfileIdsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    sitesWithProfileIdList: jspb.Message.toObjectList(msg.getSitesWithProfileIdList(),
    proto.entity.SitesWithProfileId.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.FindSitesByAmazonProfileIdsReply}
 */
proto.entity.FindSitesByAmazonProfileIdsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.FindSitesByAmazonProfileIdsReply;
  return proto.entity.FindSitesByAmazonProfileIdsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.FindSitesByAmazonProfileIdsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.FindSitesByAmazonProfileIdsReply}
 */
proto.entity.FindSitesByAmazonProfileIdsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.SitesWithProfileId;
      reader.readMessage(value,proto.entity.SitesWithProfileId.deserializeBinaryFromReader);
      msg.addSitesWithProfileId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.FindSitesByAmazonProfileIdsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.FindSitesByAmazonProfileIdsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.FindSitesByAmazonProfileIdsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.FindSitesByAmazonProfileIdsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSitesWithProfileIdList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.entity.SitesWithProfileId.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SitesWithProfileId sites_with_profile_id = 1;
 * @return {!Array<!proto.entity.SitesWithProfileId>}
 */
proto.entity.FindSitesByAmazonProfileIdsReply.prototype.getSitesWithProfileIdList = function() {
  return /** @type{!Array<!proto.entity.SitesWithProfileId>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.entity.SitesWithProfileId, 1));
};


/**
 * @param {!Array<!proto.entity.SitesWithProfileId>} value
 * @return {!proto.entity.FindSitesByAmazonProfileIdsReply} returns this
*/
proto.entity.FindSitesByAmazonProfileIdsReply.prototype.setSitesWithProfileIdList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SitesWithProfileId=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SitesWithProfileId}
 */
proto.entity.FindSitesByAmazonProfileIdsReply.prototype.addSitesWithProfileId = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SitesWithProfileId, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.FindSitesByAmazonProfileIdsReply} returns this
 */
proto.entity.FindSitesByAmazonProfileIdsReply.prototype.clearSitesWithProfileIdList = function() {
  return this.setSitesWithProfileIdList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.SitesWithProfileId.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.SitesWithProfileId.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.SitesWithProfileId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.SitesWithProfileId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SitesWithProfileId.toObject = function(includeInstance, msg) {
  var f, obj = {
    profileId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    sitesList: jspb.Message.toObjectList(msg.getSitesList(),
    proto_entity_site_pb.Site.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.SitesWithProfileId}
 */
proto.entity.SitesWithProfileId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.SitesWithProfileId;
  return proto.entity.SitesWithProfileId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.SitesWithProfileId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.SitesWithProfileId}
 */
proto.entity.SitesWithProfileId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProfileId(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.Site;
      reader.readMessage(value,proto_entity_site_pb.Site.deserializeBinaryFromReader);
      msg.addSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.SitesWithProfileId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.SitesWithProfileId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.SitesWithProfileId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.SitesWithProfileId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProfileId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_site_pb.Site.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 profile_id = 1;
 * @return {number}
 */
proto.entity.SitesWithProfileId.prototype.getProfileId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.SitesWithProfileId} returns this
 */
proto.entity.SitesWithProfileId.prototype.setProfileId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated Site sites = 2;
 * @return {!Array<!proto.entity.Site>}
 */
proto.entity.SitesWithProfileId.prototype.getSitesList = function() {
  return /** @type{!Array<!proto.entity.Site>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_site_pb.Site, 2));
};


/**
 * @param {!Array<!proto.entity.Site>} value
 * @return {!proto.entity.SitesWithProfileId} returns this
*/
proto.entity.SitesWithProfileId.prototype.setSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.Site=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Site}
 */
proto.entity.SitesWithProfileId.prototype.addSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.Site, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.SitesWithProfileId} returns this
 */
proto.entity.SitesWithProfileId.prototype.clearSitesList = function() {
  return this.setSitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateCampaignRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateCampaignRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateCampaignRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateCampaignRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    newCampaign: (f = msg.getNewCampaign()) && proto_entity_campaign_pb.NewCampaign.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateCampaignRequest}
 */
proto.entity.CreateCampaignRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateCampaignRequest;
  return proto.entity.CreateCampaignRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateCampaignRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateCampaignRequest}
 */
proto.entity.CreateCampaignRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_campaign_pb.NewCampaign;
      reader.readMessage(value,proto_entity_campaign_pb.NewCampaign.deserializeBinaryFromReader);
      msg.setNewCampaign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateCampaignRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateCampaignRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateCampaignRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateCampaignRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNewCampaign();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_campaign_pb.NewCampaign.serializeBinaryToWriter
    );
  }
};


/**
 * optional NewCampaign new_campaign = 1;
 * @return {?proto.entity.NewCampaign}
 */
proto.entity.CreateCampaignRequest.prototype.getNewCampaign = function() {
  return /** @type{?proto.entity.NewCampaign} */ (
    jspb.Message.getWrapperField(this, proto_entity_campaign_pb.NewCampaign, 1));
};


/**
 * @param {?proto.entity.NewCampaign|undefined} value
 * @return {!proto.entity.CreateCampaignRequest} returns this
*/
proto.entity.CreateCampaignRequest.prototype.setNewCampaign = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateCampaignRequest} returns this
 */
proto.entity.CreateCampaignRequest.prototype.clearNewCampaign = function() {
  return this.setNewCampaign(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateCampaignRequest.prototype.hasNewCampaign = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CreateCampaignReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CreateCampaignReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CreateCampaignReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateCampaignReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaign: (f = msg.getCampaign()) && proto_entity_campaign_pb.Campaign.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CreateCampaignReply}
 */
proto.entity.CreateCampaignReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CreateCampaignReply;
  return proto.entity.CreateCampaignReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CreateCampaignReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CreateCampaignReply}
 */
proto.entity.CreateCampaignReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_campaign_pb.Campaign;
      reader.readMessage(value,proto_entity_campaign_pb.Campaign.deserializeBinaryFromReader);
      msg.setCampaign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CreateCampaignReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CreateCampaignReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CreateCampaignReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CreateCampaignReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaign();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_campaign_pb.Campaign.serializeBinaryToWriter
    );
  }
};


/**
 * optional Campaign campaign = 1;
 * @return {?proto.entity.Campaign}
 */
proto.entity.CreateCampaignReply.prototype.getCampaign = function() {
  return /** @type{?proto.entity.Campaign} */ (
    jspb.Message.getWrapperField(this, proto_entity_campaign_pb.Campaign, 1));
};


/**
 * @param {?proto.entity.Campaign|undefined} value
 * @return {!proto.entity.CreateCampaignReply} returns this
*/
proto.entity.CreateCampaignReply.prototype.setCampaign = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.CreateCampaignReply} returns this
 */
proto.entity.CreateCampaignReply.prototype.clearCampaign = function() {
  return this.setCampaign(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.CreateCampaignReply.prototype.hasCampaign = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateCampaignRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateCampaignRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateCampaignRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateCampaignRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateCampaignRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: (f = msg.getCampaignId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    actionsList: jspb.Message.toObjectList(msg.getActionsList(),
    proto_entity_campaign_pb.UpdateCampaignAction.toObject, includeInstance),
    ifVersion: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateCampaignRequest}
 */
proto.entity.UpdateCampaignRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateCampaignRequest;
  return proto.entity.UpdateCampaignRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateCampaignRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateCampaignRequest}
 */
proto.entity.UpdateCampaignRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setCampaignId(value);
      break;
    case 2:
      var value = new proto_entity_campaign_pb.UpdateCampaignAction;
      reader.readMessage(value,proto_entity_campaign_pb.UpdateCampaignAction.deserializeBinaryFromReader);
      msg.addActions(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setIfVersion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateCampaignRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateCampaignRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateCampaignRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateCampaignRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getActionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_campaign_pb.UpdateCampaignAction.serializeBinaryToWriter
    );
  }
  f = message.getIfVersion();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional common.ObjectID campaign_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.UpdateCampaignRequest.prototype.getCampaignId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.UpdateCampaignRequest} returns this
*/
proto.entity.UpdateCampaignRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateCampaignRequest} returns this
 */
proto.entity.UpdateCampaignRequest.prototype.clearCampaignId = function() {
  return this.setCampaignId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateCampaignRequest.prototype.hasCampaignId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated UpdateCampaignAction actions = 2;
 * @return {!Array<!proto.entity.UpdateCampaignAction>}
 */
proto.entity.UpdateCampaignRequest.prototype.getActionsList = function() {
  return /** @type{!Array<!proto.entity.UpdateCampaignAction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_campaign_pb.UpdateCampaignAction, 2));
};


/**
 * @param {!Array<!proto.entity.UpdateCampaignAction>} value
 * @return {!proto.entity.UpdateCampaignRequest} returns this
*/
proto.entity.UpdateCampaignRequest.prototype.setActionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.UpdateCampaignAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateCampaignAction}
 */
proto.entity.UpdateCampaignRequest.prototype.addActions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.UpdateCampaignAction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateCampaignRequest} returns this
 */
proto.entity.UpdateCampaignRequest.prototype.clearActionsList = function() {
  return this.setActionsList([]);
};


/**
 * optional int64 if_version = 3;
 * @return {number}
 */
proto.entity.UpdateCampaignRequest.prototype.getIfVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.UpdateCampaignRequest} returns this
 */
proto.entity.UpdateCampaignRequest.prototype.setIfVersion = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateCampaignReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateCampaignReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateCampaignReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateCampaignReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaign: (f = msg.getCampaign()) && proto_entity_campaign_pb.Campaign.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateCampaignReply}
 */
proto.entity.UpdateCampaignReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateCampaignReply;
  return proto.entity.UpdateCampaignReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateCampaignReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateCampaignReply}
 */
proto.entity.UpdateCampaignReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_campaign_pb.Campaign;
      reader.readMessage(value,proto_entity_campaign_pb.Campaign.deserializeBinaryFromReader);
      msg.setCampaign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateCampaignReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateCampaignReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateCampaignReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateCampaignReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaign();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_campaign_pb.Campaign.serializeBinaryToWriter
    );
  }
};


/**
 * optional Campaign campaign = 1;
 * @return {?proto.entity.Campaign}
 */
proto.entity.UpdateCampaignReply.prototype.getCampaign = function() {
  return /** @type{?proto.entity.Campaign} */ (
    jspb.Message.getWrapperField(this, proto_entity_campaign_pb.Campaign, 1));
};


/**
 * @param {?proto.entity.Campaign|undefined} value
 * @return {!proto.entity.UpdateCampaignReply} returns this
*/
proto.entity.UpdateCampaignReply.prototype.setCampaign = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateCampaignReply} returns this
 */
proto.entity.UpdateCampaignReply.prototype.clearCampaign = function() {
  return this.setCampaign(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateCampaignReply.prototype.hasCampaign = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ExternalCampaignAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ExternalCampaignAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ExternalCampaignAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExternalCampaignAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    platform: jspb.Message.getFieldWithDefault(msg, 1, 0),
    externalAccountId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ExternalCampaignAccount}
 */
proto.entity.ExternalCampaignAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ExternalCampaignAccount;
  return proto.entity.ExternalCampaignAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ExternalCampaignAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ExternalCampaignAccount}
 */
proto.entity.ExternalCampaignAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.CampaignPlatform.Option} */ (reader.readEnum());
      msg.setPlatform(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ExternalCampaignAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ExternalCampaignAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ExternalCampaignAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExternalCampaignAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExternalAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.CampaignPlatform.Option platform = 1;
 * @return {!proto.common.CampaignPlatform.Option}
 */
proto.entity.ExternalCampaignAccount.prototype.getPlatform = function() {
  return /** @type {!proto.common.CampaignPlatform.Option} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.CampaignPlatform.Option} value
 * @return {!proto.entity.ExternalCampaignAccount} returns this
 */
proto.entity.ExternalCampaignAccount.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string external_account_id = 2;
 * @return {string}
 */
proto.entity.ExternalCampaignAccount.prototype.getExternalAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ExternalCampaignAccount} returns this
 */
proto.entity.ExternalCampaignAccount.prototype.setExternalAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ExternalCampaign.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ExternalCampaign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ExternalCampaign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExternalCampaign.toObject = function(includeInstance, msg) {
  var f, obj = {
    platform: jspb.Message.getFieldWithDefault(msg, 1, 0),
    externalCampaignId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ExternalCampaign}
 */
proto.entity.ExternalCampaign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ExternalCampaign;
  return proto.entity.ExternalCampaign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ExternalCampaign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ExternalCampaign}
 */
proto.entity.ExternalCampaign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.common.CampaignPlatform.Option} */ (reader.readEnum());
      msg.setPlatform(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalCampaignId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ExternalCampaign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ExternalCampaign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ExternalCampaign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ExternalCampaign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlatform();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getExternalCampaignId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional common.CampaignPlatform.Option platform = 1;
 * @return {!proto.common.CampaignPlatform.Option}
 */
proto.entity.ExternalCampaign.prototype.getPlatform = function() {
  return /** @type {!proto.common.CampaignPlatform.Option} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.common.CampaignPlatform.Option} value
 * @return {!proto.entity.ExternalCampaign} returns this
 */
proto.entity.ExternalCampaign.prototype.setPlatform = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string external_campaign_id = 2;
 * @return {string}
 */
proto.entity.ExternalCampaign.prototype.getExternalCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ExternalCampaign} returns this
 */
proto.entity.ExternalCampaign.prototype.setExternalCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.CampaignFilter.repeatedFields_ = [2,3,4,5,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.CampaignFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.CampaignFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.CampaignFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CampaignFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    includeDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    siteIdsList: jspb.Message.toObjectList(msg.getSiteIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    siteAliasesList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    campaignIdsList: jspb.Message.toObjectList(msg.getCampaignIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    campaignPlatformsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    externalAccountIdsList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    externalCampaignIdsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.CampaignFilter}
 */
proto.entity.CampaignFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.CampaignFilter;
  return proto.entity.CampaignFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.CampaignFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.CampaignFilter}
 */
proto.entity.CampaignFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeDeleted(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addSiteIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSiteAliases(value);
      break;
    case 4:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addCampaignIds(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.common.CampaignPlatform.Option>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCampaignPlatforms(values[i]);
      }
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addExternalAccountIds(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addExternalCampaignIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.CampaignFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.CampaignFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.CampaignFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.CampaignFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIncludeDeleted();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSiteIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getSiteAliasesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCampaignIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getCampaignPlatformsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getExternalAccountIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getExternalCampaignIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
};


/**
 * optional bool include_deleted = 1;
 * @return {boolean}
 */
proto.entity.CampaignFilter.prototype.getIncludeDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.setIncludeDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * repeated common.ObjectID site_ids = 2;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.CampaignFilter.prototype.getSiteIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.CampaignFilter} returns this
*/
proto.entity.CampaignFilter.prototype.setSiteIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.CampaignFilter.prototype.addSiteIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.clearSiteIdsList = function() {
  return this.setSiteIdsList([]);
};


/**
 * repeated string site_aliases = 3;
 * @return {!Array<string>}
 */
proto.entity.CampaignFilter.prototype.getSiteAliasesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.setSiteAliasesList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.addSiteAliases = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.clearSiteAliasesList = function() {
  return this.setSiteAliasesList([]);
};


/**
 * repeated common.ObjectID campaign_ids = 4;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.entity.CampaignFilter.prototype.getCampaignIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 4));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.entity.CampaignFilter} returns this
*/
proto.entity.CampaignFilter.prototype.setCampaignIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.entity.CampaignFilter.prototype.addCampaignIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.clearCampaignIdsList = function() {
  return this.setCampaignIdsList([]);
};


/**
 * repeated common.CampaignPlatform.Option campaign_platforms = 5;
 * @return {!Array<!proto.common.CampaignPlatform.Option>}
 */
proto.entity.CampaignFilter.prototype.getCampaignPlatformsList = function() {
  return /** @type {!Array<!proto.common.CampaignPlatform.Option>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.common.CampaignPlatform.Option>} value
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.setCampaignPlatformsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.common.CampaignPlatform.Option} value
 * @param {number=} opt_index
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.addCampaignPlatforms = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.clearCampaignPlatformsList = function() {
  return this.setCampaignPlatformsList([]);
};


/**
 * repeated string external_account_ids = 6;
 * @return {!Array<string>}
 */
proto.entity.CampaignFilter.prototype.getExternalAccountIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.setExternalAccountIdsList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.addExternalAccountIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.clearExternalAccountIdsList = function() {
  return this.setExternalAccountIdsList([]);
};


/**
 * repeated string external_campaign_ids = 7;
 * @return {!Array<string>}
 */
proto.entity.CampaignFilter.prototype.getExternalCampaignIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.setExternalCampaignIdsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.addExternalCampaignIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.CampaignFilter} returns this
 */
proto.entity.CampaignFilter.prototype.clearExternalCampaignIdsList = function() {
  return this.setExternalCampaignIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryCampaignsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryCampaignsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryCampaignsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryCampaignsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    filter: (f = msg.getFilter()) && proto.entity.CampaignFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryCampaignsRequest}
 */
proto.entity.QueryCampaignsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryCampaignsRequest;
  return proto.entity.QueryCampaignsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryCampaignsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryCampaignsRequest}
 */
proto.entity.QueryCampaignsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.CampaignFilter;
      reader.readMessage(value,proto.entity.CampaignFilter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryCampaignsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryCampaignsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryCampaignsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryCampaignsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.CampaignFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional CampaignFilter filter = 1;
 * @return {?proto.entity.CampaignFilter}
 */
proto.entity.QueryCampaignsRequest.prototype.getFilter = function() {
  return /** @type{?proto.entity.CampaignFilter} */ (
    jspb.Message.getWrapperField(this, proto.entity.CampaignFilter, 1));
};


/**
 * @param {?proto.entity.CampaignFilter|undefined} value
 * @return {!proto.entity.QueryCampaignsRequest} returns this
*/
proto.entity.QueryCampaignsRequest.prototype.setFilter = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QueryCampaignsRequest} returns this
 */
proto.entity.QueryCampaignsRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QueryCampaignsRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QueryCampaignsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryCampaignsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryCampaignsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryCampaignsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryCampaignsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignsList: jspb.Message.toObjectList(msg.getCampaignsList(),
    proto_entity_campaign_pb.Campaign.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryCampaignsReply}
 */
proto.entity.QueryCampaignsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryCampaignsReply;
  return proto.entity.QueryCampaignsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryCampaignsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryCampaignsReply}
 */
proto.entity.QueryCampaignsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_campaign_pb.Campaign;
      reader.readMessage(value,proto_entity_campaign_pb.Campaign.deserializeBinaryFromReader);
      msg.addCampaigns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryCampaignsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryCampaignsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryCampaignsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryCampaignsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_campaign_pb.Campaign.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Campaign campaigns = 1;
 * @return {!Array<!proto.entity.Campaign>}
 */
proto.entity.QueryCampaignsReply.prototype.getCampaignsList = function() {
  return /** @type{!Array<!proto.entity.Campaign>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_campaign_pb.Campaign, 1));
};


/**
 * @param {!Array<!proto.entity.Campaign>} value
 * @return {!proto.entity.QueryCampaignsReply} returns this
*/
proto.entity.QueryCampaignsReply.prototype.setCampaignsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.Campaign=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.Campaign}
 */
proto.entity.QueryCampaignsReply.prototype.addCampaigns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.Campaign, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QueryCampaignsReply} returns this
 */
proto.entity.QueryCampaignsReply.prototype.clearCampaignsList = function() {
  return this.setCampaignsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.LookupCampaignRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.entity.LookupCampaignRequest.TypeCase = {
  TYPE_NOT_SET: 0,
  CAMPAIGN_ID: 1,
  FILTER: 2
};

/**
 * @return {proto.entity.LookupCampaignRequest.TypeCase}
 */
proto.entity.LookupCampaignRequest.prototype.getTypeCase = function() {
  return /** @type {proto.entity.LookupCampaignRequest.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.LookupCampaignRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupCampaignRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupCampaignRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupCampaignRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupCampaignRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaignId: (f = msg.getCampaignId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    filter: (f = msg.getFilter()) && proto.entity.CampaignFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupCampaignRequest}
 */
proto.entity.LookupCampaignRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupCampaignRequest;
  return proto.entity.LookupCampaignRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupCampaignRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupCampaignRequest}
 */
proto.entity.LookupCampaignRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setCampaignId(value);
      break;
    case 2:
      var value = new proto.entity.CampaignFilter;
      reader.readMessage(value,proto.entity.CampaignFilter.deserializeBinaryFromReader);
      msg.setFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupCampaignRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupCampaignRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupCampaignRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupCampaignRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaignId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getFilter();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.entity.CampaignFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional common.ObjectID campaign_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.entity.LookupCampaignRequest.prototype.getCampaignId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.entity.LookupCampaignRequest} returns this
*/
proto.entity.LookupCampaignRequest.prototype.setCampaignId = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.LookupCampaignRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupCampaignRequest} returns this
 */
proto.entity.LookupCampaignRequest.prototype.clearCampaignId = function() {
  return this.setCampaignId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupCampaignRequest.prototype.hasCampaignId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional CampaignFilter filter = 2;
 * @return {?proto.entity.CampaignFilter}
 */
proto.entity.LookupCampaignRequest.prototype.getFilter = function() {
  return /** @type{?proto.entity.CampaignFilter} */ (
    jspb.Message.getWrapperField(this, proto.entity.CampaignFilter, 2));
};


/**
 * @param {?proto.entity.CampaignFilter|undefined} value
 * @return {!proto.entity.LookupCampaignRequest} returns this
*/
proto.entity.LookupCampaignRequest.prototype.setFilter = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.entity.LookupCampaignRequest.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupCampaignRequest} returns this
 */
proto.entity.LookupCampaignRequest.prototype.clearFilter = function() {
  return this.setFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupCampaignRequest.prototype.hasFilter = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupCampaignReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupCampaignReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupCampaignReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupCampaignReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    campaign: (f = msg.getCampaign()) && proto_entity_campaign_pb.Campaign.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupCampaignReply}
 */
proto.entity.LookupCampaignReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupCampaignReply;
  return proto.entity.LookupCampaignReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupCampaignReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupCampaignReply}
 */
proto.entity.LookupCampaignReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_campaign_pb.Campaign;
      reader.readMessage(value,proto_entity_campaign_pb.Campaign.deserializeBinaryFromReader);
      msg.setCampaign(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupCampaignReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupCampaignReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupCampaignReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupCampaignReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCampaign();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_campaign_pb.Campaign.serializeBinaryToWriter
    );
  }
};


/**
 * optional Campaign campaign = 1;
 * @return {?proto.entity.Campaign}
 */
proto.entity.LookupCampaignReply.prototype.getCampaign = function() {
  return /** @type{?proto.entity.Campaign} */ (
    jspb.Message.getWrapperField(this, proto_entity_campaign_pb.Campaign, 1));
};


/**
 * @param {?proto.entity.Campaign|undefined} value
 * @return {!proto.entity.LookupCampaignReply} returns this
*/
proto.entity.LookupCampaignReply.prototype.setCampaign = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupCampaignReply} returns this
 */
proto.entity.LookupCampaignReply.prototype.clearCampaign = function() {
  return this.setCampaign(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupCampaignReply.prototype.hasCampaign = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LinkClientSiteToManagerSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LinkClientSiteToManagerSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LinkClientSiteToManagerSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    managerSiteSelector: (f = msg.getManagerSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    clientSiteSelector: (f = msg.getClientSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    detailsAboutClient: (f = msg.getDetailsAboutClient()) && proto_entity_siteManagerLink_pb.SiteManagerLinkClient.Details.toObject(includeInstance, f),
    detailsAboutManager: (f = msg.getDetailsAboutManager()) && proto_entity_siteManagerLink_pb.SiteManagerLinkManager.Details.toObject(includeInstance, f),
    linkToManagerBilling: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LinkClientSiteToManagerSiteRequest;
  return proto.entity.LinkClientSiteToManagerSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LinkClientSiteToManagerSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setManagerSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setClientSiteSelector(value);
      break;
    case 3:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLinkClient.Details;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLinkClient.Details.deserializeBinaryFromReader);
      msg.setDetailsAboutClient(value);
      break;
    case 4:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLinkManager.Details;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLinkManager.Details.deserializeBinaryFromReader);
      msg.setDetailsAboutManager(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLinkToManagerBilling(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LinkClientSiteToManagerSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LinkClientSiteToManagerSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LinkClientSiteToManagerSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagerSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getClientSiteSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getDetailsAboutClient();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLinkClient.Details.serializeBinaryToWriter
    );
  }
  f = message.getDetailsAboutManager();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLinkManager.Details.serializeBinaryToWriter
    );
  }
  f = message.getLinkToManagerBilling();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional SiteSelector manager_site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.getManagerSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
*/
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.setManagerSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.clearManagerSiteSelector = function() {
  return this.setManagerSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.hasManagerSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SiteSelector client_site_selector = 2;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.getClientSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 2));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
*/
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.setClientSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.clearClientSiteSelector = function() {
  return this.setClientSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.hasClientSiteSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SiteManagerLinkClient.Details details_about_client = 3;
 * @return {?proto.entity.SiteManagerLinkClient.Details}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.getDetailsAboutClient = function() {
  return /** @type{?proto.entity.SiteManagerLinkClient.Details} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLinkClient.Details, 3));
};


/**
 * @param {?proto.entity.SiteManagerLinkClient.Details|undefined} value
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
*/
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.setDetailsAboutClient = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.clearDetailsAboutClient = function() {
  return this.setDetailsAboutClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.hasDetailsAboutClient = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SiteManagerLinkManager.Details details_about_manager = 4;
 * @return {?proto.entity.SiteManagerLinkManager.Details}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.getDetailsAboutManager = function() {
  return /** @type{?proto.entity.SiteManagerLinkManager.Details} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLinkManager.Details, 4));
};


/**
 * @param {?proto.entity.SiteManagerLinkManager.Details|undefined} value
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
*/
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.setDetailsAboutManager = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.clearDetailsAboutManager = function() {
  return this.setDetailsAboutManager(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.hasDetailsAboutManager = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool link_to_manager_billing = 5;
 * @return {boolean}
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.getLinkToManagerBilling = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.LinkClientSiteToManagerSiteRequest} returns this
 */
proto.entity.LinkClientSiteToManagerSiteRequest.prototype.setLinkToManagerBilling = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LinkClientSiteToManagerSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LinkClientSiteToManagerSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LinkClientSiteToManagerSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LinkClientSiteToManagerSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    link: (f = msg.getLink()) && proto_entity_siteManagerLink_pb.SiteManagerLink.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LinkClientSiteToManagerSiteReply}
 */
proto.entity.LinkClientSiteToManagerSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LinkClientSiteToManagerSiteReply;
  return proto.entity.LinkClientSiteToManagerSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LinkClientSiteToManagerSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LinkClientSiteToManagerSiteReply}
 */
proto.entity.LinkClientSiteToManagerSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLink;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLink.deserializeBinaryFromReader);
      msg.setLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LinkClientSiteToManagerSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LinkClientSiteToManagerSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LinkClientSiteToManagerSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LinkClientSiteToManagerSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLink();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLink.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteManagerLink link = 1;
 * @return {?proto.entity.SiteManagerLink}
 */
proto.entity.LinkClientSiteToManagerSiteReply.prototype.getLink = function() {
  return /** @type{?proto.entity.SiteManagerLink} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLink, 1));
};


/**
 * @param {?proto.entity.SiteManagerLink|undefined} value
 * @return {!proto.entity.LinkClientSiteToManagerSiteReply} returns this
*/
proto.entity.LinkClientSiteToManagerSiteReply.prototype.setLink = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LinkClientSiteToManagerSiteReply} returns this
 */
proto.entity.LinkClientSiteToManagerSiteReply.prototype.clearLink = function() {
  return this.setLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LinkClientSiteToManagerSiteReply.prototype.hasLink = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UnlinkClientSiteFromManagerSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UnlinkClientSiteFromManagerSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    managerSiteSelector: (f = msg.getManagerSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    clientSiteSelector: (f = msg.getClientSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteRequest}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UnlinkClientSiteFromManagerSiteRequest;
  return proto.entity.UnlinkClientSiteFromManagerSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UnlinkClientSiteFromManagerSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteRequest}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setManagerSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setClientSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UnlinkClientSiteFromManagerSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UnlinkClientSiteFromManagerSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagerSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getClientSiteSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector manager_site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.getManagerSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteRequest} returns this
*/
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.setManagerSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteRequest} returns this
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.clearManagerSiteSelector = function() {
  return this.setManagerSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.hasManagerSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SiteSelector client_site_selector = 2;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.getClientSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 2));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteRequest} returns this
*/
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.setClientSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteRequest} returns this
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.clearClientSiteSelector = function() {
  return this.setClientSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UnlinkClientSiteFromManagerSiteRequest.prototype.hasClientSiteSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UnlinkClientSiteFromManagerSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UnlinkClientSiteFromManagerSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    link: (f = msg.getLink()) && proto_entity_siteManagerLink_pb.SiteManagerLink.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteReply}
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UnlinkClientSiteFromManagerSiteReply;
  return proto.entity.UnlinkClientSiteFromManagerSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UnlinkClientSiteFromManagerSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteReply}
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLink;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLink.deserializeBinaryFromReader);
      msg.setLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UnlinkClientSiteFromManagerSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UnlinkClientSiteFromManagerSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLink();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLink.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteManagerLink link = 1;
 * @return {?proto.entity.SiteManagerLink}
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.prototype.getLink = function() {
  return /** @type{?proto.entity.SiteManagerLink} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLink, 1));
};


/**
 * @param {?proto.entity.SiteManagerLink|undefined} value
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteReply} returns this
*/
proto.entity.UnlinkClientSiteFromManagerSiteReply.prototype.setLink = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UnlinkClientSiteFromManagerSiteReply} returns this
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.prototype.clearLink = function() {
  return this.setLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UnlinkClientSiteFromManagerSiteReply.prototype.hasLink = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteManagerLinkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteManagerLinkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteManagerLinkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    managerSiteSelector: (f = msg.getManagerSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    clientSiteSelector: (f = msg.getClientSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    returnDeleted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteManagerLinkRequest}
 */
proto.entity.LookupSiteManagerLinkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteManagerLinkRequest;
  return proto.entity.LookupSiteManagerLinkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteManagerLinkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteManagerLinkRequest}
 */
proto.entity.LookupSiteManagerLinkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setManagerSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setClientSiteSelector(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setReturnDeleted(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteManagerLinkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteManagerLinkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteManagerLinkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagerSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getClientSiteSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getReturnDeleted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional SiteSelector manager_site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.getManagerSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupSiteManagerLinkRequest} returns this
*/
proto.entity.LookupSiteManagerLinkRequest.prototype.setManagerSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteManagerLinkRequest} returns this
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.clearManagerSiteSelector = function() {
  return this.setManagerSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.hasManagerSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SiteSelector client_site_selector = 2;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.getClientSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 2));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.LookupSiteManagerLinkRequest} returns this
*/
proto.entity.LookupSiteManagerLinkRequest.prototype.setClientSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteManagerLinkRequest} returns this
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.clearClientSiteSelector = function() {
  return this.setClientSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.hasClientSiteSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool return_deleted = 3;
 * @return {boolean}
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.getReturnDeleted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.entity.LookupSiteManagerLinkRequest} returns this
 */
proto.entity.LookupSiteManagerLinkRequest.prototype.setReturnDeleted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.LookupSiteManagerLinkReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.LookupSiteManagerLinkReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.LookupSiteManagerLinkReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteManagerLinkReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    link: (f = msg.getLink()) && proto_entity_siteManagerLink_pb.SiteManagerLink.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.LookupSiteManagerLinkReply}
 */
proto.entity.LookupSiteManagerLinkReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.LookupSiteManagerLinkReply;
  return proto.entity.LookupSiteManagerLinkReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.LookupSiteManagerLinkReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.LookupSiteManagerLinkReply}
 */
proto.entity.LookupSiteManagerLinkReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLink;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLink.deserializeBinaryFromReader);
      msg.setLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.LookupSiteManagerLinkReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.LookupSiteManagerLinkReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.LookupSiteManagerLinkReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.LookupSiteManagerLinkReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLink();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLink.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteManagerLink link = 1;
 * @return {?proto.entity.SiteManagerLink}
 */
proto.entity.LookupSiteManagerLinkReply.prototype.getLink = function() {
  return /** @type{?proto.entity.SiteManagerLink} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLink, 1));
};


/**
 * @param {?proto.entity.SiteManagerLink|undefined} value
 * @return {!proto.entity.LookupSiteManagerLinkReply} returns this
*/
proto.entity.LookupSiteManagerLinkReply.prototype.setLink = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.LookupSiteManagerLinkReply} returns this
 */
proto.entity.LookupSiteManagerLinkReply.prototype.clearLink = function() {
  return this.setLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.LookupSiteManagerLinkReply.prototype.hasLink = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QuerySiteManagerLinksRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QuerySiteManagerLinksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QuerySiteManagerLinksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySiteManagerLinksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    managerSiteSelectorsList: jspb.Message.toObjectList(msg.getManagerSiteSelectorsList(),
    proto_entity_site_pb.SiteSelector.toObject, includeInstance),
    clientSiteSelectorsList: jspb.Message.toObjectList(msg.getClientSiteSelectorsList(),
    proto_entity_site_pb.SiteSelector.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QuerySiteManagerLinksRequest}
 */
proto.entity.QuerySiteManagerLinksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QuerySiteManagerLinksRequest;
  return proto.entity.QuerySiteManagerLinksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QuerySiteManagerLinksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QuerySiteManagerLinksRequest}
 */
proto.entity.QuerySiteManagerLinksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.addManagerSiteSelectors(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.addClientSiteSelectors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QuerySiteManagerLinksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QuerySiteManagerLinksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySiteManagerLinksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagerSiteSelectorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getClientSiteSelectorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SiteSelector manager_site_selectors = 1;
 * @return {!Array<!proto.entity.SiteSelector>}
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.getManagerSiteSelectorsList = function() {
  return /** @type{!Array<!proto.entity.SiteSelector>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {!Array<!proto.entity.SiteSelector>} value
 * @return {!proto.entity.QuerySiteManagerLinksRequest} returns this
*/
proto.entity.QuerySiteManagerLinksRequest.prototype.setManagerSiteSelectorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SiteSelector=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteSelector}
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.addManagerSiteSelectors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SiteSelector, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QuerySiteManagerLinksRequest} returns this
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.clearManagerSiteSelectorsList = function() {
  return this.setManagerSiteSelectorsList([]);
};


/**
 * repeated SiteSelector client_site_selectors = 2;
 * @return {!Array<!proto.entity.SiteSelector>}
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.getClientSiteSelectorsList = function() {
  return /** @type{!Array<!proto.entity.SiteSelector>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_site_pb.SiteSelector, 2));
};


/**
 * @param {!Array<!proto.entity.SiteSelector>} value
 * @return {!proto.entity.QuerySiteManagerLinksRequest} returns this
*/
proto.entity.QuerySiteManagerLinksRequest.prototype.setClientSiteSelectorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.entity.SiteSelector=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteSelector}
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.addClientSiteSelectors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.entity.SiteSelector, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QuerySiteManagerLinksRequest} returns this
 */
proto.entity.QuerySiteManagerLinksRequest.prototype.clearClientSiteSelectorsList = function() {
  return this.setClientSiteSelectorsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QuerySiteManagerLinksReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QuerySiteManagerLinksReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QuerySiteManagerLinksReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QuerySiteManagerLinksReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySiteManagerLinksReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    linksList: jspb.Message.toObjectList(msg.getLinksList(),
    proto_entity_siteManagerLink_pb.SiteManagerLink.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QuerySiteManagerLinksReply}
 */
proto.entity.QuerySiteManagerLinksReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QuerySiteManagerLinksReply;
  return proto.entity.QuerySiteManagerLinksReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QuerySiteManagerLinksReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QuerySiteManagerLinksReply}
 */
proto.entity.QuerySiteManagerLinksReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLink;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLink.deserializeBinaryFromReader);
      msg.addLinks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QuerySiteManagerLinksReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QuerySiteManagerLinksReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QuerySiteManagerLinksReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QuerySiteManagerLinksReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLinksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLink.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SiteManagerLink links = 1;
 * @return {!Array<!proto.entity.SiteManagerLink>}
 */
proto.entity.QuerySiteManagerLinksReply.prototype.getLinksList = function() {
  return /** @type{!Array<!proto.entity.SiteManagerLink>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLink, 1));
};


/**
 * @param {!Array<!proto.entity.SiteManagerLink>} value
 * @return {!proto.entity.QuerySiteManagerLinksReply} returns this
*/
proto.entity.QuerySiteManagerLinksReply.prototype.setLinksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SiteManagerLink=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteManagerLink}
 */
proto.entity.QuerySiteManagerLinksReply.prototype.addLinks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SiteManagerLink, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QuerySiteManagerLinksReply} returns this
 */
proto.entity.QuerySiteManagerLinksReply.prototype.clearLinksList = function() {
  return this.setLinksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteManagerLinkRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteManagerLinkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    managerSiteSelector: (f = msg.getManagerSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    clientSiteSelector: (f = msg.getClientSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f),
    action: (f = msg.getAction()) && proto.entity.UpdateSiteManagerLinkRequest.Action.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest}
 */
proto.entity.UpdateSiteManagerLinkRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteManagerLinkRequest;
  return proto.entity.UpdateSiteManagerLinkRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteManagerLinkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest}
 */
proto.entity.UpdateSiteManagerLinkRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setManagerSiteSelector(value);
      break;
    case 2:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setClientSiteSelector(value);
      break;
    case 3:
      var value = new proto.entity.UpdateSiteManagerLinkRequest.Action;
      reader.readMessage(value,proto.entity.UpdateSiteManagerLinkRequest.Action.deserializeBinaryFromReader);
      msg.setAction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteManagerLinkRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteManagerLinkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagerSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getClientSiteSelector();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.entity.UpdateSiteManagerLinkRequest.Action.serializeBinaryToWriter
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.TypeCase = {
  TYPE_NOT_SET: 0,
  UPDATE_CLIENT_LABELS: 1
};

/**
 * @return {proto.entity.UpdateSiteManagerLinkRequest.Action.TypeCase}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.prototype.getTypeCase = function() {
  return /** @type {proto.entity.UpdateSiteManagerLinkRequest.Action.TypeCase} */(jspb.Message.computeOneofCase(this, proto.entity.UpdateSiteManagerLinkRequest.Action.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteManagerLinkRequest.Action.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteManagerLinkRequest.Action} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.toObject = function(includeInstance, msg) {
  var f, obj = {
    updateClientLabels: (f = msg.getUpdateClientLabels()) && proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.Action}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteManagerLinkRequest.Action;
  return proto.entity.UpdateSiteManagerLinkRequest.Action.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteManagerLinkRequest.Action} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.Action}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels;
      reader.readMessage(value,proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.deserializeBinaryFromReader);
      msg.setUpdateClientLabels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteManagerLinkRequest.Action.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteManagerLinkRequest.Action} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpdateClientLabels();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.serializeBinaryToWriter
    );
  }
};


/**
 * optional UpdateClientLabels update_client_labels = 1;
 * @return {?proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.prototype.getUpdateClientLabels = function() {
  return /** @type{?proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels, 1));
};


/**
 * @param {?proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels|undefined} value
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.Action} returns this
*/
proto.entity.UpdateSiteManagerLinkRequest.Action.prototype.setUpdateClientLabels = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.entity.UpdateSiteManagerLinkRequest.Action.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.Action} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.prototype.clearUpdateClientLabels = function() {
  return this.setUpdateClientLabels(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteManagerLinkRequest.Action.prototype.hasUpdateClientLabels = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.toObject = function(includeInstance, msg) {
  var f, obj = {
    addLabelsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    removeLabelsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels}
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels;
  return proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels}
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addAddLabels(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addRemoveLabels(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAddLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getRemoveLabelsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string add_labels = 1;
 * @return {!Array<string>}
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.getAddLabelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.setAddLabelsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.addAddLabels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.clearAddLabelsList = function() {
  return this.setAddLabelsList([]);
};


/**
 * repeated string remove_labels = 2;
 * @return {!Array<string>}
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.getRemoveLabelsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.setRemoveLabelsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.addRemoveLabels = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.UpdateClientLabels.prototype.clearRemoveLabelsList = function() {
  return this.setRemoveLabelsList([]);
};


/**
 * optional SiteSelector manager_site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.getManagerSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateSiteManagerLinkRequest} returns this
*/
proto.entity.UpdateSiteManagerLinkRequest.prototype.setManagerSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.clearManagerSiteSelector = function() {
  return this.setManagerSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.hasManagerSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SiteSelector client_site_selector = 2;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.getClientSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 2));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.UpdateSiteManagerLinkRequest} returns this
*/
proto.entity.UpdateSiteManagerLinkRequest.prototype.setClientSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.clearClientSiteSelector = function() {
  return this.setClientSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.hasClientSiteSelector = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Action action = 3;
 * @return {?proto.entity.UpdateSiteManagerLinkRequest.Action}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.getAction = function() {
  return /** @type{?proto.entity.UpdateSiteManagerLinkRequest.Action} */ (
    jspb.Message.getWrapperField(this, proto.entity.UpdateSiteManagerLinkRequest.Action, 3));
};


/**
 * @param {?proto.entity.UpdateSiteManagerLinkRequest.Action|undefined} value
 * @return {!proto.entity.UpdateSiteManagerLinkRequest} returns this
*/
proto.entity.UpdateSiteManagerLinkRequest.prototype.setAction = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteManagerLinkRequest} returns this
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.clearAction = function() {
  return this.setAction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteManagerLinkRequest.prototype.hasAction = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.UpdateSiteManagerLinkReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.UpdateSiteManagerLinkReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.UpdateSiteManagerLinkReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    link: (f = msg.getLink()) && proto_entity_siteManagerLink_pb.SiteManagerLink.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.UpdateSiteManagerLinkReply}
 */
proto.entity.UpdateSiteManagerLinkReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.UpdateSiteManagerLinkReply;
  return proto.entity.UpdateSiteManagerLinkReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.UpdateSiteManagerLinkReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.UpdateSiteManagerLinkReply}
 */
proto.entity.UpdateSiteManagerLinkReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLink;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLink.deserializeBinaryFromReader);
      msg.setLink(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.UpdateSiteManagerLinkReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.UpdateSiteManagerLinkReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.UpdateSiteManagerLinkReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.UpdateSiteManagerLinkReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLink();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLink.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteManagerLink link = 1;
 * @return {?proto.entity.SiteManagerLink}
 */
proto.entity.UpdateSiteManagerLinkReply.prototype.getLink = function() {
  return /** @type{?proto.entity.SiteManagerLink} */ (
    jspb.Message.getWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLink, 1));
};


/**
 * @param {?proto.entity.SiteManagerLink|undefined} value
 * @return {!proto.entity.UpdateSiteManagerLinkReply} returns this
*/
proto.entity.UpdateSiteManagerLinkReply.prototype.setLink = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.UpdateSiteManagerLinkReply} returns this
 */
proto.entity.UpdateSiteManagerLinkReply.prototype.clearLink = function() {
  return this.setLink(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.UpdateSiteManagerLinkReply.prototype.hasLink = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryClientSitesForManagerSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryClientSitesForManagerSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryClientSitesForManagerSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryClientSitesForManagerSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    managerSiteSelector: (f = msg.getManagerSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryClientSitesForManagerSiteRequest}
 */
proto.entity.QueryClientSitesForManagerSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryClientSitesForManagerSiteRequest;
  return proto.entity.QueryClientSitesForManagerSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryClientSitesForManagerSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryClientSitesForManagerSiteRequest}
 */
proto.entity.QueryClientSitesForManagerSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setManagerSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryClientSitesForManagerSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryClientSitesForManagerSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryClientSitesForManagerSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryClientSitesForManagerSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagerSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector manager_site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.QueryClientSitesForManagerSiteRequest.prototype.getManagerSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.QueryClientSitesForManagerSiteRequest} returns this
*/
proto.entity.QueryClientSitesForManagerSiteRequest.prototype.setManagerSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QueryClientSitesForManagerSiteRequest} returns this
 */
proto.entity.QueryClientSitesForManagerSiteRequest.prototype.clearManagerSiteSelector = function() {
  return this.setManagerSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QueryClientSitesForManagerSiteRequest.prototype.hasManagerSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QueryClientSitesForManagerSiteReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryClientSitesForManagerSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryClientSitesForManagerSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryClientSitesForManagerSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryClientSitesForManagerSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientSitesList: jspb.Message.toObjectList(msg.getClientSitesList(),
    proto_entity_siteManagerLink_pb.SiteManagerLinkClient.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryClientSitesForManagerSiteReply}
 */
proto.entity.QueryClientSitesForManagerSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryClientSitesForManagerSiteReply;
  return proto.entity.QueryClientSitesForManagerSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryClientSitesForManagerSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryClientSitesForManagerSiteReply}
 */
proto.entity.QueryClientSitesForManagerSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLinkClient;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLinkClient.deserializeBinaryFromReader);
      msg.addClientSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryClientSitesForManagerSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryClientSitesForManagerSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryClientSitesForManagerSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryClientSitesForManagerSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLinkClient.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SiteManagerLinkClient client_sites = 1;
 * @return {!Array<!proto.entity.SiteManagerLinkClient>}
 */
proto.entity.QueryClientSitesForManagerSiteReply.prototype.getClientSitesList = function() {
  return /** @type{!Array<!proto.entity.SiteManagerLinkClient>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLinkClient, 1));
};


/**
 * @param {!Array<!proto.entity.SiteManagerLinkClient>} value
 * @return {!proto.entity.QueryClientSitesForManagerSiteReply} returns this
*/
proto.entity.QueryClientSitesForManagerSiteReply.prototype.setClientSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SiteManagerLinkClient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteManagerLinkClient}
 */
proto.entity.QueryClientSitesForManagerSiteReply.prototype.addClientSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SiteManagerLinkClient, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QueryClientSitesForManagerSiteReply} returns this
 */
proto.entity.QueryClientSitesForManagerSiteReply.prototype.clearClientSitesList = function() {
  return this.setClientSitesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryManagerSitesForClientSiteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryManagerSitesForClientSiteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryManagerSitesForClientSiteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryManagerSitesForClientSiteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientSiteSelector: (f = msg.getClientSiteSelector()) && proto_entity_site_pb.SiteSelector.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryManagerSitesForClientSiteRequest}
 */
proto.entity.QueryManagerSitesForClientSiteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryManagerSitesForClientSiteRequest;
  return proto.entity.QueryManagerSitesForClientSiteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryManagerSitesForClientSiteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryManagerSitesForClientSiteRequest}
 */
proto.entity.QueryManagerSitesForClientSiteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_site_pb.SiteSelector;
      reader.readMessage(value,proto_entity_site_pb.SiteSelector.deserializeBinaryFromReader);
      msg.setClientSiteSelector(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryManagerSitesForClientSiteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryManagerSitesForClientSiteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryManagerSitesForClientSiteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryManagerSitesForClientSiteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientSiteSelector();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_entity_site_pb.SiteSelector.serializeBinaryToWriter
    );
  }
};


/**
 * optional SiteSelector client_site_selector = 1;
 * @return {?proto.entity.SiteSelector}
 */
proto.entity.QueryManagerSitesForClientSiteRequest.prototype.getClientSiteSelector = function() {
  return /** @type{?proto.entity.SiteSelector} */ (
    jspb.Message.getWrapperField(this, proto_entity_site_pb.SiteSelector, 1));
};


/**
 * @param {?proto.entity.SiteSelector|undefined} value
 * @return {!proto.entity.QueryManagerSitesForClientSiteRequest} returns this
*/
proto.entity.QueryManagerSitesForClientSiteRequest.prototype.setClientSiteSelector = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.QueryManagerSitesForClientSiteRequest} returns this
 */
proto.entity.QueryManagerSitesForClientSiteRequest.prototype.clearClientSiteSelector = function() {
  return this.setClientSiteSelector(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.QueryManagerSitesForClientSiteRequest.prototype.hasClientSiteSelector = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.QueryManagerSitesForClientSiteReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.QueryManagerSitesForClientSiteReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.QueryManagerSitesForClientSiteReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.QueryManagerSitesForClientSiteReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryManagerSitesForClientSiteReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    managerSitesList: jspb.Message.toObjectList(msg.getManagerSitesList(),
    proto_entity_siteManagerLink_pb.SiteManagerLinkManager.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.QueryManagerSitesForClientSiteReply}
 */
proto.entity.QueryManagerSitesForClientSiteReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.QueryManagerSitesForClientSiteReply;
  return proto.entity.QueryManagerSitesForClientSiteReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.QueryManagerSitesForClientSiteReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.QueryManagerSitesForClientSiteReply}
 */
proto.entity.QueryManagerSitesForClientSiteReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_siteManagerLink_pb.SiteManagerLinkManager;
      reader.readMessage(value,proto_entity_siteManagerLink_pb.SiteManagerLinkManager.deserializeBinaryFromReader);
      msg.addManagerSites(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.QueryManagerSitesForClientSiteReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.QueryManagerSitesForClientSiteReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.QueryManagerSitesForClientSiteReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.QueryManagerSitesForClientSiteReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagerSitesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_siteManagerLink_pb.SiteManagerLinkManager.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SiteManagerLinkManager manager_sites = 1;
 * @return {!Array<!proto.entity.SiteManagerLinkManager>}
 */
proto.entity.QueryManagerSitesForClientSiteReply.prototype.getManagerSitesList = function() {
  return /** @type{!Array<!proto.entity.SiteManagerLinkManager>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_siteManagerLink_pb.SiteManagerLinkManager, 1));
};


/**
 * @param {!Array<!proto.entity.SiteManagerLinkManager>} value
 * @return {!proto.entity.QueryManagerSitesForClientSiteReply} returns this
*/
proto.entity.QueryManagerSitesForClientSiteReply.prototype.setManagerSitesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.SiteManagerLinkManager=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.SiteManagerLinkManager}
 */
proto.entity.QueryManagerSitesForClientSiteReply.prototype.addManagerSites = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.SiteManagerLinkManager, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.QueryManagerSitesForClientSiteReply} returns this
 */
proto.entity.QueryManagerSitesForClientSiteReply.prototype.clearManagerSitesList = function() {
  return this.setManagerSitesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListAuditEventsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListAuditEventsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListAuditEventsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListAuditEventsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListAuditEventsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    tableName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    dateRange: (f = msg.getDateRange()) && proto_common_datetime_pb.DateRangeV2.toObject(includeInstance, f),
    andColumnFiltersList: jspb.Message.toObjectList(msg.getAndColumnFiltersList(),
    proto_entity_audit_pb.AuditEventColumnFilter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListAuditEventsRequest}
 */
proto.entity.ListAuditEventsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListAuditEventsRequest;
  return proto.entity.ListAuditEventsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListAuditEventsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListAuditEventsRequest}
 */
proto.entity.ListAuditEventsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTableName(value);
      break;
    case 2:
      var value = new proto_common_datetime_pb.DateRangeV2;
      reader.readMessage(value,proto_common_datetime_pb.DateRangeV2.deserializeBinaryFromReader);
      msg.setDateRange(value);
      break;
    case 3:
      var value = new proto_entity_audit_pb.AuditEventColumnFilter;
      reader.readMessage(value,proto_entity_audit_pb.AuditEventColumnFilter.deserializeBinaryFromReader);
      msg.addAndColumnFilters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListAuditEventsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListAuditEventsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListAuditEventsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListAuditEventsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTableName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDateRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto_common_datetime_pb.DateRangeV2.serializeBinaryToWriter
    );
  }
  f = message.getAndColumnFiltersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_entity_audit_pb.AuditEventColumnFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string table_name = 1;
 * @return {string}
 */
proto.entity.ListAuditEventsRequest.prototype.getTableName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.ListAuditEventsRequest} returns this
 */
proto.entity.ListAuditEventsRequest.prototype.setTableName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.DateRangeV2 date_range = 2;
 * @return {?proto.common.DateRangeV2}
 */
proto.entity.ListAuditEventsRequest.prototype.getDateRange = function() {
  return /** @type{?proto.common.DateRangeV2} */ (
    jspb.Message.getWrapperField(this, proto_common_datetime_pb.DateRangeV2, 2));
};


/**
 * @param {?proto.common.DateRangeV2|undefined} value
 * @return {!proto.entity.ListAuditEventsRequest} returns this
*/
proto.entity.ListAuditEventsRequest.prototype.setDateRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.ListAuditEventsRequest} returns this
 */
proto.entity.ListAuditEventsRequest.prototype.clearDateRange = function() {
  return this.setDateRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.ListAuditEventsRequest.prototype.hasDateRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated AuditEventColumnFilter and_column_filters = 3;
 * @return {!Array<!proto.entity.AuditEventColumnFilter>}
 */
proto.entity.ListAuditEventsRequest.prototype.getAndColumnFiltersList = function() {
  return /** @type{!Array<!proto.entity.AuditEventColumnFilter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_audit_pb.AuditEventColumnFilter, 3));
};


/**
 * @param {!Array<!proto.entity.AuditEventColumnFilter>} value
 * @return {!proto.entity.ListAuditEventsRequest} returns this
*/
proto.entity.ListAuditEventsRequest.prototype.setAndColumnFiltersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.entity.AuditEventColumnFilter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AuditEventColumnFilter}
 */
proto.entity.ListAuditEventsRequest.prototype.addAndColumnFilters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.entity.AuditEventColumnFilter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListAuditEventsRequest} returns this
 */
proto.entity.ListAuditEventsRequest.prototype.clearAndColumnFiltersList = function() {
  return this.setAndColumnFiltersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.entity.ListAuditEventsReply.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.ListAuditEventsReply.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.ListAuditEventsReply.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.ListAuditEventsReply} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListAuditEventsReply.toObject = function(includeInstance, msg) {
  var f, obj = {
    auditEventsList: jspb.Message.toObjectList(msg.getAuditEventsList(),
    proto_entity_audit_pb.AuditEvent.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.ListAuditEventsReply}
 */
proto.entity.ListAuditEventsReply.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.ListAuditEventsReply;
  return proto.entity.ListAuditEventsReply.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.ListAuditEventsReply} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.ListAuditEventsReply}
 */
proto.entity.ListAuditEventsReply.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_entity_audit_pb.AuditEvent;
      reader.readMessage(value,proto_entity_audit_pb.AuditEvent.deserializeBinaryFromReader);
      msg.addAuditEvents(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.ListAuditEventsReply.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.ListAuditEventsReply.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.ListAuditEventsReply} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.ListAuditEventsReply.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAuditEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_entity_audit_pb.AuditEvent.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AuditEvent audit_events = 1;
 * @return {!Array<!proto.entity.AuditEvent>}
 */
proto.entity.ListAuditEventsReply.prototype.getAuditEventsList = function() {
  return /** @type{!Array<!proto.entity.AuditEvent>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_entity_audit_pb.AuditEvent, 1));
};


/**
 * @param {!Array<!proto.entity.AuditEvent>} value
 * @return {!proto.entity.ListAuditEventsReply} returns this
*/
proto.entity.ListAuditEventsReply.prototype.setAuditEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.entity.AuditEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.entity.AuditEvent}
 */
proto.entity.ListAuditEventsReply.prototype.addAuditEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.entity.AuditEvent, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.entity.ListAuditEventsReply} returns this
 */
proto.entity.ListAuditEventsReply.prototype.clearAuditEventsList = function() {
  return this.setAuditEventsList([]);
};


goog.object.extend(exports, proto.entity);
